import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tabs,
  Upload,
  message,
  Switch,
  InputNumber,
  Spin,
  Modal,
  Radio,
  Divider,
  notification,
  Tooltip,
} from "antd";
import {
  CompetencyRole,
  Industry,
  IndustryRole,
  NON_EMPTY_REGEX,
  STATUS_CODE,
  Sector,
  countryList,
  AwardList,
  AwardListCountryNames,
  AdditionalCertificationTypeList,
  AdditionalIndustryList,
  secondaryIndustry,
  ContractingCompany,
  AdditionalContractingCompany,
  Greetings,
  RegionalCometencyRole,
  getStatutoryFieldLabel,
  MAIN_CLIENT_ID,
} from "common/Constants";
import React, { useEffect, useMemo, useRef, useState } from "react";
import PhoneInput from "react-phone-number-input";
import styled from "@emotion/styled";
import {
  getBandList,
  getClientid,
  getLocations,
  getRoleList,
  getSupervisorList,
  getUserList,
  getChargeoutRatesList,
  getHigherOfficials,
  getCountryNameToCodeMap,
  getCountryCodeOptions,
  getGradeList,
  getIsCustomPerformanceJobDescription
} from "redux/selectors";
import { connect } from "react-redux";
import { EyeOutlined, UploadOutlined, ExclamationCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { setUserList } from "redux/actions";
import { bindActionCreators } from "redux";
import { chain, flatMap, isEmpty, filter, find, concat, get, uniqBy } from "lodash";
import TabPane from "antd/lib/tabs/TabPane";
import FormModal from "./FormModal";
import SelectTable from "../molecules/EditEmployeeRole";
import COLORS from "common/Colors";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { allowOnlyNumbers, getEmailsByRole } from "utils/functions";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import Table from "atoms/Table";
import { handleCertificationChange } from "./AddEmployee";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";
import Confirm from "../../src/assets/Confirm.svg";
import { ReactComponent as DeleteIcon } from "../assets/delete_Icon.svg";
import axios from "axios";
import dayjs from "dayjs";
import { ReactComponent as TrashDelete } from "../../src/assets/Trash_Full.svg";
import circleWarning from "../../src/assets/icons/Circle_Warning.svg";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { useScrollFetch } from "hooks/useScrollFetch";
import IdentityDocUpload, { useIdentityDocs } from "./IdentityDocUpload";
import DependantFields, {
  toFormDependants,
  toPayloadDependants,
} from "./DependantFields";

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
`;

const StyleRow = styled(Row)`
  padding: 10px;
  box-shadow: 0px 3px 6px #00000015;
  .ant-form-item-label {
    text-align: left;
  }
  .ant-upload.ant-upload-select {
    width: 100% !important;
    color: #397ff4 !important;
    .ant-btn > span {
      display: inline-block;
      color: #397ff4;
    }
    button,
    html [type="button"],
    [type="reset"],
    [type="submit"] {
      background: #f2f2f2;
    }
    /* .anticon svg {
    color: #397FF4;
} */
    .ant-upload-list-picture .ant-upload-list-item,
    .ant-upload-list-picture-card .ant-upload-list-item {
      height: 40px;
    }
    .ant-upload-list-text .ant-upload-list-item-name,
    .ant-upload-list-picture .ant-upload-list-item-name {
      color: #397ff4;
    }
  }

  .ant-checkbox.ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: #02b209 !important;
      border-color: #02b209 !important;
    }
  }
`;

const EditProfileBox = styled.div`
  .ant-tabs-nav {
    padding-left: 10px;
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }
  .small-close-modal .ant-modal-close {
    width: 20px;
    height: 20px;
  }

  .small-close-modal .ant-modal-close-x {
    font-size: 5px; /* reduce icon size */
    line-height: 20px;
  }
`;

const StyledNewModal = styled(Modal)`
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-title {
    color: #1f243b !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: left;
  }
  .ant-modal-body {
    padding: 0px 17px 30px 24px;
  }
  .ant-modal-header {
    border-bottom: none !important;
    border-radius: 40px 40px 0 0;
  }
  .ant-modal-content {
    border-radius: 10px;
    width: 600px;
  }
  .ant-modal-footer {
    border-top: none !important;
  }
  .content_style {
    color: #636980;
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }
`;

const FullWidthUpload = styled.div`
  .ant-upload.ant-upload-select {
    display: block;
    width: 100%;
  }
`;

const StyledNewTable = styled(Table)`
  .ant-table-content {
    // height: 150px;
  }
  ${'' /* .ant-table-title {
    background-color: #c2fae5;
  } */}
`;


function generateUniqueId() {
  // Generate a random number and convert it to base 36 (numbers + letters)
  const randomNumber = Math.random().toString(36).substr(2, 9);

  // Get the current timestamp
  const timestamp = Date.now();

  // Combine the random number with the timestamp
  const uniqueId = randomNumber + timestamp;

  return uniqueId;
}

const getPrimaryCountryName = (val) => {
  if (Array.isArray(val)) val = val[0];
  if (val && typeof val === "object") return val.value || val.label || "";
  return val || "";
};

const excludePrimaryCountry = (list, primary) => {
  const p = String(primary || "").trim().toLowerCase();
  return (Array.isArray(list) ? list : []).filter(
    (c) => String(c || "").trim().toLowerCase() !== p
  );
};


function EditProfile({
  updateState,
  setUpdateState,
  EmployeeDetails,
  roleList,
  ClientId,
  bandList,
  updateUserList,
  locationList,
  pageName,
  supervisorList,
  terminatePopup,
  reasonopen,
  handleReasonCancel,
  handleReasonOk,
  handleReasonChange,
  terminatedReason,
  setTeriminatePopup,
  onProfileUpdated,
}) {
  console.log("supervisorList", supervisorList);
  const masterUserList = useSelector(getUserList);
  console.log("masterUserList", masterUserList);
  const roleOptions = roleList?.filter((role) => role?.display === 1)
  const containerRef = useRef(null);
  const { Option } = Select;
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState({});
  const [showLoader, toggleLoader] = useState(false);
  const [employeeStatusId, setEmployeeStatusId] = useState("1");
  const employeesList = masterUserList?.map((user) => user.userid);
  const [activeTab, setActiveTab] = useState("0");
  const [selectedRoleId, setSelectedRoleId] = useState([]);
  const [baseLocation, setBaseLocation] = useState("");
  const [selectAllRoleChecked, setSelectAllRoleChecked] = useState(false);
  const [data, setData] = useState([]);
  const { RangePicker } = DatePicker;
  const [showOtherCertification, setShowOtherCertification] = useState(false);
  const [changeLogs, setChangeLogs] = useState([]);
  const [terminatedData, setTerminatedData] = useState({
    chargeable: [],
    non_chargeable: [],
    leave: [],
    appraisal: [],
    wfh: [],
  });
  const [loader, setLoader] = useState(false);
  const [timeSheetIdsForPost, setTimeSheetIdsForPost] = useState([]);
  const [personInchargeforPayload, setPersonInchargeforPayload] = useState({});
  const [proceedLoader, setProceedLoader] = useState(false);
  // Dedicated visibility flag for the "Changing Office Supervisor" popup.
  // Kept separate from the parent's terminatePopup/reasonopen (used by the
  // unrelated "Reason for termination" modal) so the two no longer collide.
  const [officeSupervisorPopup, setOfficeSupervisorPopup] = useState(false);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [formReady, setFormReady] = useState(false);
  const [filteredLocation, setFilteredLocation] = useState([]);
  const [managingCountry, setManagingCountry] = useState("");
  const [overrideRole, setOverrideRole] = useState(null);
  const [gradeBasedRole, setGradeBasedRole] = useState(null);
  const GradeandGradeCodes = useSelector((state) => getChargeoutRatesList(state));
  const gradeListData = useSelector(getGradeList) || [];
  const Grade = gradeListData.map((item) => item.jobgradecode);
  const higherOfficialsList = useSelector((state) => getHigherOfficials(state));
  const countryNameToCode = useSelector(getCountryNameToCodeMap);
  const countryCodeOptions = useSelector(getCountryCodeOptions);
  const isCustomJobDescription = useSelector(getIsCustomPerformanceJobDescription);
  console.log("isCustomJobDescription", isCustomJobDescription)
  const originalDesignationRef = useRef(null);
  const gradeChangedRef = useRef(false);
  const roleSyncedForUserRef = useRef(null);
  const originalGradeRef = useRef(null);                 // NEW
  const originalLastPromotionDateRef = useRef(null);     // NEW - "Last Promotion Date" field
  const originalLastPromotionLevelRef = useRef("");
  const promotionPayloadRef = useRef({
    oldpromotionallevel: "",
    servedfrom: "",
    servedto: "",
  });
  const CEO = (() => {
    const val = getEmailsByRole(higherOfficialsList, "CEO");
    return Array.isArray(val) ? val : val ? [val] : [];
  })();

  const { getRolesList } = queryKeys;
  const showClientExtras = ClientId !== MAIN_CLIENT_ID;

  const { docs: identityDocs, refresh: refreshIdentityDocs } = useIdentityDocs(
    showClientExtras ? ClientId : null,
    showClientExtras ? EmployeeDetails?.userid : null
  );

  const { key: key2, url: url2 } = getRolesList(ClientId);
  const { data: data2, lastElementRef, isLoading, refetch, isReloading } =
    useScrollFetch(key2, {
      endPoint: url2,
      queryParam: "lastEvaluatedKey",
      // onFetchStart: () => setPageLoading(true),
      // onFetchEnd: () => setPageLoading(false),
    });
  const roleListForGrade =
    data2?.pages?.flatMap(page => page?.data || []) || [];

  useEffect(() => {
    const {
      firstname,
      lastname,
      salutation,
      othernames,
      dateofbirth,
      gender,
      dependent,
      maritalstatus,
      phoneno,
      userid,
      postaladdress,
      physicaladdress,
      password,
      country,
      greetings,
      national_id,
      nationality,
      workpermitno,
      workpermitexpirydate,
      emergencycontactname,
      emergencycontactnumber,
      nextofkinrelationship,
      nextofkinpostaladdress,
      educationdetails,
      practicaltrainings,
      professionalcertifications,
      workexperience,
      accountname,
      accountno,
      bankname,
      bankbranch,
      bankcountry,
      bankcode,
      bankbranchcode,
      bankswiftcode,
      nssf,
      krapin,
      housingfundno,
      nhif,
      helpmonthlybilling,
      managingoffice,
      competencyQC,
      serviceline,
      subserviceline,
      leveldepartmentname,
      competencyrole,
      levellocationid,
      supervisor,
      companyname,
      industry,
      secondaryindustry,
      sector,
      expertise,
      industryrole,
      regionalsupervisor,
      regionalcompetencyrole,
      officesupervisor,
      engagementsupervisor,
      designation,
      grade,
      targetchargeability,
      chargeoutrate,
      lastpromotionlevel,
      lastpromotion,
      jobtitle,
      professionalsince,
      hireddate,
      employeesponser,
      employee_status,
      roleid,
      baselocationid,
      workinghoursfrom,
      workinghoursto,
      profile_url,
      employeeid,
      OfficeSupervisorId,
      RegionalSupervisorId,
      statusname,
      shiftstarttime,
      shiftendtime,
      grossSalary,
      housingAllowance,
      medicalInsurance,
      pension,
      groupLifeInsurance,
      socialSecurityContribution,
      bonus,
      otherCosts,
      totalEmploymentCost,
      appraisalInformation,
      personalemailid,
      OfficeSupervisorEmailId,
      subcluster,
      subclustercountries,
    } = EmployeeDetails;

    const mergedCertifications = professionalcertifications.reduce(
      (acc, obj) => {
        return { ...acc, ...obj }; // Merging all key-value pairs
      },
      {}
    );
    setEmployeeStatusId(EmployeeDetails?.status_id);

    if (mergedCertifications?.certificationtype === "Others") {
      setShowOtherCertification(true);
    } else {
      setShowOtherCertification(false);
    }

    setFormValues({
      full_name: `${firstname} ${lastname}`,
      password: password,
      user_id: userid,
      role_id: roleid,
      // role_name: roleNames,
      start_date: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      gender: gender,
      status_id: employeeStatusId,
      profile_url: profile_url,
      nssf: nssf,
      national_id: national_id,
      phoneno: phoneno,
      personalemailid: personalemailid,
      physicaladdress: physicaladdress,
      professionalsince: professionalsince
        ? moment(professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      employee_status: statusname,
      employeesponser: employeesponser,
      // age: agecalculte,
      maritalstatus: maritalstatus,
      country: country,
      nationality: nationality,
      companyname: companyname,
      jobtitle: jobtitle,
      dateofbirth: dateofbirth
        ? moment(moment.utc(dateofbirth).format("YYYY-MM-DD"), "YYYY-MM-DD")
        : null,
      emergencycontactname: emergencycontactname,
      emergencycontactnumber: emergencycontactnumber,
      baselocationid: baselocationid,
      employeeid: employeeid,
      firstname: firstname,
      lastname: lastname,
      salutation: salutation,
      competencyQC: competencyQC,
      serviceline: serviceline,
      subserviceline: subserviceline,
      competencyrole: competencyrole,
      industry: industry,
      sector: sector,
      industryrole: industryrole,
      expertise: expertise,
      designation: designation,
      grade: grade,
      targetchargeability: targetchargeability,
      chargeoutrate: chargeoutrate,
      greetings: greetings,
      lastpromotionlevel: lastpromotion && moment(lastpromotion, "YYYY-MM-DD").isValid()
        ? moment(lastpromotion, "YYYY-MM-DD")
        : null,
      dependent: dependent,
      managingoffice: managingoffice,
      supervisor: supervisor,
      lastpromotion: lastpromotionlevel || "",
      levellocationid: levellocationid,
      // oversight: oversight ?? false,
      secondaryindustry: secondaryindustry,
      leveldepartmentname: leveldepartmentname,
      regionalsupervisor:
        regionalsupervisor !== "none"
          ? get(
            find(supervisorList, { employeeId: RegionalSupervisorId }),
            "name",
            null
          )
          : "none",
      officesupervisor:
        OfficeSupervisorId !== "none"
          ? get(
            find(supervisorList, { employeeId: OfficeSupervisorId }),
            "name",
            null
          )
          : EmployeeDetails?.userid,
      OfficeSupervisorEmailId:
        OfficeSupervisorId !== "none"
          ? get(
            find(supervisorList, { employeeId: OfficeSupervisorId }),
            "userid",
            null
          )
          : "none",
      engagementsupervisor: get(
        find(supervisorList, { name: engagementsupervisor }),
        "name",
        null
      ),
      OfficeSupervisorId:
        OfficeSupervisorId !== "none"
          ? get(
            find(supervisorList, { employeeId: OfficeSupervisorId }),
            "employeeId",
            null
          )
          : "none",
      RegionalSupervisorId:
        regionalsupervisor !== "none"
          ? get(
            find(supervisorList, { employeeId: RegionalSupervisorId }),
            "employeeId",
            null
          )
          : "none",
      othernames: othernames,
      postaladdress: postaladdress,
      workpermitno: workpermitno,
      workpermitexpirydate: workpermitexpirydate
        ? moment(workpermitexpirydate, "YYYY-MM-DD")
        : null,
      nextofkinrelationship: nextofkinrelationship,
      nextofkinpostaladdress: nextofkinpostaladdress,
      accountno: accountno,
      accountname: accountname,
      bankname: bankname,
      bankbranch: bankbranch,
      bankcountry: bankcountry,
      bankcode: bankcode,
      bankbranchcode: bankbranchcode,
      bankswiftcode: bankswiftcode,
      krapin: krapin,
      housingfundno: housingfundno,
      nhif: nhif,
      helpmonthlybilling: helpmonthlybilling,
      shiftstarttime: shiftstarttime,
      shiftendtime: shiftendtime,
      regionalcompetencyrole: regionalcompetencyrole,
      educationdetails:
        educationdetails?.length !== 0
          ? educationdetails
          : [
            {
              institutename: "",
              fromdate: "",
              todate: "",
              exambody: "",
              awarded: "",
            },
          ],
      workexperience:
        workexperience?.length !== 0
          ? workexperience
          : [
            {
              companyname: "",
              fromdate: "",
              todate: "",
              jobtitle: "",
              relevnt: "",
              jobdescription: "",
            },
          ],
      professionalcertifications:
        professionalcertifications?.length !== 0
          ? professionalcertifications
          : [
            {
              certificationtype: "",
              certificationname: "",
              fromdate: "",
              todate: "",
              remarks: "",
            },
          ],
      practicaltrainings:
        practicaltrainings.length !== 0
          ? [
            {
              certificationname: mergedCertifications.certificationname || "",
              certificationtype: mergedCertifications.certificationtype || "",
              fromdate: mergedCertifications.fromdate || "",
              remarks: mergedCertifications.remarks || "",
              todate: mergedCertifications.todate || "",
            },
          ]
          : [
            {
              organisationname: "",
              fromdate: "",
              todate: "",
              positionheld: "",
              tasksperformed: "",
            },
          ],
      grossSalary,
      housingAllowance,
      medicalInsurance,
      pension,
      groupLifeInsurance,
      socialSecurityContribution,
      bonus,
      otherCosts,
      totalEmploymentCost,
      subCluster: subcluster || false,
      subClusterList: subclustercountries || [],
    });
    const transformedDetails = (data) =>
      data?.map((item) => {
        const { fromdate, todate, ...rest } = item;
        const formattedFromDate = fromdate ? moment(fromdate) : null;
        const formattedToDate = todate ? moment(todate) : null;
        return {
          ...rest,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        };
      });

    const matchedRole = roleOptions.find((role) => role.roleId === roleid);
    form.setFieldsValue({
      full_name: `${firstname} ${lastname}`,
      password: password,
      user_id: userid,
      roleId: Array.isArray(roleid) ? roleid[0] : roleid,
      ...(showClientExtras && {
        dependentdetails: toFormDependants(EmployeeDetails?.dependentdetails),
      }),
      // role_name: roleNames,
      start_date: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      gender: gender,
      status_id: employeeStatusId,
      profile_url: profile_url,
      nssf: nssf,
      national_id: national_id,
      phoneno: phoneno,
      personalemailid: personalemailid,
      physicaladdress: physicaladdress,
      professionalsince: professionalsince
        ? moment(professionalsince, "YYYY-MM-DD")
        : null,
      hireddate: hireddate ? moment(hireddate, "YYYY-MM-DD") : null,
      employee_status: statusname,
      employeesponser: employeesponser,
      // age: agecalculte,
      maritalstatus: maritalstatus,
      country: country,
      nationality: nationality,
      companyname: companyname,
      jobtitle: jobtitle,
      dateofbirth: dateofbirth
        ? moment(moment.utc(dateofbirth).format("YYYY-MM-DD"), "YYYY-MM-DD")
        : null,
      emergencycontactname: emergencycontactname,
      emergencycontactnumber: emergencycontactnumber,
      baselocationid: baselocationid,
      employeeid: employeeid,
      firstname: firstname,
      lastname: lastname,
      salutation: salutation,
      competencyQC: competencyQC,
      serviceline: serviceline,
      subserviceline: subserviceline,
      competencyrole: competencyrole,
      industry: industry,
      sector: sector,
      industryrole: industryrole,
      expertise: expertise,
      designation: designation,
      grade: grade,
      targetchargeability: targetchargeability,
      chargeoutrate: chargeoutrate,
      greetings: greetings,
      lastpromotionlevel: lastpromotion && moment(lastpromotion, "YYYY-MM-DD").isValid()
        ? moment(lastpromotion, "YYYY-MM-DD")
        : null,
      dependent: dependent,
      managingoffice: managingoffice,
      supervisor: get(
        find(supervisorList, { employeeId: supervisor }),
        "name",
        null
      ),
      lastpromotion: lastpromotionlevel || "",
      levellocationid: levellocationid,
      // oversight: oversight,
      secondaryindustry: secondaryindustry,
      leveldepartmentname: leveldepartmentname,
      regionalsupervisor:
        regionalsupervisor !== "none"
          ? get(
            find(supervisorList, { employeeId: RegionalSupervisorId }),
            "employeeId",
            null
          )
          : "none",
      officesupervisor:
        officesupervisor !== "none"
          ? get(
            find(supervisorList, { employeeId: OfficeSupervisorId }),
            "employeeId",
            null
          )
          : EmployeeDetails?.employeeid,
      engagementsupervisor: get(
        find(supervisorList, { name: engagementsupervisor }),
        "employeeId",
        null
      ),
      OfficeSupervisorId:
        officesupervisor !== "none"
          ? get(
            find(supervisorList, { employeeId: OfficeSupervisorId }),
            "employeeId",
            null
          )
          : "none",
      RegionalSupervisorId:
        regionalsupervisor !== "none"
          ? get(
            find(supervisorList, { employeeId: RegionalSupervisorId }),
            "employeeId",
            null
          )
          : "none",
      othernames: othernames,
      postaladdress: postaladdress,
      workpermitno: workpermitno,
      workpermitexpirydate: workpermitexpirydate
        ? moment(workpermitexpirydate, "YYYY-MM-DD")
        : null,
      nextofkinrelationship: nextofkinrelationship,
      nextofkinpostaladdress: nextofkinpostaladdress,
      accountno: accountno,
      accountname: accountname,
      bankname: bankname,
      bankbranch: bankbranch,
      bankcountry: bankcountry,
      bankcode: bankcode,
      bankbranchcode: bankbranchcode,
      bankswiftcode: bankswiftcode,
      krapin: krapin,
      housingfundno: housingfundno,
      nhif: nhif,
      helpmonthlybilling: helpmonthlybilling,
      // workinghoursfrom: moment.utc(workinghoursfrom).format("hh:mm:ss"),
      // workinghoursto: moment.utc(workinghoursto).format("hh:mm:ss"),
      regionalcompetencyrole: regionalcompetencyrole,
      educationdetails:
        educationdetails?.length !== 0
          ? transformedDetails(educationdetails)
          : [
            {
              institutename: "",
              fromdate: "",
              todate: "",
              exambody: "",
              awarded: "",
            },
          ],
      workexperience:
        workexperience?.length !== 0
          ? transformedDetails(workexperience)
          : [
            {
              companyname: "",
              fromdate: "",
              todate: "",
              jobtitle: "",
              relevnt: "",
              jobdescription: "",
            },
          ],
      professionalcertifications:
        professionalcertifications?.length !== 0
          ? transformedDetails(professionalcertifications)
          : [
            {
              certificationtype: "",
              certificationname: "",
              fromdate: "",
              todate: "",
              remarks: "",
            },
          ],
      practicaltrainings:
        practicaltrainings.length !== 0
          ? transformedDetails(practicaltrainings)
          : [
            {
              organisationname: "",
              fromdate: "",
              todate: "",
              positionheld: "",
              tasksperformed: "",
            },
          ],
      grossSalary,
      housingAllowance,
      medicalInsurance,
      pension,
      groupLifeInsurance,
      socialSecurityContribution,
      bonus,
      otherCosts,
      totalEmploymentCost,
      subCluster: subcluster || false,
    });
    const primaryOnLoad = getPrimaryCountryName(managingoffice);

    setTimeout(() => {
      form.setFieldsValue({
        // Base/managing office country is never shown in Sub Cluster Countries
        subClusterList: excludePrimaryCountry(subclustercountries, primaryOnLoad),
      });
    }, 0);
    originalGradeRef.current = grade;
    roleSyncedForUserRef.current = null;
    originalLastPromotionDateRef.current =
      lastpromotion && moment(lastpromotion, "YYYY-MM-DD").isValid()
        ? moment(lastpromotion, "YYYY-MM-DD")
        : null;
    originalLastPromotionLevelRef.current = lastpromotionlevel || "";

    setData(appraisalInformation);
    setIsInitialized(true);
    setFormReady(true);
    setTimeout(() => {
      setInitialLoaded(true);
    }, 200);
  }, [EmployeeDetails]);


  const validateEmployeeId = (rule, value) => {
    if (EmployeeDetails?.userid === value) {
      return Promise.resolve();
    } else if (value && employeesList.includes(value)) {
      return Promise.reject("User ID already exist");
    }
    return Promise.resolve();
  };

  const onFinish = () => {
    if (updateState === "salaryInfo") {
      calculateTotal();
    }
    const currentFormValues = form.getFieldValue();
    const updatedFormValues = {
      ...currentFormValues,
      selectedRoleId,
    };

    setFormValues(updatedFormValues);
  };

  const uploadFile = async (value) => {
    const { file } = value;
    try {
      if (!isEmpty(file)) {
        await CALL_API(`upload-userdocuments/${ClientId}`, "post", {
          userId: EmployeeDetails?.userid,
          name: file.name,
          type: file.type,
          uniqueId: file.response.uniqueId,
          content: file.response.base64Data,
        });
      }
    } catch (error) {
      console.error("[handlesubmit] error --->", error);
    }
  };

  // After an edit/update, refresh just the edited person via
  // getuserbyid?clientid=&userid= instead of re-pulling the whole roster
  // through master-data/user-list/{clientid}.
  const fetchMasterData = async () => {
    const result = await CALL_API(
      `getuserbyid?clientid=${ClientId}&userid=${EmployeeDetails?.userid}`,
      "get"
    );
    if (result?.code === STATUS_CODE.SUCCESS && result?.response) {
      const updatedUser = result.response;
      updateUserList(
        (masterUserList || []).map((user) =>
          user.userid === updatedUser.userid
            ? { ...user, ...updatedUser }
            : user
        )
      );
    }
  };

  const handlesubmit = async () => {
    try {
      if (handleValidation() && validateTotalWeightage()) {
        const missingPrimaryJobDescriptions = data?.filter((row) => {
          const hasFile = !!row?.jobDescriptionId;
          return !hasFile; // keep only rows missing job descriptions
        });

        if (missingPrimaryJobDescriptions?.length > 0) {
          message.error(
            "Please add a Job Description for all roles before proceeding."
          );
          return; // ✅ Block going forward
        }

        toggleLoader(true);

        const {
          firstname,
          lastname,
          salutation,
          othernames,
          dateofbirth,
          gender,
          dependent,
          maritalstatus,
          phoneno,
          user_id,
          postaladdress,
          physicaladdress,
          country,
          greetings,
          national_id,
          nationality,
          workpermitno,
          workpermitexpirydate,
          emergencycontactname,
          emergencycontactnumber,
          nextofkinrelationship,
          nextofkinpostaladdress,
          educationdetails,
          practicaltrainings,
          professionalcertifications,
          workexperience,
          accountname,
          accountno,
          bankname,
          bankbranch,
          bankcountry,
          bankcode,
          bankbranchcode,
          bankswiftcode,
          nssf,
          krapin,
          housingfundno,
          nhif,
          helpmonthlybilling,
          managingoffice,
          competencyQC,
          serviceline,
          subserviceline,
          leveldepartmentname,
          competencyrole,
          levellocationid,
          supervisor,
          companyname,
          industry,
          secondaryIndustry,
          sector,
          expertise,
          industryrole,
          regionalsupervisor,
          regionalcompetencyrole,
          officesupervisor,
          engagementsupervisor,
          designation,
          grade,
          targetchargeability,
          chargeoutrate,
          lastpromotionlevel,
          lastpromotion,
          jobtitle,
          professionalsince,
          hireddate,
          employeesponser,
          employee_status,
          roleId,
          baselocationid,
          employeeid,
          grossSalary,
          housingAllowance,
          medicalInsurance,
          pension,
          groupLifeInsurance,
          socialSecurityContribution,
          bonus,
          otherCosts,
          personalemailid,
          OfficeSupervisorId,
        } = formValues;
        const baseLocationId =
          form.getFieldValue("baselocationid") ||
          baseLocation ||
          baselocationid ||
          levellocationid ||
          "";

        const totalEmploymentCost = form.getFieldValue("totalEmploymentCost");
        const personalEmailId = form.getFieldValue("personalemailid");

        const workexperienceDetails = workexperience
          ?.filter((item) => {
            const {
              companyname,
              fromdate,
              todate,
              jobtitle,
              relevnt,
              jobdescription,
            } = item;
            return (
              companyname?.trim() !== "" ||
              companyname === null ||
              companyname === undefined ||
              fromdate !== "" ||
              fromdate === null ||
              fromdate === undefined ||
              todate !== "" ||
              todate === null ||
              todate === undefined ||
              jobtitle?.trim() !== "" ||
              jobtitle === null ||
              jobtitle === undefined ||
              relevnt?.trim() !== "" ||
              relevnt === null ||
              relevnt === undefined ||
              jobdescription?.trim() !== "" ||
              jobdescription === null ||
              jobdescription === undefined
            );
          })
          .map((item) => {
            const { fromdate, todate, ...rest } = item;
            const formattedFromDate = fromdate
              ? moment(fromdate).format("YYYY-MM-DD")
              : null;
            const formattedToDate = todate
              ? moment(todate).format("YYYY-MM-DD")
              : null;
            return {
              ...rest,
              fromdate: formattedFromDate,
              todate: formattedToDate,
            };
          });

        const transformedEducationDetails = educationdetails
          ?.filter((item) => {
            const { institutename, fromdate, todate, exambody, awarded } = item;
            return (
              institutename?.trim() !== "" ||
              institutename === null ||
              institutename === undefined ||
              fromdate !== "" ||
              fromdate === null ||
              fromdate === undefined ||
              todate !== "" ||
              todate === null ||
              todate === undefined ||
              exambody?.trim() !== "" ||
              exambody === null ||
              exambody === undefined ||
              awarded?.trim() !== "" ||
              awarded === null ||
              awarded === undefined
            );
          })
          .map((item) => {
            const { attachment, fromdate, todate, ...rest } = item;
            const formattedFromDate = fromdate
              ? moment(fromdate).format("YYYY-MM-DD")
              : null;
            const formattedToDate = todate
              ? moment(todate).format("YYYY-MM-DD")
              : null;
            const updatedAttachment = attachment?.map((att) => ({
              name: att?.name,
              uniqueId: att?.response?.uniqueId
                ? att?.response?.uniqueId
                : att?.uniqueId,
            }));
            return {
              ...rest,
              fromdate: formattedFromDate,
              todate: formattedToDate,
              attachment: updatedAttachment,
            };
          });

        const practicaltrainingsDetails = practicaltrainings
          ?.filter((item) => {
            const {
              organisationname,
              fromdate,
              todate,
              positionheld,
              tasksperformed,
            } = item;
            return (
              organisationname?.trim() !== "" ||
              organisationname === null ||
              organisationname === undefined ||
              fromdate !== "" ||
              fromdate === null ||
              fromdate === undefined ||
              todate !== "" ||
              todate === null ||
              todate === undefined ||
              positionheld?.trim() !== "" ||
              positionheld === null ||
              positionheld === undefined ||
              tasksperformed?.trim() !== "" ||
              tasksperformed === null ||
              tasksperformed === undefined
            );
          })
          .map((item) => {
            const { fromdate, todate, ...rest } = item;
            const formattedFromDate = fromdate
              ? moment(fromdate).format("YYYY-MM-DD")
              : null;
            const formattedToDate = todate
              ? moment(todate).format("YYYY-MM-DD")
              : null;
            return {
              ...rest,
              fromdate: formattedFromDate,
              todate: formattedToDate,
            };
          });

        const professionalcertificationsDetails = professionalcertifications
          ?.filter((item) => {
            const {
              certificationtype,
              certificationname,
              fromdate,
              todate,
              remarks,
            } = item;
            // Check if all fields are empty
            return (
              certificationtype?.trim() !== "" ||
              certificationtype === null ||
              certificationtype === undefined ||
              certificationname?.trim() !== "" ||
              certificationname === null ||
              certificationname === undefined ||
              fromdate !== "" ||
              fromdate === null ||
              fromdate === undefined ||
              todate !== "" ||
              todate === null ||
              todate === undefined ||
              remarks?.trim() !== "" ||
              remarks === null ||
              remarks === undefined
            );
          })
          .map((item) => {
            const { attachment, fromdate, todate, ...rest } = item;
            const formattedFromDate = fromdate
              ? moment(fromdate).format("YYYY-MM-DD")
              : null;
            const formattedToDate = todate
              ? moment(todate).format("YYYY-MM-DD")
              : null;
            const updatedAttachment = attachment?.map((att) => ({
              name: att?.name,
              uniqueId: att?.response?.uniqueId
                ? att?.response?.uniqueId
                : att?.uniqueId,
            }));
            return {
              ...rest,
              fromdate: formattedFromDate,
              todate: formattedToDate,
              attachment: updatedAttachment,
            };
          });



        const currentRoleId = form.getFieldValue("roleId") || roleId;
        const selectedRole = roleList.find((item) => item.roleId === currentRoleId) ||
          roleList.find((item) => item.roleName === currentRoleId);
        const roleIds = selectedRole ? [selectedRole.roleId] : [];
        const roleNames = selectedRole ? [selectedRole.roleName] : [];

        const dobDate = new Date(dateofbirth);
        const currentDate = new Date();
        const agecalculte = currentDate.getFullYear() - dobDate.getFullYear();

        const primaryRow = (data || []).find(
          (row) => row.roletype === "Primary"
        );
        const previousAreaOfWork =
          EmployeeDetails?.appraisalInformation?.find(
            (row) => row.roletype === "Primary"
          )?.areaofwork || "";
        const currentAreaOfWork = primaryRow?.areaofwork || "";
        const selectedRoleType = primaryRow?.roletype || "";
        let officeSupervisorUserId = "";
        if (primaryRow?.appraiser) {
          const supervisorUser = masterUserList?.find(
            (user) => user.employeeid === primaryRow.appraiser
          );
          officeSupervisorUserId = supervisorUser?.userid || "";
        }

        const numberedData = data.map((row, idx) => ({
          ...row,
          key: idx + 1, // Set key as row number (starting from 1)
        }));

        const normalizeCountry = (value) => {
          if (!value) return [];
          if (Array.isArray(value)) {
            return Array.isArray(value[0]) ? value[0] : value;
          }
          return [value];
        };
        const payloadData = {
          full_name: `${firstname} ${lastname}`,
          employeeid: employeeid,
          user_id: user_id,
          role_id: roleIds,
          role_name: roleNames,
          profile_url: EmployeeDetails?.profile_url,
          start_date: hireddate
            ? moment(hireddate._d).format("YYYY-MM-DD")
            : "",
          gender: gender,
          status_id: employeeStatusId,
          nssf: nssf,
          national_id: national_id,
          phoneno: phoneno,
          personalemailid: personalEmailId,
          physicaladdress: physicaladdress,
          professionalsince: professionalsince
            ? moment(professionalsince._d).format("YYYY-MM-DD")
            : "",
          hireddate: hireddate ? moment(hireddate._d).format("YYYY-MM-DD") : "",
          statusname: employee_status,
          employeesponser: employeesponser,
          age: agecalculte,
          maritalstatus: maritalstatus,
          country: country,
          nationality: nationality,
          companyname: companyname,
          jobtitle: jobtitle,
          dateofbirth: dateofbirth
            ? moment.utc(dateofbirth.format("YYYY-MM-DD"), "YYYY-MM-DD").toISOString()
            : "",
          emergencycontactname: emergencycontactname,
          emergencycontactnumber: emergencycontactnumber,
          baselocationid: baseLocationId,
          firstname: firstname,
          lastname: lastname,
          salutation: salutation,
          competencyQC: Array.isArray(competencyQC)
            ? competencyQC
            : competencyQC
              ? [competencyQC]
              : [],
          serviceline: serviceline,
          subserviceline: subserviceline,
          competencyrole: competencyrole,
          industry: industry,
          sector: sector,
          industryrole: industryrole,
          expertise: expertise,
          designation: designation,
          grade: grade,
          targetchargeability: targetchargeability,
          chargeoutrate: chargeoutrate,
          greetings: greetings,
          lastpromotionlevel: lastpromotion,
          dependent: dependent,
          educationdetails: transformedEducationDetails,
          ...(showClientExtras && { dependentdetails: toPayloadDependants(form) }),
          workexperience: workexperienceDetails,
          professionalcertifications: professionalcertificationsDetails,
          practicaltrainings: practicaltrainingsDetails,
          managingoffice: normalizeCountry(managingoffice),
          supervisor: get(
            find(supervisorList, { employeeId: supervisor }),
            "name",
            null
          ),
          lastpromotion: lastpromotionlevel
            ? moment(lastpromotionlevel._d).format("YYYY-MM-DD")
            : "",
          levellocationid: levellocationid,
          secondaryindustry: secondaryIndustry,
          leveldepartmentname: leveldepartmentname,
          regionalsupervisor:
            regionalsupervisor !== "none"
              ? get(
                find(supervisorList, { employeeId: regionalsupervisor }),
                "name",
                null
              )
              : "none",
          officesupervisor:
            OfficeSupervisorId === "EA-RW-88"
              ? "none"
              : officesupervisor !== "none"
                ? get(
                  find(supervisorList, {
                    employeeId: form.getFieldValue("officesupervisor"),
                  }),
                  "name",
                  null
                )
                : "none",
          OfficeSupervisorEmailId:
            OfficeSupervisorId === "EA-RW-88"
              ? "none"
              : officesupervisor !== "none"
                ? get(
                  find(supervisorList, {
                    employeeId: form.getFieldValue("officesupervisor"),
                  }),
                  "userid",
                  null
                )
                : "none",
          engagementsupervisor: get(
            find(supervisorList, { employeeId: engagementsupervisor }),
            "name",
            null
          ),
          OfficeSupervisorId: form.getFieldValue("officesupervisor"),
          RegionalSupervisorId: regionalsupervisor,
          othernames: othernames,
          postaladdress: postaladdress,
          workpermitno: workpermitno,
          workpermitexpirydate: workpermitexpirydate
            ? moment(workpermitexpirydate._d).format("YYYY-MM-DD")
            : "",
          nextofkinrelationship: nextofkinrelationship,
          nextofkinpostaladdress: nextofkinpostaladdress,
          accountno: accountno,
          accountname: accountname,
          bankname: bankname,
          bankbranch: bankbranch,
          bankcountry: bankcountry,
          bankcode: bankcode,
          bankbranchcode: bankbranchcode,
          bankswiftcode: bankswiftcode,
          krapin: krapin,
          housingfundno: housingfundno,
          nhif: nhif,
          helpmonthlybilling: helpmonthlybilling,
          shiftstarttime: EmployeeDetails?.shiftstarttime,
          shiftendtime: EmployeeDetails?.shiftendtime,
          regionalcompetencyrole: regionalcompetencyrole,
          grossSalary,
          housingAllowance,
          medicalInsurance,
          pension,
          groupLifeInsurance,
          socialSecurityContribution,
          bonus,
          otherCosts,
          totalEmploymentCost,
          appraisalInformation: numberedData,
          appraisalmethod: "editappraisal",
          appraisalChanges: changeLogs, // optional
          subcluster: form.getFieldValue("subCluster") || false,
          subclustercountries: form.getFieldValue("subClusterList") || [],
          isgradeeditable: gradeChangedRef.current,
          //   oldpromotionallevel: gradeChangedRef.current
          //     ? promotionPayloadRef.current.oldpromotionallevel
          //     : "",
          servedfrom: gradeChangedRef.current
            ? promotionPayloadRef.current.servedfrom
            : "",
          servedto: gradeChangedRef.current
            ? promotionPayloadRef.current.servedto
            : "",
          updatedby: userInfo?.userid || "",
        };

        const response = await CALL_API(
          `add-users/${ClientId}`,
          "patch",
          payloadData
        );

        toggleLoader(false);
        //   setFileName("");
        form.resetFields();
        //   closeModal(true);

        if (response.code === "SUCCESS") {
          if (response?.message === "Please Upgrade Your Plan") {
            message.error(response?.message);
          } else {
            message.success(response?.message);
            setUpdateState("");
          }
        }
        setUpdateState("");
        //   await getEmployeeList();
        await fetchMasterData();
        if (typeof onProfileUpdated === "function") {
          await onProfileUpdated();
        }
        if (response.code === "SUCCESS") {

          const oldLocations = filteredLocation;
          const newLocations = levellocationid;
          const newlyAddedLocations = filteredLocation.some(loc => loc.location_id === levellocationid);
          if (newlyAddedLocations.length === 0) {
            console.warn("No new locations added. Only updating category details.");
          } else {
            const secondPayload = {
              clientid: ClientId,
              userId: EmployeeDetails?.userid,
              baselocationId: baseLocationId,
            };
            const secondResponse = await CALL_API(
              `add-users/${ClientId}?updateleave=true`,
              "post",
              secondPayload
            );
            if (secondResponse.code === STATUS_CODE.SUCCESS) {
              message.success("Leave updated successfully");
            } else {
              // message.warning("Leave updated, but allocation update failed");
            }
          }
          if (response?.message === "Please Upgrade Your Plan") {
            message.error(response?.message);
          } else {
            // message.success(response?.message);
            setUpdateState("");
          }
        }
      }
    } catch (error) {
      message.error("Something went wrong");
      toggleLoader(false);
      console.error("[handlesubmit] error --->", error);
    }
  };

  const onCancel = () => {
    if (isHistory) {
      setIsHistory(false);
    }
    setIsModalVisible(false);
  };

  const handleHistoryClick = async () => {
    setHistoryLoading(true);
    setIsHistory(true);
    setIsModalVisible(true);

    try {
      const editingUserId = EmployeeDetails?.userid;
      if (!editingUserId) {
        message.error("User ID not found for this employee");
        setHistoryLoading(false);
        return;
      }

      const response = await CALL_API(
        `appraisal/appraisalhisorty?userid=${editingUserId}`,
        "get"
      );
      const historyList =
        [...response?.historyList].sort(
          (a, b) => new Date(b.modifiedat) - new Date(a.modifiedat)
        ) || [];
      setHistoryData(
        historyList.map((item, idx) => ({
          key: item.id || idx,
          roleType: item.roletype,
          change: item.change,
          modifiedBy: item.modifiedby,
          modifiedAt: item.modifiedat,
        }))
      );
      setFilteredHistoryData(
        historyList.map((item, idx) => ({
          key: item.id || idx,
          roleType: item.roletype,
          change: item.change,
          modifiedBy: item.modifiedby,
          modifiedAt: item.modifiedat,
        }))
      );
    } catch (error) {
      message.error("Failed to fetch history");
      setHistoryData([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const [managingOfficeData, setManagingOfficeData] = useState([]);
  const [organisationLevelData, setOrganisationLevelData] = useState([]);
  const [competencyQCData, setCompetencyQCfetchData] = useState([]);
  const [servicelineData, setServicelinefetchData] = useState([]);
  const [subservicelineData, setsubservicelineData] = useState([]);
  const [competencyroleData, setcompetencyroleData] = useState([]);
  const [departmentLevelData, setDepartmentLevelData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyDatas, setHistoryData] = useState([]);
  const [isHistory, setIsHistory] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [currentRoleRecord, setCurrentRoleRecord] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [filteredJobDescriptions, setFilteredJobDescriptions] = useState([]);
  const [addedJobDescriptions, setAddedJobDescriptions] = useState({});
  const [addLoadingRow, setAddLoadingRow] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const userInfo = useSelector((store) => get(store, "common.userInfo"));
  const [gradeMap, setGradeMap] = useState({});
  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [isHistoryModalVisible, setHistoryModalVisible] = useState(false);
  const [historyDateRange, setHistoryDateRange] = useState([]);
  const [filteredHistoryData, setFilteredHistoryData] = useState([]);
  const [otherFileList, setOtherFileList] = useState([]);
  const [loadingnew, setViewLoadingnew] = useState([]);
  const [isCustomJdModalVisible, setIsCustomJdModalVisible] = useState(false);
  const [customJdFileList, setCustomJdFileList] = useState([]);
  const [customJdSaving, setCustomJdSaving] = useState(false);
  const [customJdForm] = Form.useForm();
  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  const fetchData = async () => {
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level1`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setManagingOfficeData(result);
    }
  };

  const selectedCountry = Form.useWatch("managingoffice", form);
  const subClusterEnabled = Form.useWatch("subCluster", form);
  const selectedSubClusters = Form.useWatch("subClusterList", form) || [];
  const selectedSupervisorId = Form.useWatch("officesupervisor", form);

  useEffect(() => {
    if (EmployeeDetails && locationList?.length > 0) {
      const { managingoffice, levellocationid } = EmployeeDetails;

      const selectedOffice = selectedCountry
        ? (Array.isArray(selectedCountry) ? selectedCountry[0] : selectedCountry)
        : (Array.isArray(managingoffice) ? managingoffice[0] : managingoffice);

      const filtered = locationList.filter(
        (item) =>
          item.login_from_anywhere !== 1 &&
          item.country === selectedOffice
      );
      setFilteredLocation(filtered);

      if (selectedCountry) {
        if (filtered.length > 0) {
          const newLocationId = filtered[0].location_id;
          form.setFieldsValue({ levellocationid: newLocationId });
          form.setFieldValue("baselocationid", newLocationId);
          setFormValues((prev) => ({
            ...prev,
            levellocationid: newLocationId,
            baselocationid: newLocationId,
          }));
          setBaseLocation(newLocationId);
        } else {
          form.setFieldsValue({ levellocationid: undefined });
          form.setFieldValue("baselocationid", undefined);
          setFormValues((prev) => ({
            ...prev,
            levellocationid: undefined,
            baselocationid: undefined,
          }));
          setBaseLocation("");
        }
        return;
      }

      if (levellocationid && filtered.length > 0) {
        const matchedLocation = filtered.find(
          (loc) => String(loc.location_id) === String(levellocationid)
        );
        const resolvedId = matchedLocation
          ? matchedLocation.location_id
          : filtered[0].location_id;

        form.setFieldsValue({ levellocationid: resolvedId });
        setBaseLocation(resolvedId);
      }
    }
  }, [EmployeeDetails, locationList, selectedCountry]);

  const normalizeCountry = (val) => {
    if (!val) return "";
    if (Array.isArray(val)) val = val[0];
    if (typeof val === "object") return val.value || val.label || "";
    return val;
  };

  const primaryCountry = normalizeCountry(selectedCountry);
  const loggedInCountry = userInfo?.managingoffice?.[0];

  const allowedCountries = React.useMemo(() => {
    if (primaryCountry === "Head Office") return ["Head Office"];
    const base = primaryCountry || loggedInCountry;
    const subClusters = subClusterEnabled
      ? selectedSubClusters.map(normalizeCountry)
      : [];
    return [...new Set([base, ...subClusters].filter(Boolean))];
  }, [primaryCountry, loggedInCountry, subClusterEnabled, selectedSubClusters]);

  const officeSupervisorOptions = React.useMemo(() => {
    if (!supervisorList?.length) return [];
    if (allowedCountries.includes("Head Office")) {
      return supervisorList;
    }
    let filtered = supervisorList.filter((sup) => {
      // const empCountryCode = sup.employeeId
      //   ?.split("-")?.[1]
      //   ?.toUpperCase();

      // const empFullCountry = empCountryCode ? countryNameToCode[empCountryCode] : null;

      // const countryMatch = empCountryCode && allowedCountries.some((c) => {
      //   const upperC = c.toUpperCase();
      //   if (upperC.startsWith(empCountryCode)) return true;
      //   if (empFullCountry && c === empFullCountry) return true;
      //   return false;
      // });

      const userDetails = masterUserList?.find(
        (u) => u.userid === sup.userid && u.statusid === "1"
      );
      const useridCountryMatch = userDetails?.managingoffice?.some((office) =>
        allowedCountries.includes(office)
      );
      const subClusterMatch =
        userDetails?.subcluster === true &&
        userDetails?.subclustercountries?.some((c) =>
          allowedCountries.includes(c)
        );

      return useridCountryMatch || subClusterMatch;
    });
    const editedEmployeeId =
      EmployeeDetails?.employeeid || EmployeeDetails?.employeeId;
    filtered = filtered.filter((sup) => sup.employeeId !== editedEmployeeId);
    if (selectedSupervisorId) {
      const selected = supervisorList.find((s) => s.employeeId === selectedSupervisorId);
      if (selected && !filtered.some((f) => f.employeeId === selectedSupervisorId)) {
        filtered = [selected, ...filtered];
      }
    }
    // No supervisor is assigned (officesupervisorid is "none"): the field is
    // disabled, but still needs an option so the Select can display the
    // employee's own name instead of rendering blank for an unmatched value.
    // The option value must match what form.setFieldsValue actually stores
    // for "officesupervisor" in this case (the employee's own id) so the
    // submitted payload is unaffected by this display-only fix.
    if (EmployeeDetails?.OfficeSupervisorId === "none") {
      const ownFullName = `${EmployeeDetails?.firstname || ""} ${EmployeeDetails?.lastname || ""}`.trim();
      if (ownFullName && editedEmployeeId) {
        filtered = [{ name: ownFullName, employeeId: editedEmployeeId }, ...filtered];
      }
    }
    console.log("filtered", filtered)
    return filtered;
  }, [supervisorList, masterUserList, allowedCountries, selectedSupervisorId, EmployeeDetails,]);

  console.log("officeSupervisorOptions", officeSupervisorOptions)

  useEffect(() => {
    if (!subClusterEnabled) return;
    if (!primaryCountry || primaryCountry === "Head Office") return;

    // Keep the base/managing office country out of Sub Cluster Countries
    const existing = form.getFieldValue("subClusterList") || [];
    if (existing.includes(primaryCountry)) {
      form.setFieldValue("subClusterList", existing.filter((c) => c !== primaryCountry));
    }
  }, [primaryCountry, subClusterEnabled, form]);



  useEffect(() => {
    if (!initialLoaded) return;
    const current = form.getFieldValue("officesupervisor");
    if (!current) return;
    const stillExists = officeSupervisorOptions.some((opt) => opt.employeeId === current);
    if (!stillExists) form.setFieldValue("officesupervisor", undefined);
  }, [officeSupervisorOptions, form, initialLoaded]);



  // const organisationLevelfetchData1= async () => {
  //   const filtervalue = managingOfficeData.filter((item)=>form.getFieldValue('managingoffice').includes(item.value));
  //   const mapdata = filtervalue.map((item)=>item?.name);
  //   const response = await CALL_FEATCH_API(`insyts/level-data?levelName=Level2&parentLevel=[${mapdata}]`, "get");
  //   if (!isEmpty(response))  {
  //     const result = flatMap(response.data, item => item.value.map(value => ({ name: item.name, value })));
  //     setOrganisationLevelData(result);
  //   }
  // };

  const competencyQCfetchData1 = async () => {
    const filtervalue = managingOfficeData?.filter((item) =>
      form.getFieldValue("managingoffice").includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level2&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setCompetencyQCfetchData(result);
    }
  };

  const servicelinefetchData1 = async () => {
    const filtervalue = competencyQCData.filter((item) =>
      form.getFieldValue("competencyQC")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level3&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const serviceLines = form.getFieldValue("serviceline"); // e.g., ['Deal Advisory', 'Risk Advisory']
      const formValues = serviceLines?.map((line) =>
        line.replace(/[\s&()]+/g, "")
      );
      const filterResponse = response?.data?.filter((item) =>
        formValues.some((formValue) => item?.name?.includes(formValue))
      );
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setServicelinefetchData(result);
    }
  };

  const subservicelinefetchData1 = async () => {
    const filtervalue = servicelineData?.filter((item) =>
      form.getFieldValue("serviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level4&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response?.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setsubservicelineData(result);
    }
  };

  const departmentfetchData1 = async () => {
    const filtervalue = subservicelineData?.filter((item) =>
      form.getFieldValue("subserviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level5&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setDepartmentLevelData(result);
    }
  };

  const competencyrolefetchData1 = async () => {
    const filtervalue = subservicelineData.filter((item) =>
      form.getFieldValue("subserviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level6&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({ name: item.name, value }))
      );
      setcompetencyroleData(result);
    }
  };

  // const organisationLevelfetchData = async () => {
  //   const filtervalue = managingOfficeData.filter((item) =>
  //     form.getFieldValue("managingoffice").includes(item.value)
  //   );
  //   const mapdata = filtervalue.map((item) => item?.name);
  //   const response = await CALL_FEATCH_API(
  //     `insyts/level-data?levelName=Level2&parentLevel=[${mapdata}]`,
  //     "get"
  //   );
  //   if (!isEmpty(response)) {
  //     const result = flatMap(response.data, (item) =>
  //       item.value.map((value) => ({
  //         name: item.name,
  //         value,
  //         parentLevel: item.parentLevel,
  //       }))
  //     );
  //     setOrganisationLevelData(result);
  //     if (isEmpty(result)) {
  //       form.setFieldValue("organisationlevel", []);
  //       form.setFieldValue("competencyQC", []);
  //       form.setFieldValue("serviceline", []);
  //       form.setFieldValue("subserviceline", []);
  //       form.setFieldValue("competencyrole", []);
  //     } else {
  //       // organisationlevel
  //       const organisationlevelList = filter(result, (item) =>
  //         form.getFieldValue("managingoffice").includes(item.parentLevel)
  //       );
  //       const organisationlevel = filter(
  //         form.getFieldValue("organisationlevel"),
  //         (value) => find(organisationlevelList, { value: value })
  //       );
  //       form.setFieldValue("organisationlevel", organisationlevel);
  //       // competencyQC

  //       const competencyQClevelList = filter(competencyQCData, (item) =>
  //         form.getFieldValue("organisationlevel").includes(item.parentLevel)
  //       );
  //       setCompetencyQCfetchData(competencyQClevelList);
  //       const competencyQClevel = filter(
  //         form.getFieldValue("competencyQC"),
  //         (value) => find(competencyQClevelList, { value: value })
  //       );
  //       form.setFieldValue("competencyQC", competencyQClevel);
  //       // serviceline
  //       const servicelinelevelList = filter(servicelineData, (item) =>
  //         form.getFieldValue("competencyQC").includes(item.parentLevel)
  //       );
  //       setServicelinefetchData(servicelinelevelList);
  //       const serviceline = filter(form.getFieldValue("serviceline"), (value) =>
  //         find(servicelinelevelList, { value: value })
  //       );
  //       form.setFieldValue("serviceline", serviceline);
  //       // subserviceline
  //       const subservicelinelevelList = filter(subservicelineData, (item) =>
  //         form.getFieldValue("serviceline").includes(item.parentLevel)
  //       );
  //       setsubservicelineData(subservicelinelevelList);
  //       const subserviceline = filter(
  //         form.getFieldValue("subserviceline"),
  //         (value) => find(subservicelinelevelList, { value: value })
  //       );
  //       form.setFieldValue("subserviceline", subserviceline);
  //       //  // competencyrole
  //       //  const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
  //       //  setcompetencyroleData(competencyrolelevelList)
  //       //  const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
  //       //  form.setFieldValue('competencyrole', competencyrole);
  //     }
  //   }
  // };

  const competencyQCfetchData = async () => {
    const filtervalue = managingOfficeData.filter((item) =>
      form.getFieldValue("managingoffice").includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level2&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setCompetencyQCfetchData(result);
      if (isEmpty(result)) {
        form.setFieldValue("competencyQC", []);
        form.setFieldValue("serviceline", []);
        form.setFieldValue("subserviceline", []);
        form.setFieldValue("competencyrole", []);
        form.setFieldValue("leveldepartmentname", []);
        form.setFieldValue("levellocationid", []);

        setServicelinefetchData([]);
      } else {
        // competencyQC

        const competencyQClevelList = filter(result, (item) =>
          form.getFieldValue("managingoffice").includes(item.parentLevel)
        );
        const competencyQClevel = filter(
          form.getFieldValue("competencyQC"),
          (value) => find(competencyQClevelList, { value: value })
        );
        form.setFieldValue("competencyQC", competencyQClevel);
        // serviceline
        const servicelinelevelList = filter(servicelineData, (item) =>
          form.getFieldValue("competencyQC").includes(item.parentLevel)
        );
        setServicelinefetchData(servicelinelevelList);
        const serviceline = filter(form.getFieldValue("serviceline"), (value) =>
          find(servicelinelevelList, { value: value })
        );
        form.setFieldValue("serviceline", serviceline);
        // subserviceline
        const subservicelinelevelList = filter(subservicelineData, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        setsubservicelineData(subservicelinelevelList);
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );
        form.setFieldValue("subserviceline", subserviceline);

        // const leveldepartmentnameList = filter(subservicelineData, (item) =>
        //   form.getFieldValue("serviceline").includes(item.parentLevel)
        // );
        // setsubservicelineData(leveldepartmentnameList);
        // const leveldepartmentname = filter(
        //   form.getFieldValue("leveldepartmentname"),
        //   (value) => find(leveldepartmentnameList, { value: value })
        // );
        // form.setFieldValue("leveldepartmentname", leveldepartmentname);
        // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };

  const servicelinefetchData = async () => {
    const filtervalue = competencyQCData.filter((item) =>
      form.getFieldValue("competencyQC")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level3&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setServicelinefetchData(result);
      if (isEmpty(result)) {
        form.setFieldValue("serviceline", []);
        form.setFieldValue("subserviceline", []);
        form.setFieldValue("competencyrole", []);
        form.setFieldValue("leveldepartmentname", []);
      } else {
        // serviceline
        const servicelinelevelList = filter(result, (item) =>
          form.getFieldValue("competencyQC").includes(item.parentLevel)
        );
        const serviceline = filter(form.getFieldValue("serviceline"), (value) =>
          find(servicelinelevelList, { value: value })
        );
        form.setFieldValue("serviceline", serviceline);
        // subserviceline
        const subservicelinelevelList = filter(subservicelineData, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        setsubservicelineData(subservicelinelevelList);
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );
        form.setFieldValue("subserviceline", subserviceline);

        const leveldepartmentnameList = filter(subservicelineData, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        setsubservicelineData(leveldepartmentnameList);
        const leveldepartmentname = filter(
          form.getFieldValue("leveldepartmentname"),
          (value) => find(leveldepartmentnameList, { value: value })
        );
        form.setFieldValue("leveldepartmentname", leveldepartmentname);

        // // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };

  const subservicelinefetchData = async () => {
    const filtervalue = servicelineData?.filter((item) =>
      form.getFieldValue("serviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level4&parentLevel=[${mapdata}]`,
      "get"
    );

    if (!isEmpty(response)) {
      const serviceLines = form.getFieldValue("serviceline"); // e.g., ['Deal Advisory', 'Risk Advisory']
      // Map each service line to a cleaned-up string (remove spaces)
      const formValues = serviceLines?.map((line) =>
        line.replace(/[\s&()]+/g, "")
      );

      // Filter the response data to include only items that match any cleaned-up service line
      const filterResponse = response?.data?.filter((item) =>
        formValues.some((formValue) => item?.name?.includes(formValue))
      );

      const result = filterResponse.flatMap((item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setsubservicelineData(result);
      if (isEmpty(result)) {
        form.setFieldValue("subserviceline", []);
        form.setFieldValue("leveldepartmentname", []);
      } else {
        // subserviceline
        const subservicelinelevelList = filter(result, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );

        form.setFieldValue("subserviceline", subserviceline);
        // // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };
  const departmentfetchData = async () => {
    const filtervalue = subservicelineData?.filter((item) =>
      form.getFieldValue("subserviceline")?.includes(item.value)
    );
    const mapdata = filtervalue.map((item) => item?.name);
    const response = await CALL_FEATCH_API(
      `insyts/level-data?levelName=Level5&parentLevel=[${mapdata}]`,
      "get"
    );
    if (!isEmpty(response)) {
      const result = flatMap(response.data, (item) =>
        item.value.map((value) => ({
          name: item.name,
          value,
          parentLevel: item.parentLevel,
        }))
      );
      setDepartmentLevelData(result);
      if (isEmpty(result)) {
        form.setFieldValue("leveldepartmentname", []);
        // form.setFieldValue("subserviceline", []);
        // form.setFieldValue("competencyrole", []);
      } else {
        // subserviceline
        const subservicelinelevelList = filter(result, (item) =>
          form.getFieldValue("serviceline").includes(item.parentLevel)
        );
        const subserviceline = filter(
          form.getFieldValue("subserviceline"),
          (value) => find(subservicelinelevelList, { value: value })
        );

        // form.setFieldValue("subserviceline", subserviceline);
        // // competencyrole
        // const competencyrolelevelList = filter(subservicelineData, item => form.getFieldValue('subserviceline').includes(item.parentLevel))
        // setcompetencyroleData(competencyrolelevelList)
        // const competencyrole = filter(form.getFieldValue('competencyrole'), value => find(competencyrolelevelList, { 'value': value }));
        // form.setFieldValue('competencyrole', competencyrole);
      }
    }
  };
  const fetchJobDescriptions = async () => {
    try {
      const selectedGrade = form.getFieldValue("grade");
      if (!selectedGrade) {
        setFilteredJobDescriptions([]);
        return;
      }
      const response = await CALL_API("appraisal/jobdescription", "get");
      const apiData = response?.data || response?.response?.data || [];

      if (Array.isArray(apiData)) {
        const today = dayjs().startOf("day");
        const filtered = apiData
          .filter(
            (item) =>
              item.jobGradeCode === selectedGrade &&
              item?.additionalFile !== "Yes" &&
              (item?.fromDate
                ? dayjs().isSameOrAfter(
                  dayjs(item.fromDate, "DD-MM-YYYY").startOf("day")
                )
                : true) &&
              (item?.toDate
                ? dayjs().isSameOrBefore(
                  dayjs(item.toDate, "DD-MM-YYYY").endOf("day")
                )
                : true)
          )
          ?.reverse();

        setFilteredJobDescriptions(
          filtered.map((item) => ({
            fileName: item.fileName,
            fileUrl: item.fileUrl,
            jobDescriptionId: item.jobDescriptionId,
            jobGradeCode: item.jobGradeCode,
            jobGrade: item.jobGrade,
            fromDate: item?.fromDate,
            toDate: item?.toDate,
          }))
        );
      } else {
        const filtered = GradeandGradeCodes.filter(
          (item) => item.jobgradecode === selectedGrade
        );

        setFilteredJobDescriptions(
          filtered.map((item) => ({
            jobGradeCode: item.jobgradecode,
            jobGrade: item.jobgrade,
          }))
        );
      }
    } catch (error) {
      setFilteredJobDescriptions([]);
    }
  };

  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfModalVisible, setIsPdfModalVisible] = useState(false);

  const viewJobDescription = async (jobdescriptionid, filename, rowKey) => {
    setViewLoadingnew(rowKey);
    try {
      const token = window.localStorage.getItem("token") || "";
      const response = await axios.get(
        "https://h8gw6wo6o3.execute-api.us-west-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: { jobdescriptionid, filename },
          headers: { Tymeplusjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        // window.open(response.data.url, "_blank");
        setPdfUrl(response.data.url);
        setIsPdfModalVisible(true);
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
    } finally {
      setViewLoadingnew(null); // Stop loader
    }
  };

  // Custom-country Job Description reuses the existing per-role appraisal
  // fields (jobDescriptionId, jobdescriptionFileName, jobdescriptionFileUrl
  // on the row, submitted as part of appraisalInformation) via the same
  // appraisal/jobdescription S3 upload system the grade-based flow already
  // uses (see ModalView.js). It has no grade, so jobgradecode/jobgrade are
  // sent as a fixed "CUSTOM" sentinel (jobGradeCode is the DynamoDB
  // partition key for that table, so it can't be blank).
  const handleSaveCustomJobDescription = async () => {
    try {
      const values = await customJdForm.validateFields();
      const fileObj = customJdFileList[0]?.originFileObj;
      if (!fileObj) {
        message.error("Please upload a file");
        return;
      }

      setCustomJdSaving(true);

      const s3Response = await CALL_API("appraisal/jobdescription", "post", {
        method: "docupload",
        filename: fileObj.name,
        attachmenttype: fileObj.type || "application/pdf",
      });

      if (s3Response?.code !== "SUCCESS" || !s3Response?.url || !s3Response?.objectkey) {
        message.error("Failed to get upload URL");
        return;
      }

      const { url, objectkey, jobDescriptionid } = s3Response;

      const s3UploadResponse = await axios.put(url, fileObj, {
        headers: { "Content-Type": fileObj.type || "application/pdf" },
      });

      if (s3UploadResponse.status !== 200) {
        message.error("Failed to upload file to S3");
        return;
      }

      const fullName = [EmployeeDetails?.firstname, EmployeeDetails?.lastname]
        .filter(Boolean)
        .join(" ");

      const response = await CALL_API("appraisal/jobdescription", "post", {
        jobDescriptionid,
        jobgradecode: "CUSTOM",
        jobgrade: "Custom",
        fileid: values.fileid,
        fromdate: "",
        todate: "",
        attachmenttype: fileObj.type || "application/pdf",
        filename: fileObj.name,
        objectkey,
        updatedby: userInfo?.userid,
        createdBy: userInfo?.userid,
        employeeid: EmployeeDetails?.employeeid || EmployeeDetails?.employeeId || "",
        employeename: fullName,
      });

      if (response?.code !== "SUCCESS") {
        message.error("Failed to save job description");
        return;
      }

      if (currentRoleRecord) {
        const jdInfo = {
          jobDescriptionId: jobDescriptionid,
          jobdescriptionFileName: fileObj.name,
          jobdescriptionFileUrl: "",
          jobdescriptionFileId: values.fileid,
        };

        setAddedJobDescriptions((prev) => ({
          ...prev,
          [currentRoleRecord.key]: jdInfo,
        }));

        setData((prevData) =>
          prevData.map((row) =>
            row.key === currentRoleRecord.key ? { ...row, ...jdInfo } : row
          )
        );
      }

      message.success("Job description saved successfully");
      setIsCustomJdModalVisible(false);
      customJdForm.resetFields();
      setCustomJdFileList([]);
    } catch (error) {
      if (error?.errorFields) return;
      message.error(error?.message || "Something went wrong. Please try again.");
    } finally {
      setCustomJdSaving(false);
    }
  };

  useEffect(() => {
    if (isModalVisible) {
      setOtherFileList([]);
      setSelectedOption(null);
      form.setFieldsValue({ jobDescription: undefined });
    }
  }, [isModalVisible]);

  const handleGradeChange = (value) => {
    // Custom Job Description has no link to grade, so grade changes must not
    // clear an already-uploaded file in that mode.
    if (!isCustomJobDescription) {
      setData((prevData) =>
        prevData.map((row) => ({
          ...row,
          jobdescriptionFileName: "",
          jobdescriptionFileUrl: "",
          jobDescriptionId: "",
          jobdescriptionFileId: "",
        }))
      );
      setAddedJobDescriptions({});
    }
    setFormValues((prev) => ({
      ...prev,
      grade: value,
    }));
    setChargeout();
    setTargetChargeability();
  };

  const handleUpload = ({ file, onSuccess }) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      onSuccess();
    };
    reader.onerror = (error) => {
      console.error("File read error:", error);
    };
  };

  const handlePostCategoryDoc = async (row, file, base64, type) => {
    const desc = filteredJobDescriptions;
    const jobGradeCode = desc[0]?.jobGradeCode;
    const jobGrade = desc[0]?.jobGrade;
    // const gradeCode = gradeMap[row.key];   // grab the grade you saved earlier
    if (!jobGradeCode || !jobGrade) {
      message.warning("No jobGradeCode or gradeCode found for this row.");
      return;
    }

    setViewLoading(true);
    try {
      const token = window.localStorage.getItem("token") || "";

      const body = {
        clientid: "",
        engagementid: "",
        method: "appraisalInformation",
        jobgradecode: jobGradeCode || "",
        jobgrade: jobGrade || "",
        category: type || "",
        filename: file?.name || "",
        attachmenttype: file?.type || "",
        description: "-",
        content: base64 || "",
        createdby: userInfo?.userid || "",
        updatedby: userInfo?.userid || "",
      };
      const response = await axios.post(
        "https://h8gw6wo6o3.execute-api.us-west-1.amazonaws.com/Prod/insyts/engagement/category-doc",
        body,
        { headers: { Tymeplusjwt: token } }
      );
      if (response.data.response.code === "SUCCESS") {
        const fileData = response.data.response.response;
        const updatedFile = {
          ...fileData,
          name: fileData?.fileName,
        };

        form.setFieldValue("file", [updatedFile]);
      }
    } catch (error) {
      message.error("Error fetching category document.");
    } finally {
      setViewLoading(false);
    }
  };
  // Handle Add Job Description
  const handleFinish = async () => {
    const selectedJobDescription =
      selectedOption || form.getFieldValue("jobDescription");
    const selectedDescObj = filteredJobDescriptions.find(
      (desc) => desc.jobDescriptionId === selectedJobDescription
    );
    const fileList = form.getFieldValue("file");
    if (!selectedJobDescription && (!fileList || fileList.length === 0)) {
      message.error("Please select or upload a job description");
      return;
    }

    let fileName = "";
    let jobDescriptionId = "";
    let fileUrl = "";
    let fromDate = "";
    let toDate = "";
    let otherFile = "No";
    if (selectedJobDescription) {
      const selectedDescObj = filteredJobDescriptions.find(
        (desc) => desc.jobDescriptionId === selectedJobDescription
      );
      fileName = selectedDescObj?.fileName || "";
      jobDescriptionId =
        selectedDescObj?.jobDescriptionId || selectedJobDescription;
      fileUrl = selectedDescObj?.fileUrl || "";
      fromDate = selectedDescObj?.fromDate;
      toDate = selectedDescObj?.toDate;
      otherFile = "No";
    } else if (fileList && fileList.length > 0) {
      const file = fileList[0];
      fileName = file.name;
      jobDescriptionId = file?.jobDescriptionId;
      fileUrl = file.fileUrl; // Set if you have a URL after upload
      fromDate = "";
      toDate = "";
      otherFile = "Yes";
    }
    if (currentRoleRecord) {
      setAddedJobDescriptions((prev) => ({
        ...prev,
        [currentRoleRecord.key]: {
          fileName,
          jobDescriptionId,
          fileUrl,
          fromDate,
          toDate,
          otherFile,
        },
      }));

      setData((prevData) =>
        prevData.map((row) =>
          row.key === currentRoleRecord.key
            ? {
              ...row,
              jobdescriptionFileName: fileName,
              jobdescriptionFileUrl: fileUrl,
              jobDescriptionId: jobDescriptionId,
              fromDate: fromDate,
              toDate: toDate,
              otherFile: otherFile,
            }
            : row
        )
      );
    }
    const fileLog = {
      roletype: currentRoleRecord?.roletype || "New row",
      change: "job description added",
      modifiedby: userInfo?.userid,
      appraisee: EmployeeDetails?.userid || "",
      modifiedat: new Date().toISOString(),
      _logKey: `${key}_added`,
    };

    setChangeLogs((prevLogs) => [...prevLogs, fileLog]);
    setIsModalVisible(false);
    form.setFieldValue("file", []);
    setOtherFileList([]);
    setShowConfirmModal(true);
    setTimeout(() => {
      setShowConfirmModal(false);
    }, 1800);
  };

  // Handle View Job Description
  const handleViewJobDescription = async (row) => {
    const desc = addedJobDescriptions[row.key];
    if (!desc) {
      message.warning("Job description not found.");
      return;
    }
    setViewLoading(true);
    try {
      const params = new URLSearchParams({
        jobdescriptionid: desc.jobDescriptionId,
        filename: desc.fileName,
      }).toString();
      const response = await CALL_API(
        `/appraisal/getdocument?${params}`,
        "get"
      );
      if (response?.status === "SUCCESS" && response?.url) {
        window.open(response.url, "_blank");
      } else {
        message.error(response?.message || "Failed to fetch document.");
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
    } finally {
      setViewLoading(false);
    }
  };

  useEffect(() => {
    if (updateState === "basic") {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (competencyQCData?.length == 0 && updateState === "basic") {
      competencyQCfetchData1();
    }
  }, [managingOfficeData]);

  useEffect(() => {
    if (servicelineData?.length == 0 && updateState === "basic") {
      servicelinefetchData1();
    }
  }, [competencyQCData]);

  useEffect(() => {
    if (subservicelineData?.length == 0 && updateState === "basic") {
      subservicelinefetchData1();
    }
  }, [servicelineData]);

  useEffect(() => {
    if (departmentLevelData?.length == 0 && updateState === "basic") {
      departmentfetchData1();
    }
  }, [subservicelineData]);

  // useEffect(() => {
  //   if (competencyroleData?.length == 0 && updateState === "basic") {
  //     competencyrolefetchData1();
  //   }
  // }, [subservicelineData]);

  useEffect(() => {
    if (!historyDateRange || historyDateRange.length !== 2) {
      setFilteredHistoryData(historyDatas);
      return;
    }
    const [start, end] = historyDateRange;
    setFilteredHistoryData(
      historyDatas.filter((item) => {
        if (!item.modifiedAt) return false;
        const date = new Date(item.modifiedAt);
        return (
          date >= start.startOf("day").toDate() &&
          date <= end.endOf("day").toDate()
        );
      })
    );
  }, [historyDateRange, historyDatas]);

  const tabTitles = ["Basic"];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const rolecolumns = [
    {
      title: "Role Name",
      dataIndex: "roleName",
      key: "roleName",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "roleId",
      key: "roleId",
      width: "10%",
      align: "center",
      render: (roleId) => {
        const check = selectedRoleId?.includes(roleId) ? true : false;
        return (
          <Switch
            size="small"
            defaultChecked
            checked={check}
            onChange={(checked) => {
              getRoleId(roleId, checked);
            }}
          />
        );
      },
    },
  ];

  const baseLocationColumn = [
    {
      title: "Select Base Location",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        return (
          <Switch
            size="small"
            checked={baseLocation === location_id}
            onChange={(checked) => {
              const baseLocationId = checked ? location_id : "";
              setBaseLocation(baseLocationId);
              form.setFieldValue("baselocationid", baseLocationId);
              onFinish();
            }}
          />
        );
      },
    },
  ];

  const getRoleId = (role_id, checked) => {
    const newRoleId = checked
      ? [...selectedRoleId, role_id]
      : selectedRoleId.filter((item) => item !== role_id);
    setSelectedRoleId(newRoleId);
    onFinish();
  };

  const handleSelectAllRole = (e) => {
    const checked = e.target.checked;
    setSelectAllRoleChecked(checked);
    const allRoleIds = roleList.map((item) => item.roleId);
    setSelectedRoleId(checked ? allRoleIds : []);
    setFormValues((prev) => ({
      ...prev,
      selectedRoleId: selectedRoleId,
    }));
    onFinish();
  };

  const handleDeleteClick = () => {
    Modal.confirm({
      title: "Are you sure you want to delete this job description?",
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      centered: true,
      onOk() {
        const updatedData = data.map((item) => {
          if (item.key === currentRoleRecord?.key) {
            return {
              ...item,
              jobdescriptionFileName: "",
              jobDescriptionId: "",
              jobdescriptionFileUrl: "",
              jobdescriptionFileId: "",
            };
          }
          return item;
        });

        setData(updatedData);
        const fileLog = {
          roletype: currentRoleRecord?.roletype || "New row",
          change: "job description deleted",
          modifiedby: userInfo?.userid,
          appraisee: EmployeeDetails?.userid || "",
          modifiedat: new Date().toISOString(),
          _logKey: `${key}_deleted`,
        };

        setChangeLogs((prevLogs) => [...prevLogs, fileLog]);
        setIsPdfModalVisible(false);
      },
    });
  };

  const handleResetAllRole = (e) => {
    setSelectedRoleId([]);
    setFormValues((prev) => ({
      ...prev,
      selectedRoleId: selectedRoleId,
    }));
    onFinish();
  };

  useEffect(() => {
    const employeeBaseLocation =
      EmployeeDetails?.baselocationid ??
      EmployeeDetails?.levellocationid ??
      "";

    setSelectedRoleId(EmployeeDetails?.roleid || []);
    setBaseLocation(employeeBaseLocation);
    form.setFieldValue("baselocationid", employeeBaseLocation);
  }, [EmployeeDetails, form]);

  useEffect(() => {
    if (EmployeeDetails?.appraisalInformation) {
      setData(EmployeeDetails.appraisalInformation);
    }
  }, [EmployeeDetails]);

  useEffect(() => {
    if (!EmployeeDetails?.userid) return;
    setAppraisalInfoLoading(true);
    CALL_API("appraisal/performanceids", "get")
      .then((d) => {
        const pidList = d?.performanceIdList || [];
        const userRows = pidList.filter(
          (r) => r.apraiseemailid === EmployeeDetails.userid
        );
        if (userRows.length === 0) {
          setAppraisalInfoLocked(false);
        } else {
          const allReviewed = userRows.every((r) => r.contractstatus === "reviewed");
          setAppraisalInfoLocked(!allReviewed);
        }
        const openRoles = userRows
          .filter((r) => r.contractstatus !== "reviewed")
          .map((r) => r.roletype?.trim().toLowerCase());
        setActiveContractRoles(openRoles);

        // Map of roletype -> contract status for the CURRENT cycle, so we can
        // tell a role that's "not yet created" (absent here) apart from one
        // that's already reviewed.
        //
        // Each row is a role's latest contract across ALL cycles. A role whose
        // latest contract sits in an earlier cycle has nothing in the current
        // one, so carrying that old "reviewed" over made the cycle look
        // finished when that role still owes a contract. Scope to the current
        // cycle; anything older reads as not-yet-created (undefined).
        const currentCycle = userRows.reduce(
          (max, r) => Math.max(max, Number(r.latest_performanceid) || 0),
          0
        );
        const statusMap = {};
        userRows
          .filter((r) => Number(r.latest_performanceid) === currentCycle)
          .forEach((r) => {
            statusMap[r.roletype?.trim().toLowerCase()] = r.contractstatus;
          });
        setRoleContractStatusMap(statusMap);
      })
      .catch(() => { setAppraisalInfoLocked(false); })
      .finally(() => { setAppraisalInfoLoading(false); });
  }, [EmployeeDetails?.userid]);

  const locationId = chain(roleList)
    .filter((role) => selectedRoleId?.includes(role.roleId))
    .flatMap((role) => role.locationId)
    .uniq()
    .value();

  const locationBasedOnRole = locationList?.filter((val) =>
    locationId.includes(val?.location_id)
  );

  const iconsize = { fontSize: "14px" };

  const cursorstyle = { cursor: "pointer" };

  const handleDateChange = (date, dateString, key, field) => {
    const updatedEducationDetails = [...formValues.educationdetails];
    updatedEducationDetails[key][field] = date;

    setFormValues({
      ...formValues,
      educationdetails: updatedEducationDetails,
    });

    onFinish();
  };

  const calculateTotal = () => {
    const values = form.getFieldsValue([
      "grossSalary",
      "housingAllowance",
      "medicalInsurance",
      "pension",
      "groupLifeInsurance",
      "socialSecurityContribution",
      "bonus",
      "otherCosts",
    ]);

    const total = Object.values(values).reduce((acc, val) => {
      const numericVal = parseFloat(val.replace(/,/g, "")); // Remove commas before parsing
      return acc + (isNaN(numericVal) ? 0 : numericVal);
    }, 0);

    const formattedTotal = total.toFixed(2); // Ensure maximum 5 digits after decimal

    form.setFieldsValue({ totalEmploymentCost: formattedTotal });
  };

  const formatNumber = (value) => {
    if (!value) return "";
    const [integer, fraction] = value.toString().split(".");
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fraction !== undefined
      ? `${formattedInteger}.${fraction}`
      : formattedInteger;
  };

  const parseNumber = (value) => {
    return value.replace(/,/g, "");
  };

  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Enter",
      ".",
    ];

    const isAllowedKey =
      allowedKeys.includes(e.key) ||
      ((e.ctrlKey || e.metaKey) &&
        (e.key === "v" || e.key === "c" || e.key === "x"));

    if (!/^[0-9]$/.test(e.key) && !isAllowedKey) {
      e.preventDefault();
    }
  };

  const { key, url } = queryKeys.getChargeoutRates;
  const { data: gradeDataRes } = useFetch(key, url);

  const gradeData = gradeDataRes?.response?.items || [];

  // Head Office has no chargeout-rate column of its own; it reads Kenya's rate.
  const countries = countryCodeOptions.map((c) =>
    c.country === "Head Office" ? { ...c, code: "KE" } : c
  );
  const managingOffice = form.getFieldValue("managingoffice")?.[0];

  const countryCode = countries.find(
    (val) => val.country === managingOffice
  )?.code;

  const gradeOptions = gradeData
    ? gradeData?.map((item) => ({
      label: item.jobgradecode,
      value: item.jobgradecode,
      rate: item?.[countryCode] || 0,
      targetchargeability: item.targetchargeability || 0,
      designation: item.designation,
      jobgrade: item.jobgrade,
    }))
    : [];

  const setChargeout = () => {
    const selectedGrade = form.getFieldValue("grade");
    const managingoffice = form.getFieldValue("managingoffice");
    const countryCode = countryNameToCode[managingoffice];
    if (selectedGrade && countryCode) {
      const selectedGradeData = gradeData?.find(
        (item) => item.jobgradecode === selectedGrade
      );
      const rate = parseFloat(selectedGradeData?.[countryCode]) || 0;
      form.setFieldsValue({ chargeoutrate: rate });
      setFormValues((prev) => ({
        ...prev,
        chargeoutrate: rate,
      }));
    }
  };

  const setTargetChargeability = () => {
    const selectedGrade = form.getFieldValue("grade");

    if (selectedGrade) {
      const target = gradeOptions.find(
        (item) => item.value === selectedGrade
      )?.targetchargeability;

      form.setFieldsValue({ targetchargeability: target });
      setFormValues((prev) => ({
        ...prev,
        targetchargeability: target || 0,
      }));
    }
  };

  // const appraisers = userList?.map((item) => item?.fullname); // Example appraisers
  const roleLevels = ["Leader", "Backstop", "Member"];

  const [validationErrors, setValidationErrors] = useState({});
  const [appraisalInfoLocked, setAppraisalInfoLocked] = useState(false);
  const [appraisalInfoLoading, setAppraisalInfoLoading] = useState(true);
  const [activeContractRoles, setActiveContractRoles] = useState([]);
  const [roleContractStatusMap, setRoleContractStatusMap] = useState({});
  const [contractDeleteModal, setContractDeleteModal] = useState({ visible: false, key: null });
  const [lastActiveRoleDeleteModal, setLastActiveRoleDeleteModal] = useState({ visible: false, key: null });
  const [lastPendingRoleDeleteModal, setLastPendingRoleDeleteModal] = useState({ visible: false, key: null });
  const [appraisalNoModal, setAppraisalNoModal] = useState({ visible: false, record: null, value: null, option: null });
  const [changeAppraiserModal, setChangeAppraiserModal] = useState({ visible: false, record: null, value: null, option: null });
  const [addRoleModal, setAddRoleModal] = useState({ visible: false });

  const getNextRoleType = () => {
    const existing = data.map((row) => row.roletype);
    if (!existing.includes("Additional 1")) return "Additional 1";
    if (!existing.includes("Additional 2")) return "Additional 2";
    return "Additional 3";
  };

  const requestAddRow = () => {
    if (appraisalInfoLoading) {
      message.warning("Checking contract status, please wait...");
      return;
    }
    const missingPrimaryJobDescriptions = data?.filter((row) => {
      const hasFile = !!row?.jobDescriptionId;
      return !hasFile; // keep only rows missing job descriptions
    });

    if (missingPrimaryJobDescriptions?.length > 0) {
      message.error(
        "Please add a Job Description for all roles before proceeding."
      );
      return; // ✅ Block going forward
    }

    if (appraisalInfoLocked) {
      setAddRoleModal({ visible: true });
      return;
    }

    addNewRow();
  };

  const addNewRow = () => {
    setData((prevData) => [
      ...prevData,
      {
        key: prevData.length + 1,
        orgLevel: "",
        areaofwork: "",
        subareaofwork: "",
        weightage: 0,
        roletype: getNextRoleType(),
        rolelevel: "",
        appraiser: "",
        appraisal: "",
        jobdescriptionFileName: "",
        jobdescriptionFileUrl: "",
        jobdescriptionFileId: "",
      },
    ]);
    const newLog = {
      roletype: getNextRoleType(),
      change: "Row added",
      modifiedby: userInfo?.userid,
      appraisee: EmployeeDetails?.userid,
      modifiedat: new Date().toISOString(),
      _logKey: `${data?.length + 1}_added`,
    };

    setChangeLogs((prevLogs) => [...prevLogs, newLog]);
  };

  useEffect(() => {
    if (updateState === "basic" && activeTab === "0") {
      setData((prevData) => {
        if (!prevData.length) return prevData;

        const primaryRow =
          prevData.find((row) => row.roletype === "Primary") || prevData[0];

        const orgLevel = form.getFieldValue("managingoffice")?.[0] || "";
        const areaofworkArr = form.getFieldValue("serviceline") || [];
        const subareaofworkArr = form.getFieldValue("subserviceline") || [];
        const appraiserId = form.getFieldValue("officesupervisor") || "";
        const noOfficeSupervisor = appraiserId === "none";
        const ownFullName = `${EmployeeDetails?.firstname || ""} ${EmployeeDetails?.lastname || ""}`.trim();

        const appraiserName = noOfficeSupervisor
          ? ownFullName
          : supervisorList?.find((user) => user.employeeId === appraiserId)
            ?.name || "";

        const updatedPrimary = {
          ...primaryRow,
          orgLevel,
          areaofwork:
            areaofworkArr.length > 1
              ? areaofworkArr.join(", ")
              : areaofworkArr[0] || "",
          subareaofwork:
            subareaofworkArr.length > 1
              ? subareaofworkArr.join(", ")
              : subareaofworkArr[0] || "",
          appraiser: noOfficeSupervisor
            ? EmployeeDetails?.userid || ""
            : supervisorList?.find((user) => user.employeeId === appraiserId)
              ?.userid || "",
          appraiserName,
        };

        const oldPrimary = EmployeeDetails?.appraisalInformation?.find(
          (row) => row.key === primaryRow.key
        );

        if (!oldPrimary) return prevData;

        // === 🧠 Compare and log changes ===
        if (oldPrimary?.orgLevel !== updatedPrimary.orgLevel) {
          updateLog(oldPrimary, "orgLevel", updatedPrimary.orgLevel);
        }

        if (oldPrimary.areaofwork !== updatedPrimary.areaofwork) {
          updateLog(updatedPrimary, "areaofwork", updatedPrimary.areaofwork);
        }

        if (oldPrimary.subareaofwork !== updatedPrimary.subareaofwork) {
          updateLog(
            updatedPrimary,
            "subareaofwork",
            updatedPrimary.subareaofwork
          );
        }

        if (oldPrimary.appraiser !== updatedPrimary.appraiser) {
          updateLog(updatedPrimary, "appraiser", updatedPrimary.appraiser);
        }

        // === 🧠 Return updated data ===
        const additionalRows = prevData.filter(
          (row) => row.key !== primaryRow.key
        );
        return [updatedPrimary, ...additionalRows];
      });
    }
    // eslint-disable-next-line
  }, [
    updateState,
    activeTab,
    form.getFieldValue("managingoffice"),
    form.getFieldValue("serviceline"),
    form.getFieldValue("subserviceline"),
    form.getFieldValue("officesupervisor"),
    supervisorList,
  ]);

  // Replace with actual user context

  // Label map
  const fieldLabelMap = {
    orgLevel: "Country",
    areaofwork: "ServiceLine",
    subareaofwork: "SubServiceLine",
    appraiser: "Appraiser",
    appraisal: "Appraisal",
    weightage: "Weightage",
  };

  const updateLog = (record, field, newValue) => {
    const original = EmployeeDetails?.appraisalInformation?.find(
      (item) => item.key === record.key
    );

    if (!original) return;

    const oldValue =
      field === "appraiser" ? original?.appraisername || "" : original?.[field];

    const fieldLabelMap = {
      orgLevel: "Country",
      areaofwork: "ServiceLine",
      subareaofwork: "SubServiceLine",
      appraiser: "Appraiser",
      appraisal: "Appraisal",
      weightage: "Weightage",
    };

    const changeEntry = {
      roletype: record.roletype,
      change: `${fieldLabelMap[field]}: From ${oldValue || "Empty"} to ${newValue || ""
        }`,
      modifiedby: userInfo?.userid,
      appraisee: EmployeeDetails.userid,
      modifiedat: new Date().toISOString(),
      _logKey: `${record.key}_${field}`,
    };

    setChangeLogs((prevLogs) => {
      const filtered = prevLogs.filter(
        (log) => log._logKey !== changeEntry._logKey
      );
      return [...filtered, changeEntry];
    });
  };

  const handleChange = (value, record, field, label) => {
    const newValue = field === "appraiser" ? label : value;

    const updatedData = data.map((item) =>
      item.key === record.key
        ? field === "appraiser"
          ? { ...item, appraiser: value, appraisername: label }
          : field === "appraisal"
            ? {
              ...item,
              appraisal: value,
              weightage: value === "No" ? 0 : item.weightage,
            }
            : field === "roletype" && value === "Additional"
              ? {
                ...item,
                [field]: `Additional ${data.filter((row) => row.roletype?.startsWith("Additional"))
                  .length + 1
                  }`,
              }
              : { ...item, [field]: value }
        : item
    );

    setData(updatedData);

    // Skip tracking for some fields if needed
    if (!["jobdescriptionFileName", "jobDescriptionId"].includes(field)) {
      updateLog(record, field, newValue);
    }

    if (validationErrors?.[record.key]?.[field]) {
      const updatedErrors = { ...validationErrors };
      delete updatedErrors[record.key][field];
      if (Object.keys(updatedErrors[record.key] || {}).length === 0) {
        delete updatedErrors[record.key];
      }
      setValidationErrors(updatedErrors);
    }
  };

  // const handleValidation = () => {
  //   const errors = {};
  //   let isValid = true;

  //   data.forEach((record) => {
  //     const requiredFields = [
  //       "orgLevel",
  //       "areaofwork",
  //       "subareaofwork",
  //       "appraiser",
  //       "appraisal",
  //       "weightage",
  //       "roletype",
  //     ];
  //     requiredFields.forEach((key) => {
  //       if (
  //         (record[key] === "" ||
  //           record[key] === null ||
  //           record[key] === undefined) &&
  //         record.appraisal === "Yes"
  //       ) {
  //         if (!errors[record.key]) {
  //           errors[record.key] = {};
  //         }
  //         errors[record.key][key] = true;
  //         isValid = false;
  //       }
  //     });
  //   });

  //   setValidationErrors(errors);

  //   if (!isValid) {
  //     message.error("Please fill in all required fields.");
  //   }

  //   return isValid;
  // };
  const handleValidation = () => {
    const errors = {};
    let isValid = true;

    const excludedKeys = [
      "key",
      "jobdescriptionFileName",
      "jobdescriptionFileUrl",
      "jobdescriptionFileId",
      "jobDescriptionId",
      "rolelevel",
      "appraisername",
      "appraiserName",
      "fromDate",
      "toDate",
      "otherFile",
    ];

    data.forEach((record) => {
      Object.keys(record).forEach((key) => {
        if (
          !excludedKeys.includes(key) &&
          (record[key] === "" ||
            record[key] === null ||
            record[key] === undefined)
        ) {
          if (!errors[record.key]) {
            errors[record.key] = {};
          }
          errors[record.key][key] = true;
          isValid = false;
        }
      });
    });

    setValidationErrors(errors);

    if (!isValid) {
      message.error("Please fill in all required fields.");
    }

    return isValid;
  };

  const totalWeightage = data?.reduce(
    (sum, record) => sum + (record.weightage || 0),
    0
  );

  const zeroWeightageRoles = data?.filter(
    (record) =>
      record.appraisal === "Yes" && (!record.weightage || record.weightage <= 0)
  );

  const validateTotalWeightage = () => {
    if (zeroWeightageRoles?.length > 0) {
      message.error(
        `Weightage must be greater than 0 for: ${zeroWeightageRoles
          .map((r) => r.roletype)
          .join(", ")}`
      );
      return false;
    }
    if (totalWeightage !== 100) {
      message.error(`Total weightage must be exactly 100%. Current total: ${totalWeightage}%`);
      return false;
    }
    return true;
  };
  const handleDeleteRow = (key, deleteContract = false) => {
    const rowToDelete = data.find((row) => row.key === key);
    if (rowToDelete?.roletype === "Primary") return;

    const updatedData = data.filter((row) => row.key !== key);
    setData(updatedData);
    const deletionLog = {
      roletype: rowToDelete.roletype,
      change: "Row deleted",
      modifiedby: userInfo?.userid,
      appraisee: EmployeeDetails?.userid || "", // optional if available
      modifiedat: new Date().toISOString(),
      _logKey: `${key}_deleted`,
      deleteContract,
    };

    setChangeLogs((prevLogs) => [...prevLogs, deletionLog]);
    form.setFieldValue("file", []);
    setOtherFileList([]);
  };

  const requestDeleteRow = (key) => {
    const rowToDelete = data.find((row) => row.key === key);
    if (!rowToDelete || rowToDelete.roletype === "Primary") return;

    const hasOpenContract = activeContractRoles.includes(
      rowToDelete.roletype?.trim().toLowerCase()
    );

    if (hasOpenContract) {
      // Deleting this role closes out the whole cycle only if nothing else is
      // still holding it open. A configured role with no contract yet counts
      // just as much as one with an open contract — it was absent from
      // activeContractRoles (which only tracks roles that HAVE a contract), so
      // checking that array alone wrongly called this the last active role.
      const otherYesRoles = data.filter(
        (r) => r.key !== key && r.appraisal === "Yes"
      );
      const othersKeepingCycleOpen = otherYesRoles.filter(
        (r) =>
          roleContractStatusMap[r.roletype?.trim().toLowerCase()] !== "reviewed"
      );
      const isLastActiveRole = othersKeepingCycleOpen.length === 0;
      if (isLastActiveRole) {
        setLastActiveRoleDeleteModal({ visible: true, key });
      } else {
        setContractDeleteModal({ visible: true, key });
      }
    } else {
      // No open contract for this role — either it's "not yet created" or
      // already reviewed. If it's not yet created AND every other
      // currently-active role has already been reviewed, deleting it still
      // closes out the current cycle even though there's no contract to
      // delete — warn separately.
      const roletype = rowToDelete.roletype?.trim().toLowerCase();
      const thisRoleStatus = roleContractStatusMap[roletype];
      const isNotYetCreated = thisRoleStatus === undefined;

      const otherYesRoles = data.filter(
        (r) => r.key !== key && r.appraisal === "Yes"
      );
      const allOthersClosed =
        otherYesRoles.length > 0 &&
        otherYesRoles.every(
          (r) =>
            roleContractStatusMap[r.roletype?.trim().toLowerCase()] ===
            "reviewed"
        );

      if (isNotYetCreated && allOthersClosed) {
        setLastPendingRoleDeleteModal({ visible: true, key });
      } else {
        handleDeleteRow(key, false);
      }
    }
  };

  const requestAppraiserChange = (value, record, option) => {
    const hasOpenContract = activeContractRoles.includes(
      record.roletype?.trim().toLowerCase()
    );
    if (hasOpenContract) {
      setChangeAppraiserModal({ visible: true, record, value, option });
      return;
    }
    handleChange(value, record, "appraiser", option?.label);
  };

  const confirmChangeAppraiser = () => {
    const { record, value, option } = changeAppraiserModal;
    handleChange(value, record, "appraiser", option?.label);
    setChangeAppraiserModal({ visible: false, record: null, value: null, option: null });
  };

  const requestAppraisalChange = (value, record, option) => {
    if (value === "No") {
      const hasOpenContract = activeContractRoles.includes(
        record.roletype?.trim().toLowerCase()
      );
      if (hasOpenContract) {
        setAppraisalNoModal({ visible: true, record, value, option });
        return;
      }
    }
    handleChange(value, record, "appraisal", option?.label);
  };

  const confirmAppraisalNo = () => {
    const { record, value, option } = appraisalNoModal;
    handleChange(value, record, "appraisal", option?.label);
    setChangeLogs((prevLogs) => [
      ...prevLogs,
      {
        roletype: record.roletype,
        change: "Appraisal set to No - contract removed",
        modifiedby: userInfo?.userid,
        appraisee: EmployeeDetails?.userid || "",
        modifiedat: new Date().toISOString(),
        _logKey: `${record.key}_appraisal_contractdelete`,
        deleteContract: true,
      },
    ]);
    setAppraisalNoModal({ visible: false, record: null, value: null, option: null });
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Country",
      dataIndex: "orgLevel",
      render: (text, record) => (
        <Select
          value={record.orgLevel}
          onChange={(value) => handleChange(value, record, "orgLevel")}
          placeholder="Select Org Level"
          options={managingOfficeData}
          disabled={
            appraisalInfoLoading ||
            activeContractRoles.includes(record.roletype?.trim().toLowerCase()) ||
            record.roletype === "Primary"
          }
          style={{
            border: validationErrors[record.key]?.orgLevel
              ? "1px solid red"
              : "",
          }}
          getPopupContainer={() => containerRef.current}
        />
      ),
    },
    {
      title: "Service Line",
      dataIndex: "areaofwork",
      render: (text, record) => (
        <Input
          value={record.areaofwork}
          onChange={(e) => handleChange(e.target.value, record, "areaofwork")}
          onBlur={(e) => updateLog(record, "areaofwork", e.target.value)}
          placeholder="Enter Service Line"
          disabled={
            appraisalInfoLoading ||
            activeContractRoles.includes(record.roletype?.trim().toLowerCase()) ||
            record.roletype === "Primary"
          }
          style={{
            borderColor: validationErrors[record.key]?.areaofwork ? "red" : "",
          }}
        />
      ),
    },
    {
      title: "Sub Serviceline",
      dataIndex: "subareaofwork",
      render: (text, record) => (
        <Input
          value={record.subareaofwork}
          onChange={(e) =>
            handleChange(e.target.value, record, "subareaofwork")
          }
          onBlur={(e) => updateLog(record, "subareaofwork", e.target.value)}
          placeholder="Enter Sub Serviceline"
          disabled={
            appraisalInfoLoading ||
            activeContractRoles.includes(record.roletype?.trim().toLowerCase()) ||
            record.roletype === "Primary"
          }
          style={{
            borderColor: validationErrors[record.key]?.subareaofwork
              ? "red"
              : "",
          }}
        />
      ),
    },
    {
      title: "Appraiser",
      dataIndex: "appraiser",
      render: (text, record) => {
        const appraiserDisplayValue =
          record.roletype === "Primary"
            ? record.appraiserName || undefined
            : masterUserList?.find((val) => val?.userid === record?.appraiser)
              ?.fullname || record.appraiser || undefined;
        return (
          <Select
            value={appraiserDisplayValue}
            showSearch
            onChange={(value, option) =>
              requestAppraiserChange(value, record, option)
            }
            placeholder="Select Appraiser"
            options={masterUserList
              ?.filter(
                (val) =>
                  (EmployeeDetails?.OfficeSupervisorId === "none" &&
                    val?.userid === record?.appraiser) ||
                  !data?.map((item) => item?.appraiser).includes(val?.userid)
              )
              ?.map((a) => ({
                value: a?.userid,
                label: a?.fullname,
              }))}
            disabled={record.roletype === "Primary"}
            style={{
              width: "100%",
              border: validationErrors[record.key]?.appraiser
                ? "1px solid red"
                : "",
            }}
            getPopupContainer={() => containerRef.current}
          />
        );
      },
    },
    {
      title: "Appraisal",
      dataIndex: "appraisal",
      render: (text, record) => (
        <Select
          value={record.appraisal}
          onChange={(value, option) =>
            requestAppraisalChange(value, record, option)
          }
          placeholder="Select Appraisal"
          disabled={appraisalInfoLoading}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
          getPopupContainer={() => containerRef.current}
        />
      ),
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      render: (text, record) => (
        <Input
          value={record.weightage ?? ""}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              handleChange(Number(value), record, "weightage");
            }
          }}
          onBlur={(e) => updateLog(record, "weightage", e.target.value)}
          onKeyDown={(event) => {
            if (
              !/[0-9]/.test(event.key) &&
              event.key !== "Backspace" &&
              event.key !== "Tab"
            ) {
              event.preventDefault();
            }
          }}
          disabled={record.appraisal !== "Yes"}
          style={{
            borderColor:
              record.appraisal === "Yes" && totalWeightage !== 100
                ? "red"
                : validationErrors[record.key]?.weightage
                  ? "red"
                  : "",
            borderRadius: "8px",
          }}
        />
      ),
    },
    {
      title: "Role Type",
      dataIndex: "roletype",
      render: (text, record) => (
        <Select
          value={record.roletype}
          onChange={(value) => handleChange(value, record, "roletype")}
          placeholder="Select Role Type"
          disabled
          suffixIcon={null}
          style={{
            border: validationErrors[record.key]?.roletype
              ? "1px solid red"
              : "",
          }}
          getPopupContainer={() => containerRef.current}
        >
          <Option value="Primary">Primary</Option>
          <Option value="Additional">Additional</Option>
        </Select>
      ),
    },
    {
      title: "Job Description",
      dataIndex: "jobdescriptionFileName",
      render: (_, record) => {
        const hasJD = record.jobdescriptionFileName;

        if (isCustomJobDescription) {
          return hasJD ? (
            <span
              style={{
                cursor: "pointer",
                color: "#1890ff",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
              onClick={() => {
                setCurrentRoleRecord(record);
                viewJobDescription(
                  record.jobDescriptionId,
                  record.jobdescriptionFileName,
                  record.key
                );
              }}
            >
              <EyeOutlined style={{ fontSize: 16 }} />
              <span style={{ textDecoration: "underline" }}>View</span>
              {loadingnew === record.key && <Spin size="small" />}
            </span>
          ) : (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentRoleRecord(record);
                customJdForm.resetFields();
                setCustomJdFileList([]);
                setIsCustomJdModalVisible(true);
              }}
              style={{
                color: "black",
                outline: "none",
                boxShadow: "none",
                border: "none",
                background: "transparent",
                cursor: "pointer",
              }}
            >
              +
              <span style={{ textDecoration: "underline", marginLeft: 4 }}>
                Add
              </span>
            </button>
          );
        }

        return hasJD ? (
          <span
            style={{
              cursor: "pointer",
              color: "#1890ff",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
            onClick={() => {
              setCurrentRoleRecord(record);
              viewJobDescription(
                record.jobDescriptionId,
                record.jobdescriptionFileName,
                record.key
              );
            }}
          >
            <EyeOutlined style={{ fontSize: 16 }} />
            <span style={{ textDecoration: "underline" }}>View</span>
            {loadingnew === record.key && <Spin size="small" />}
          </span>
        ) : (
          <button
            type="button"
            onClick={async (e) => {
              e.stopPropagation();
              setAddLoadingRow(record.key);
              setCurrentRoleRecord(record);
              const grade = form.getFieldValue("grade");

              if (!grade) {
                message.warning(
                  "Please select a Grade before adding a Job Description."
                );
                setAddLoadingRow(null);
                return;
              }

              setGradeMap((prev) => ({ ...prev, [record.key]: grade }));
              setModalLoading(true);
              await fetchJobDescriptions();
              setIsModalVisible(true);
              setModalLoading(false);
              setAddLoadingRow(null);
            }}
            style={{
              color: "black",
              outline: "none",
              boxShadow: "none",
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            +
            <span style={{ textDecoration: "underline", marginLeft: 4 }}>
              Add
            </span>
            {addLoadingRow === record.key && <Spin size="small" />}
          </button>
        );
      },
    },
    {
      title: "",
      dataIndex: "actions",
      render: (_, record) =>
        record.roletype !== "Primary" && (
          <DeleteIcon
            onClick={() => {
              if (appraisalInfoLoading) return;
              requestDeleteRow(record.key);
            }}
            title={
              appraisalInfoLoading
                ? "Checking contract status, please wait..."
                : undefined
            }
            style={{
              color: appraisalInfoLoading ? "#ccc" : "red",
              cursor: appraisalInfoLoading ? "not-allowed" : "pointer",
              opacity: appraisalInfoLoading ? 0.5 : 1,
            }}
          />
        ),
    },
  ];

  const onCertificationTypeChange = (value) => {
    handleCertificationChange(value, setShowOtherCertification);
  };

  const historyColumns = [
    {
      title: "Role Type",
      dataIndex: "roleType",
      key: "roleType",
    },
    {
      title: "Change",
      dataIndex: "change",
      key: "change",
    },
    {
      title: "Modified By",
      dataIndex: "modifiedBy",
      key: "modifiedBy",
      render: (text, record) => {
        const user = masterUserList?.find((u) => u.userid === record.modifiedBy);
        const employeeId = user?.employeeid || "";
        const fullName = user?.fullname || "";

        let formattedDate = "";
        if (record.modifiedAt) {
          const dateObj = new Date(record.modifiedAt);
          const day = dateObj.getDate();
          const month = dateObj.toLocaleString("en-US", { month: "short" });
          const year = dateObj.getFullYear();
          const hours = dateObj.getHours();
          const minutes = dateObj.getMinutes();
          // Format hours and minutes to 2 digits
          const pad = (n) => n.toString().padStart(2, "0");
          formattedDate = `${pad(day)}${getDaySuffix(
            day
          )} ${month} ${year}; ${pad(hours % 12 || 12)}:${pad(minutes)} ${hours >= 12 ? "PM" : "AM"
            }`;
        }
        function getDaySuffix(day) {
          if (day >= 11 && day <= 13) return "th";
          switch (day % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        }
        return (
          <span>
            {fullName}
            {employeeId ? ` (${employeeId})` : ""}
            <i>{formattedDate ? `; ${formattedDate}` : ""}</i>
          </span>
        );
      },
    },
  ];

  const noWrapStyle = {
    whiteSpace: "nowrap",
    // overflow: "auto", // or "auto"
    textOverflow: "ellipsis",
  };

  const getDataWithCount = (
    dataArray,
    idKey = "employeeId",
    nameKey = "employeeName"
  ) => {
    const employeeCountMap = dataArray.reduce((acc, curr) => {
      const id = curr[idKey];
      acc[id] = (acc[id] || 0) + 1;
      return acc;
    }, {});

    const uniqueEmployees = uniqBy(dataArray, idKey);

    return uniqueEmployees.map((employee) => ({
      employeeId: employee[idKey],
      employeeName: employee[nameKey] || employee[idKey] || "-",
      count: employeeCountMap[employee[idKey]] || 0,
    }));
  };

  const formatWeekPeriod = (weekStr) => {
    if (!weekStr) return "";

    const [start, end] = weekStr.split("-");
    const parse = (str) => {
      const date = new Date(
        str.replace(/(\d{4})([A-Z]{3})(\d{2})/, (_, y, m, d) => {
          const monthMap = {
            JAN: 0,
            FEB: 1,
            MAR: 2,
            APR: 3,
            MAY: 4,
            JUN: 5,
            JUL: 6,
            AUG: 7,
            SEP: 8,
            OCT: 9,
            NOV: 10,
            DEC: 11,
          };
          return `${y}-${monthMap[m]}-${d}`;
        })
      );
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    return `${parse(start)} - ${parse(end)}`;
  };

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const formatOrdinalDate = (dateStr) => {
    if (!dateStr) return "-";
    const dateObj = new Date(dateStr);
    if (Number.isNaN(dateObj.getTime())) return "-";
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("en-US", { month: "long" });
    const year = dateObj.getFullYear();
    const suffix = day >= 11 && day <= 13 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[day % 10] || "th";
    return `${day}${suffix} ${month} ${year}`;
  };

  const chargeableDataWithCount = getDataWithCount(terminatedData.chargeable);
  const nonChargeableData = (terminatedData.non_chargeable || []).map((item) => ({
    // employeeId: item.employeeId,
    // employeeName: item.employeeName,
    period: formatWeekPeriod(item.week),
    totalHours: item.totalhours,
  }));
  const leaveData = (terminatedData.leave || []).map((item) => ({
    leaveType: item.leave_category_name || "-",
    startDate: formatDate(item.start_date),
    endDate: formatDate(item.end_date),
    numberOfDays: item.number_of_days || "0",
  }));
  const appraisalData = (terminatedData.appraisal || []).map((item) => ({
    roletype: item.roletype || "-",
    createdat: formatOrdinalDate(item.createdat),
    status: item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : "-",
    attendedon: formatOrdinalDate(item.attendedon),
  }));
  const wfhData = (terminatedData.wfh || []).map((item) => ({
    startDate: formatDate(item.startDate),
    endDate: formatDate(item.endDate),
    numberOfDays: item.noOfDays || "0",
  }));
  // const selectedSupervisorId = form.getFieldValue("officesupervisor");

  const columnsDummyData = [
    {
      title: "Name",
      dataIndex: "employeeName",
      key: "employeeName",
      align: "center",
      // ellipsis: true,
      render: (text) => <div style={noWrapStyle}>{text}</div>,
    },
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",
      align: "center",
      ellipsis: true,
      width: "50%",
      render: (text) => <div style={noWrapStyle}>{text}</div>,
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      align: "center",
      render: (text) => <div style={noWrapStyle}>{text}</div>,
    },
  ];

  const nonChargeableColumns = [
    {
      title: "Period",
      dataIndex: "period",
      key: "period",
      align: "left",
      render: (text) => <div style={noWrapStyle}>{text}</div>,
    },
    {
      title: "Timesheet hours",
      dataIndex: "totalHours",
      key: "totalHours",
      align: "left",
      render: (text) => <div style={noWrapStyle}>{text}</div>,
    },
  ];

  const leaveColumns = [
    {
      title: "Leave Type",
      dataIndex: "leaveType",
      key: "leaveType",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "No. of Days",
      dataIndex: "numberOfDays",
      key: "numberOfDays",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
  ];

  const appraisalColumns = [
    {
      title: "Role Type",
      dataIndex: "roletype",
      key: "roletype",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "Contract Created on",
      dataIndex: "createdat",
      key: "createdat",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "Contract Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "Attended on",
      dataIndex: "attendedon",
      key: "attendedon",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
  ];

  const wfhColumns = [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: "No. of Days",
      dataIndex: "numberOfDays",
      key: "numberOfDays",
      align: "center",
      render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
  ];


  const shouldShowFooter =
    !chargeableDataWithCount.length > 0 ||
    !nonChargeableData.length > 0 ||
    !leaveData.length > 0 ||
    !appraisalData.length > 0 ||
    !wfhData.length > 0;
  const hasPendingData =
    chargeableDataWithCount.length > 0 ||
    nonChargeableData.length > 0 ||
    leaveData.length > 0 ||
    appraisalData.length > 0 ||
    wfhData.length > 0;

  // The Office Supervisor IS the Primary appraiser — changing it reassigns
  // the Primary role. Warn when that role still has an unreviewed contract,
  // same as the appraiser dropdown in Appraisal Information does.
  const hasOpenPrimaryContract = activeContractRoles.includes("primary");

  const fetchTerminationDetailsForTimesheet = async (values) => {
    setPersonInchargeforPayload(values);
    setUpdateState("basic");
    const oldOfficeSuoervisorId =
      masterUserList?.find(
        (user) => user.employeeid === EmployeeDetails?.OfficeSupervisorId
      )?.userid || "";

    if (!oldOfficeSuoervisorId) {
      return;
    }

    setLoader(true);
    try {
      const apiResponse = await CALL_FEATCH_API(
        `insyts/timesheet/pendingtimesheet?userId=${EmployeeDetails?.userid}&officesupervisorId=${oldOfficeSuoervisorId}`,
        "get"
      );
      const { chargeable, leave, non_chargeable, appraisal, wfh } = apiResponse.response || {};
      const terminatedData = { chargeable, leave, non_chargeable, appraisal, wfh };
      setTerminatedData(terminatedData);

      const timeSheetIds = [
        ...chargeable.map((item) => item.timeSheetId),
        ...non_chargeable.map((item) => item.timeSheetId),
      ];
      setTimeSheetIdsForPost(timeSheetIds);
      if (apiResponse?.response?.code === "SUCCESS") {
        setLoader(false);
        setOfficeSupervisorPopup(true);
      }
    } catch (error) {
      console.error("Error fetching termination details:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleOfficeSupervisorCancel = () => {
    // Revert the field to the currently saved supervisor — the Select's
    // onChange already committed the new value into the form store, so
    // cancelling the "pending items" warning must explicitly undo that.
    form.setFieldsValue({ officesupervisor: EmployeeDetails?.OfficeSupervisorId });
    setFormValues((prev) => ({
      ...prev,
      officesupervisor: EmployeeDetails?.OfficeSupervisorId,
    }));
    setPersonInchargeforPayload({});
    setOfficeSupervisorPopup(false);
  };

  const oldSuopervisorId =
    masterUserList?.find(
      (data) => data?.employeeid === EmployeeDetails?.OfficeSupervisorId
    )?.userid || "";

  // Shared by both the "Proceed" (reassign + save) and "OK" (save only)
  // buttons on the office-supervisor popup - the supervisor must not be
  // changed (nor the profile saved) until the mandatory fields are filled.
  const validateMandatoryFieldsOrNotify = async () => {
    try {
      await form.validateFields();
    } catch (validationError) {
      notification.error({ message: "Please fill the mandatory fields" });
      // Don't allow the office supervisor change to stand when validation
      // fails - revert the field and close the popup, same as Cancel.
      handleOfficeSupervisorCancel();
      return false;
    }
    // The Appraisal Information grid (the "data" state driving the table
    // under "Edit Appraisal Information") lives outside the antd Form, so
    // form.validateFields() above can't see it - run the same checks the
    // main "Update" submit (handlesubmit) runs on it, in the same order.
    if (!handleValidation() || !validateTotalWeightage()) {
      handleOfficeSupervisorCancel();
      return false;
    }
    // Same job-description check handlesubmit runs right after those two.
    const missingPrimaryJobDescriptions = data?.filter((row) => !row?.jobDescriptionId);
    if (missingPrimaryJobDescriptions?.length > 0) {
      message.error("Please add a Job Description for all roles before proceeding.");
      handleOfficeSupervisorCancel();
      return false;
    }
    return true;
  };

  const handleOfficeSupervisorOk = async () => {
    if (!(await validateMandatoryFieldsOrNotify())) return;
    setOfficeSupervisorPopup(false);
    form.submit();
  };

  const handleChangeOfficeSupervisor = async () => {
    // Validate the whole profile form before committing the office
    // supervisor change - otherwise the supervisor gets reassigned via
    // updatepersonincharge even though the subsequent form.submit() below
    // would fail validation and never actually save the profile.
    if (!(await validateMandatoryFieldsOrNotify())) return;
    setProceedLoader(true);
    try {
      const userIdforTermination =
        masterUserList?.find((user) => user.employeeid === personInchargeforPayload)
          ?.userid || "";
      const payload = {
        oldPersonInCharge:
          oldSuopervisorId === "none"
            ? CEO[0]
            : oldSuopervisorId,
        newPersonInCharge:
          userIdforTermination === "none"
            ? CEO[0]
            : userIdforTermination,
        userId: EmployeeDetails?.userid,
        timeSheetIds: timeSheetIdsForPost,
      };
      const response = await CALL_FEATCH_API(
        `insyts/timesheet/updatepersonincharge`,
        "post",
        payload
      );
      const code = response?.response?.code;
      if (code === "SUCCESS") {
        notification.success({
          message: "Success",
          description: "Office Supervisor updated successfully.",
        });
        // Only persist the profile itself (the add-users/<ClientId> PATCH,
        // same as pressing the section's own "Update" submit button) once
        // the reassignment has actually succeeded, and close the popup only
        // once that save has gone through too.
        await handlesubmit();
        setOfficeSupervisorPopup(false);
      } else {
        notification.error({
          message: "Error",
          description:
            response?.response?.message ||
            "Failed to update office supervisor. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error in handleChangeOfficeSupervisor:", error);
      message.error(
        "An error occurred while updating person in charge. Please try again."
      );
    } finally {
      setProceedLoader(false);
    }
  };

  const resetToGradeRole = () => {
    const currentGrade = form.getFieldValue("grade");
    if (currentGrade) {
      const matchedRole = roleListForGrade.find(
        (role) =>
          Array.isArray(role?.jobgrade) &&
          role.jobgrade.includes(currentGrade)
      );
      if (matchedRole) {
        form.setFieldsValue({ roleId: matchedRole.roleId });
        setGradeBasedRole(matchedRole.roleId);
      } else if (gradeBasedRole) {
        form.setFieldsValue({ roleId: gradeBasedRole });
      }
    } else if (gradeBasedRole) {
      form.setFieldsValue({ roleId: gradeBasedRole });
    }
    setOverrideRole(null);
  };

  useEffect(() => {
    if (!roleList?.length || !EmployeeDetails?.roleid) return;

    const currentRoleId = Array.isArray(EmployeeDetails.roleid)
      ? EmployeeDetails.roleid[0]
      : EmployeeDetails.roleid;

    const hrRole = roleList.find((r) => r.roleName === "HR");
    const caRole = roleList.find((r) => r.roleName === "Country Admin");

    if (hrRole && currentRoleId === hrRole.roleId) {
      setOverrideRole("HR");
    } else if (caRole && currentRoleId === caRole.roleId) {
      setOverrideRole("Country Admin");
    } else {
      setOverrideRole(null);
    }
  }, [EmployeeDetails?.roleid, roleList]);

  useEffect(() => {
    if (
      !formReady ||
      !roleList?.length ||
      !roleListForGrade?.length ||
      !EmployeeDetails?.userid
    )
      return;

    // run only once per loaded employee
    if (roleSyncedForUserRef.current === EmployeeDetails.userid) return;

    const grade = EmployeeDetails.grade;
    if (!grade) return;

    const storedRoleId = Array.isArray(EmployeeDetails.roleid)
      ? EmployeeDetails.roleid[0]
      : EmployeeDetails.roleid;

    const storedRole = roleList.find((r) => r.roleId === storedRoleId);

    // HR / Country Admin stored on the user = intentional override, keep it
    const isOverride =
      storedRole && ["HR", "Country Admin"].includes(storedRole.roleName);

    const matchedRole = roleListForGrade.find(
      (role) => Array.isArray(role?.jobgrade) && role.jobgrade.includes(grade)
    );
    if (!matchedRole) return;

    roleSyncedForUserRef.current = EmployeeDetails.userid;

    // remember grade-based role so "reset override" works correctly
    setGradeBasedRole(matchedRole.roleId);

    if (isOverride) return;

    if (matchedRole.roleId !== storedRoleId) {
      form.setFieldsValue({ roleId: matchedRole.roleId });
    }
  }, [formReady, roleList, roleListForGrade, EmployeeDetails, form]);

  return (
    <EditProfileBox>
      <Spin spinning={loader} tip="Loading...">
        {officeSupervisorPopup && (
          <StyledNewModal
            title={
              <div style={{ textAlign: "center" }}>
                {hasPendingData && (
                  <img src={circleWarning} alt="Warning" />
                )}
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "20px",
                    color: "#000",
                    letterSpacing: "0.5px",
                    textTransform: "capitalize",
                    textAlign: hasPendingData ? "center" : "left",
                    marginTop: hasPendingData ? "12px" : "0",
                  }}
                >
                  {hasPendingData ? "Pending Item" : "Changing Office Supervisor"}
                </div>
              </div>
            }
            open={officeSupervisorPopup}
            onCancel={handleOfficeSupervisorCancel}
            footer={[
              <ButtonOutlined key="cancel" disabled={loader} onClick={handleOfficeSupervisorCancel}>
                Cancel
              </ButtonOutlined>,
              hasPendingData ? (
                <ButtonFilled
                  key="proceed"
                  type="primary"
                  disabled={loader}
                  loading={proceedLoader}
                  onClick={handleChangeOfficeSupervisor}
                >
                  {hasOpenPrimaryContract ? "Proceed & Save" : "Proceed"}
                </ButtonFilled>
              ) : (
                <ButtonFilled
                  key="ok"
                  type="primary"
                  disabled={loader}
                  onClick={handleOfficeSupervisorOk}
                >
                  OK
                </ButtonFilled>
              ),
            ]}
            bodyStyle={{
              maxHeight: "400px",
              overflowY: "auto",
              paddingRight: "12px",
            }}
          >
            <Spin spinning={loader}>
              {hasPendingData ? (
                <>
                  {(chargeableDataWithCount.length > 0 || nonChargeableData.length > 0 || leaveData.length > 0 || appraisalData.length > 0 || wfhData.length > 0) && (
                    <>
                      <ol style={{ paddingLeft: 20, margin: 0 }}>
                        {(chargeableDataWithCount.length > 0 || nonChargeableData.length > 0 || leaveData.length > 0 || wfhData.length > 0) && (
                          <li>
                            The current Office Supervisor has{" "}
                            <b>
                              {[
                                (chargeableDataWithCount.length > 0 || nonChargeableData.length > 0) && "pending timesheets",
                                leaveData.length > 0 && "leave requests",
                                wfhData.length > 0 && "Work from Home requests",
                              ]
                                .filter(Boolean)
                                .join(", ")
                                .replace(/, ([^,]*)$/, " & $1")}
                            </b>{" "}
                            to approve for this employee.
                          </li>
                        )}
                        {appraisalData.length > 0 && (
                          <li>
                            There is also an <b>open performance appraisal</b> created by the current supervisor for this employee.
                          </li>
                        )}
                      </ol>
                      <p style={{ marginTop: 12 }}>
                        If you proceed with changing the supervisor, these pending approvals
                        {appraisalData.length > 0 ? " and the open performance appraisal" : ""}
                        {" "}
                        will be transferred to the new supervisor.
                      </p>
                    </>
                  )}
                  <div style={{ padding: "8px 0" }}>
                    {chargeableDataWithCount.length > 0 && (
                      <StyledNewTable
                        pagination={false}
                        columns={columnsDummyData}
                        dataSource={chargeableDataWithCount}
                        rowKey="employeeId"
                        title={() => <b>Chargeable Timesheets</b>}
                      />
                    )}
                    {nonChargeableData.length > 0 && (
                      <StyledNewTable
                        pagination={false}
                        columns={nonChargeableColumns}
                        dataSource={nonChargeableData}
                        rowKey={(record, index) => index}
                        title={() => <b>Non-Chargeable Timesheets</b>}
                      />
                    )}

                    {leaveData.length > 0 && (
                      <StyledNewTable
                        pagination={false}
                        columns={leaveColumns}
                        dataSource={leaveData}
                        rowKey={(record, index) => index}
                        title={() => <b>Leave Approvals</b>}
                      />
                    )}

                    {appraisalData.length > 0 && (
                      <StyledNewTable
                        pagination={false}
                        columns={appraisalColumns}
                        dataSource={appraisalData}
                        rowKey={(record, index) => index}
                        title={() => <b>Open Performance</b>}
                      />
                    )}

                    {wfhData.length > 0 && (
                      <StyledNewTable
                        pagination={false}
                        columns={wfhColumns}
                        dataSource={wfhData}
                        rowKey={(record, index) => index}
                        title={() => <b>Pending Work From Home Requests</b>}
                      />
                    )}
                  </div>
                </>
              ) : hasOpenPrimaryContract ? (
                <p style={{ textAlign: "center" }}>
                  No timesheets or leave pending for this employee.{" "}
                  <b>An active contract exists for this role.</b> Changing the
                  appraiser will transfer the open contract to the new
                  appraiser. Click <b>OK</b> to change the office supervisor.
                </p>
              ) : (
                <p style={{ textAlign: "center" }}>
                  No timesheets or leave pending for this employee. Click <b>OK</b> to
                  change the office supervisor.
                </p>
              )}
            </Spin>
          </StyledNewModal>
        )}
        {updateState === "personalinformation" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {pageName} /{" "}
            </button>
            <b>Edit Personal Information:</b>
            <Form
              className=""
              form={form}
              name="addemployeeform"
              layout="vertical"
              initialValues={{
                user_id: "",
                department_id: "",
                gender: "",
                dateof_birth: "",
                maritalstatus: "",
                nationality: "",
                nssf: "",
                krapin: "",
                housingfundno: "",
                nhif: "",
                helpmonthlybilling: "",
                national_id: "",
                address: "",
                phoneno: "",
                personalemailid: "",
                overtime: "",
                start_date: "",
                emergencycontactname: "",
                emergencycontactnumber: "",
                employementtype: "",
                initial: "",
                first_name: "",
                last_name: "",
                salutation: "",
                dependent: "",
              }}
              onFinish={() => {
                handlesubmit();
              }}
            >
              <StyleRow className="m-1 mt-2" gutter={20}>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="salutation"
                    label="Salutation"
                    placeholder="Select Salutation"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Salutation is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Salutation"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      <Option value="Mr.">Mr.</Option>
                      <Option value="Dr.">Dr.</Option>
                      <Option value="Prof.">Prof.</Option>
                      <Option value="Ms.">Ms.</Option>
                      <Option value="Mrs.">Mrs.</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="initial"
                    label="Initial"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Initial is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Initial"
                      maxLength={5}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="firstname"
                    label="First Name"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "First name is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="First name"
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars =
                          /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="lastname"
                    label="Last Name"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Last name is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Last name"
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars =
                          /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="employeeid"
                  label="Employee ID"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Employee ID is required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Employee ID"
                    maxLength={15}
                    onChange={onFinish}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z0-9\s]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col> */}
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="user_id"
                    label="User ID"
                    rules={[
                      {
                        required: true,
                        message: "Email ID is required",
                      },
                      { validator: validateEmployeeId },
                    ]}
                  >
                    <Input
                      placeholder="Email ID"
                      disabled={true}
                      onChange={onFinish}
                      maxLength={60}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item name="phoneno" label="Phone No">
                    <PhoneInput
                      type="text"
                      placeholder="Phone No"
                      maxLength={20}
                      onChange={onFinish}
                      onKeyDown={(e) => {
                        const value = /^[0-9+]$/?.test(e.key);
                        if (!value && e.key !== "Backspace" && /^[0-9+]$/) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="gender"
                    label="Gender"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Gender is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select gender"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      <Option value="male">Male</Option>
                      <Option value="female">Female</Option>
                      <Option value="They/ Them">They/ Them</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item name="dependent" label="No. of Dependants">
                    <Input
                      placeholder="No. of Dependants"
                      maxLength={10}
                      onKeyDown={(e) => {
                        const value = /^[0-9+]$/?.test(e.key);
                        if (!value && e.key !== "Backspace" && /^[0-9+]$/) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                  {showClientExtras && (
                    <DependantFields
                      form={form}
                      clientId={ClientId}
                      userId={EmployeeDetails?.userid}
                      onChange={onFinish}
                    />
                  )}
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label="Date of Birth"
                    name="dateofbirth"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Date of Birth is required",
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      onChange={() => {
                        onFinish();
                      }}
                      placeholder="Select Date of Birth"
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="maritalstatus"
                    label="Marital Status"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      <Option value="single">Single</Option>
                      <Option value="married">Married</Option>
                      <Option value="widowed">Widowed</Option>
                      <Option value="divorced">Divorced</Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="greetings"
                    label="Greetings"
                    rules={[
                      { required: false, message: "Greetings is required" },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                    >
                      {Greetings?.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="nationality"
                    label="Country"
                    rules={[
                      {
                        required: true,
                        message: "Country is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      onChange={onFinish}
                      getPopupContainer={() => containerRef.current}
                    >
                      {countryList?.map((country, index) => (
                        <Select.Option
                          key={index}
                          value={country}
                          label={country}
                        >
                          {country}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="emergencycontactname"
                    label="Emergency Contact Name"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Emergency Contact Name is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Emergency Contact Name"
                      maxLength={30}
                      onChange={onFinish}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="emergencycontactnumber"
                    label="Emergency Contact Number"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Emergency Contact Name is required",
                      },
                    ]}
                  >
                    <PhoneInput
                      placeholder="Emergency Contact Number"
                      maxLength={20}
                      onChange={onFinish}
                      onKeyDown={(e) => {
                        const value = /^[0-9+]$/?.test(e.key);
                        if (!value && e.key !== "Backspace" && /^[0-9+]$/) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="address"
                    label="Address"
                    rules={[
                      {
                        required: true,
                        message: "Address is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Address"
                      onChange={onFinish}
                      maxLength={60}
                      onKeyDown={(e) => {
                        const value =
                          /^[0-9,/]$/.test(e.key) ||
                          /^[a-zA-Z\s,/]+$/.test(e.key);
                        if (!value && e.key !== "Backspace") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </StyleRow>

              {ClientId !== MAIN_CLIENT_ID && (
                <>
                  <b className="my-2 mx-1">Statutory Information</b>
                  <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="krapin" label={getStatutoryFieldLabel(ClientId, "krapin")}>
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "krapin")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="housingfundno"
                        label={getStatutoryFieldLabel(ClientId, "housingfundno")}
                      >
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "housingfundno")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="nssf" label={getStatutoryFieldLabel(ClientId, "nssf")}>
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "nssf")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="nhif" label={getStatutoryFieldLabel(ClientId, "nhif")}>
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "nhif")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="helpmonthlybilling"
                        label={getStatutoryFieldLabel(ClientId, "helpmonthlybilling")}
                      >
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "helpmonthlybilling")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </StyleRow>
                </>
              )}

              <div className="text-end mt-3">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}
        {updateState === "workinformation" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {pageName} /{" "}
            </button>
            <b>Edit Work Information:</b>
            <Form
              className=""
              form={form}
              name="addemployeeidentityform"
              layout="vertical"
              initialValues={{
                company_Name: "",
                industry: [],
                sector: [],
                secondaryindustry: [],
                industryrole: "",
                expertise: "",
                designation: "",
                immediatesupervisor: "",
                grade: "",
                targetchargeability: "",
                chargeoutrate: "",
                jobtitle: "",
                professionalsince: "",
                hireddate: "",
                employeesponser: "",
                relevent: "",
                maritalstatus: "",
                description: "",
                lastpromotionlevel: "",
                overtime: "",
                lastpromotion: "",
                regionalsupervisor: "",
                regionalcompetencyrole: "",
                officesupervisor: "",
                engagementsupervisor: "",
              }}
              onFinish={() => handlesubmit()}
            >
              <StyleRow className="m-1 mt-2" gutter={20}>
                {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                              <Form.Item
                                name="overtime"
                                label="Overtime Eligible"
                                rules={[
                                  {
                                    required: true,
                                    pattern: NON_EMPTY_REGEX,
                                    message: "This field is required",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select"
                                  getPopupContainer={() => containerRef.current}
                                  onChange={onFinish}
                                >
                                  <Option value="yes">Yes</Option>
                                  <Option value="no">No</Option>
                                </Select>
                              </Form.Item>
                            </Col> */}
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="companyname"
                    label="Contracting Company"
                    rules={[
                      {
                        required: false,
                        message: "Contracting Company is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      onChange={onFinish}
                      getPopupContainer={() => containerRef.current}
                    >
                      {(ClientId === MAIN_CLIENT_ID
                        ? ContractingCompany
                        : AdditionalContractingCompany
                      )?.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="industry"
                    label="Primary Industry"
                    rules={[
                      {
                        required: false,
                        message: "Primary Industry is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      onChange={onFinish}
                      getPopupContainer={() => containerRef.current}
                    >
                      {[
                        ...(Industry || []),
                        ...(ClientId !== MAIN_CLIENT_ID ? AdditionalIndustryList : [])
                      ].map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="secondaryindustry"
                    label="Secondary Industry"
                    rules={[
                      {
                        required: false,
                        message: "Secondary Industry is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      onChange={onFinish}
                      getPopupContainer={() => containerRef.current}
                    >
                      {secondaryIndustry?.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="sector"
                    label="Sector"
                    rules={[
                      {
                        required: false,
                        message: "Sector is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      onChange={onFinish}
                      getPopupContainer={() => containerRef.current}
                    >
                      {Sector?.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="industryrole"
                    label="Industry Role"
                    rules={[
                      {
                        required: false,
                        message: "Industry Role is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      onChange={onFinish}
                      getPopupContainer={() => containerRef.current}
                    >
                      {IndustryRole?.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="regionalsupervisor"
                    label="Regional Competency Supervisor"
                    rules={[
                      {
                        required: false,
                        message: "Regional Competency Supervisor is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      // options={managingOfficeData}
                      allowClear
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                      options={
                        EmployeeDetails?.RegionalSupervisorId === "none"
                          ? [
                            {
                              name: `${EmployeeDetails?.firstname || ""} ${EmployeeDetails?.lastname || ""}`.trim(),
                              employeeId: "none",
                            },
                          ]
                          : supervisorList
                      }
                      fieldNames={{
                        label: "name",
                        value: "employeeId",
                      }}
                      filterOption={(input, option) =>
                        option.name.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="regionalcompetencyrole"
                    label="Regional Competency Role"
                    rules={[
                      {
                        required: false,
                        message: "Regional Competency Role is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                    >
                      {RegionalCometencyRole.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="officesupervisor"
                    label="Office Competency Supervisor"
                    rules={[
                      {
                        required: true,
                        message: "Office Competency Supervisor is required",
                      },
                    ]}
                  >
                    <Select
                      disabled={
                        EmployeeDetails?.OfficeSupervisorId === "none" ||
                        (ClientId === MAIN_CLIENT_ID &&
                          !(userInfo?.managingoffice?.[0] === "Head Office" || userInfo?.roleId === "7"))
                      }
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                      options={
                        EmployeeDetails?.OfficeSupervisorId === "none"
                          ? [
                            {
                              name: `${EmployeeDetails?.firstname || ""} ${EmployeeDetails?.lastname || ""}`.trim(),
                              employeeId:
                                EmployeeDetails?.employeeid ||
                                EmployeeDetails?.employeeId,
                            },
                          ]
                          : supervisorList?.concat([
                            {
                              name: "Null",
                              employeeId: null,
                            },
                          ])
                      }
                      allowClear
                      fieldNames={{
                        label: "name",
                        value: "employeeId",
                      }}
                      filterOption={(input, option) => {
                        return option.name
                          ?.toLowerCase()
                          .includes(input.toLowerCase());
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="engagementsupervisor"
                    label="Secondary Supervisor"
                    rules={[
                      {
                        required: false,
                        message: "Secondary Supervisor is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                      options={supervisorList}
                      fieldNames={{
                        label: "name",
                        value: "employeeId",
                      }}
                      filterOption={(input, option) =>
                        option.name.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="expertise"
                    label="Expertise"
                    rules={[
                      {
                        required: false,
                        message: "Expertise is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Expertise"
                      // maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="designation"
                    label="Designation"
                    rules={[
                      {
                        required: false,
                        message: "Designation is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Designation"
                      maxLength={50}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z0-9\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>

                {/* <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="immediatesupervisor"
                  label="Immediate Supervisor"
                  rules={[
                    {
                      required: false,
                      message: "Immediate Supervisor is required",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Immediate Supervisor"
                    maxLength={50}
                    onKeyDown={(e) => {
                      const allowedChars = /^[a-zA-Z\s]+$/;
                      if (!allowedChars.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={onFinish}
                  />
                </Form.Item>
              </Col> */}

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="grade"
                    label="Grade"
                    rules={[
                      {
                        required: true,
                        message: "Grade is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      onChange={() => {
                        onFinish();
                        setChargeout();
                        setTargetChargeability();
                        // Reset job description for all rows and clear addedJobDescriptions.
                        // Custom Job Description has no link to grade, so skip this in that mode.
                        if (!isCustomJobDescription) {
                          setData((prevData) =>
                            prevData.map((row) => ({
                              ...row,
                              jobdescriptionFileName: "",
                              jobdescriptionFileUrl: "",
                              jobDescriptionId: "",
                              jobdescriptionFileId: "",
                            }))
                          );
                          setAddedJobDescriptions({});
                        }
                      }}
                    >
                      {gradeListData?.map((item) => (
                        <Select.Option key={item.id} value={item.jobgradecode} label={item.jobgradecode}>
                          {item.jobgradecode}
                        </Select.Option>
                      ))}
                    </Select>
                    {/* {Grade?.map((value, index) => (
                      <Select.Option key={index} value={value} label={value}>
                        {value}
                      </Select.Option>
                    ))}
                  </Select> */}
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="chargeoutrate"
                    label="Charge Out Rate"
                    rules={[
                      {
                        required: false,
                        message: "Charge Out Rate is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Charge Out Rate"
                      // maxLength={50}
                      onChange={onFinish}
                      disabled={true}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="targetchargeability"
                    label="Target Chargeability %"
                    rules={[
                      {
                        required: false,
                        message: "Target Chargeability % is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Target Chargeability %"
                      onChange={onFinish}
                      disabled={true}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label="Last Promotion Date"
                    name="lastpromotionlevel"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Last Promotion Date is required",
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      placeholder="Select Last Promotion Date"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="lastpromotion"
                    label="Last Promotion Level"
                    rules={[
                      {
                        required: false,
                        message: "Last Promotion is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Last Promotion"
                      maxLength={100}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="jobtitle"
                    label="Job Title"
                    rules={[
                      {
                        required: true,
                        message: "Job title is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Job Title"
                      maxLength={50}
                      onChange={onFinish}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z0-9\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label="Professional Since"
                    name="professionalsince"
                    rules={[
                      {
                        required: false,
                        pattern: NON_EMPTY_REGEX,
                        message: "Professional Since is required",
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      onChange={onFinish}
                      placeholder="Professional Since"
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    label="Hired Date"
                    name="hireddate"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Hired Date is required",
                      },
                    ]}
                  >
                    <DatePicker
                      className="w-100"
                      format="DD-MM-YYYY"
                      onChange={onFinish}
                      placeholder="Select Hired Date"
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="employeesponser"
                    label="Employee Sponsor"
                    rules={[
                      {
                        required: ClientId === MAIN_CLIENT_ID,
                        pattern: NON_EMPTY_REGEX,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      <Option value="yes">Yes</Option>
                      <Option value="no">No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="status_id"
                    label="Status"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      getPopupContainer={() => containerRef.current}
                      onChange={(value) => {
                        setEmployeeStatusId(value === "active" ? "1" : "0");
                        onFinish();
                      }}
                    >
                      <Option value="active">Active</Option>
                      <Option value="in active">In active</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="relevent"
                    label="Relevant"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      <Option value="yes">Yes</Option>
                      <Option value="no">No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea
                      onChange={onFinish}
                      placeholder="description"
                    />
                  </Form.Item>
                </Col>
              </StyleRow>
              <div className="text-end mt-3">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}
        {updateState === "level" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              <ArrowForwardIosIcon style={iconsize} /> Back
            </button>
            <b>Level:</b>
            <Form
              className=""
              form={form}
              name="addemployeelevelform"
              layout="vertical"
              initialValues={{
                competencyQC: [],
                serviceline: [],
                subserviceline: [],
                competencyrole: [],
                managingoffice: [],
                organisationlevel: [],
              }}
              onFinish={() => handlesubmit()}
            >
              <StyleRow gutter={20}>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="managingoffice"
                    label="Country"
                    rules={[
                      {
                        required: true,
                        message: "Country is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      options={managingOfficeData}
                      fieldNames={{
                        label: "value",
                        value: "value",
                      }}
                      getPopupContainer={() => containerRef.current}
                      onChange={() => {
                        onFinish();
                        competencyQCfetchData();
                      }}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                <Form.Item
                  name="organisationlevel"
                  label="Organisation Level"
                  rules={[
                    {
                      required: true,
                      message: "Organisation Level is required",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    mode="multiple"
                    getPopupContainer={() => containerRef.current}
                    disabled={form.getFieldValue('managingoffice')?.length == 0}
                    options={organisationLevelData}
                    fieldNames={{
                      label: "value",
                      value: "value",
                    }}
                    onChange={() => {
                      onFinish();
                      competencyQCfetchData();
                    }}
                  />
                </Form.Item>
              </Col> */}
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="competencyQC"
                    label="Competency/ QC"
                    rules={[
                      {
                        required: true,
                        message: "Competency/ QC is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      getPopupContainer={() => containerRef.current}
                      disabled={competencyQCData?.length == 0}
                      options={competencyQCData}
                      fieldNames={{
                        label: "value",
                        value: "value",
                      }}
                      onChange={() => {
                        onFinish();
                        servicelinefetchData();
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="serviceline"
                    label="Service Line"
                    rules={[
                      {
                        required: true,
                        message: "Service Line is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      getPopupContainer={() => containerRef.current}
                      disabled={servicelineData?.length === 0}
                      options={servicelineData}
                      fieldNames={{
                        label: "value",
                        value: "value",
                      }}
                      onChange={() => {
                        onFinish();
                        subservicelinefetchData();
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="subserviceline"
                    label="Sub Serviceline"
                    rules={[
                      {
                        required: true,
                        message: "Sub Serviceline is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      getPopupContainer={() => containerRef.current}
                      disabled={subservicelineData?.length == 0}
                      options={subservicelineData}
                      fieldNames={{
                        label: "value",
                        value: "value",
                      }}
                      onChange={() => {
                        onFinish();
                        departmentfetchData();
                        // competencyrolefetchData();
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="leveldepartmentname"
                    label="Department"
                    rules={[
                      {
                        required: true,
                        message: "Department is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      mode="multiple"
                      getPopupContainer={() => containerRef.current}
                      disabled={subservicelineData?.length == 0}
                      options={departmentLevelData}
                      fieldNames={{
                        label: "value",
                        value: "value",
                      }}
                      onChange={() => {
                        // competencyrolefetchData();
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="competencyrole"
                    label="Office Competency Role"
                    rules={[
                      {
                        required: false,
                        message: "Office Competency Role is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      {CompetencyRole?.map((value, index) => (
                        <Select.Option key={index} value={value} label={value}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="supervisor"
                  label="Supervisor / Manager"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Supervisor/Manager is required",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    getPopupContainer={() => containerRef.current}
                    onChange={onFinish}
                    options={supervisorList}
                    fieldNames={{
                      label: "name",
                      value: "employeeId",
                    }}
                    filterOption={(input, option) =>
                      option.name.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col> */}

                {/* <Col xs={24} sm={24} md={12}>
                              <Form.Item
                                name="manager"
                                label="Manager"
                                rules={[
                                  {
                                    required: true,
                                    pattern: NON_EMPTY_REGEX,
                                    message: "Manager is required",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  placeholder="Search to Select"
                                  optionFilterProp="children"
                                  getPopupContainer={() => containerRef.current}
                                  onChange={onFinish}
                                >
                                  {filteredUserName?.map((value, index) => (
                                    <Option key={index} value={value} label={value}>
                                      {value}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col> */}
              </StyleRow>
              <div className="text-end mt-3">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}
        {updateState === "basic" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {" "}
              {pageName} /
            </button>{" "}
            <b>Edit Employee</b>
            <Tabs
              defaultActiveKey={activeTab}
              className="mt-3"
              onChange={handleTabChange}
            >
              {tabTitles.map((title, index) => (
                <TabPane tab={title} key={index.toString()}>
                  {activeTab === "0" && (
                    <>
                      <Form
                        className=""
                        form={form}
                        name="addemployeeform"
                        layout="vertical"
                        initialValues={{
                          managingoffice: [],
                          competencyQC: [],
                          serviceline: [],
                          subserviceline: [],
                          leveldepartmentname: [],
                          competencyrole: [],
                          levellocationid: "",
                          supervisor: "",
                          companyname: "",
                          industry: [],
                          secondaryindustry: [],
                          sector: [],
                          expertise: "",
                          industryrole: [],
                          regionalsupervisor: "",
                          regionalcompetencyrole: "",
                          officesupervisor: "",
                          engagementsupervisor: "",
                          designation: "",
                          grade: "",
                          targetchargeability: "",
                          chargeoutrate: "",
                          lastpromotionlevel: "",
                          lastpromotion: "",
                          jobtitle: "",
                          professionalsince: "",
                          hireddate: "",
                          employeesponser: "",
                          employee_status: "",
                          firstname: "",
                          lastname: "",
                          salutation: "",
                          othernames: "",
                          dateofbirth: "",
                          gender: "",
                          dependent: "",
                          maritalstatus: "",
                          phoneno: "",
                          personalemailid: "",
                          user_id: "",
                          postaladdress: "",
                          physicaladdress: "",
                          password: "",
                          country: "",
                          greetings: "",
                          national_id: "",
                          nationality: "",
                          workpermitno: "",
                          workpermitexpirydate: "",
                          emergencycontactname: "",
                          emergencycontactnumber: "",
                          nextofkinrelationship: "",
                          nextofkinpostaladdress: "",
                        }}
                        onFinish={() => {
                          handlesubmit();
                        }}
                      >
                        <b className="mt-2">Edit Level Information:</b>
                        <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="managingoffice"
                              label="Country"
                              rules={[
                                {
                                  required: true,
                                  message: "Country is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                // optionFilterProp="children"
                                //   mode="multiple"
                                options={managingOfficeData}
                                fieldNames={{
                                  label: "value",
                                  value: "value",
                                }}
                                getPopupContainer={() => containerRef.current}
                                onChange={(value) => {
                                  form.setFieldValue("levellocationid", undefined);
                                  setFormValues({
                                    ...formValues,
                                    managingoffice: value,
                                  });
                                  setManagingCountry(value);
                                  onFinish();
                                  competencyQCfetchData();

                                  const countryLocations = locationList?.filter(
                                    (loc) =>
                                      loc.login_from_anywhere !== 1 &&
                                      loc.country?.toLowerCase().trim() === value?.toLowerCase().trim()
                                  );
                                  const uniqueLocations = uniqBy(countryLocations, "location_name");

                                  if (uniqueLocations?.length > 0) {
                                    const newLocationId = uniqueLocations[0].location_id;
                                    form.setFieldValue("levellocationid", newLocationId);
                                    form.setFieldValue("baselocationid", newLocationId);
                                    setBaseLocation(newLocationId);
                                    setFormValues((prev) => ({
                                      ...prev,
                                      managingoffice: value,
                                      levellocationid: newLocationId,
                                      baselocationid: newLocationId,
                                    }));
                                  } else {
                                    form.setFieldValue("baselocationid", undefined);
                                    setBaseLocation("");
                                    setFormValues((prev) => ({
                                      ...prev,
                                      managingoffice: value,
                                      baselocationid: undefined,
                                    }));
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="competencyQC"
                              label="Competency/ QC"
                              rules={[
                                {
                                  required: true,
                                  message: "Competency/ QC is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                // mode="multiple"
                                getPopupContainer={() => containerRef.current}
                                disabled={competencyQCData?.length == 0}
                                options={competencyQCData}
                                fieldNames={{
                                  label: "value",
                                  value: "value",
                                }}
                                onChange={() => {
                                  onFinish();
                                  servicelinefetchData();
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="serviceline"
                              label="Service Line"
                              rules={[
                                {
                                  required: true,
                                  message: "Service Line is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                // optionFilterProp="children"
                                mode="multiple"
                                getPopupContainer={() => containerRef.current}
                                disabled={servicelineData?.length === 0}
                                options={servicelineData}
                                fieldNames={{
                                  label: "value",
                                  value: "value",
                                }}
                                onChange={() => {
                                  onFinish();
                                  subservicelinefetchData();
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="subserviceline"
                              label="Sub Serviceline"
                              rules={[
                                {
                                  required:
                                    subservicelineData &&
                                    subservicelineData.length > 0,
                                  message: "Sub Serviceline is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                // optionFilterProp="children"
                                mode="multiple"
                                getPopupContainer={() => containerRef.current}
                                disabled={subservicelineData?.length === 0}
                                options={subservicelineData}
                                fieldNames={{
                                  label: "value",
                                  value: "value",
                                }}
                                onChange={() => {
                                  onFinish();
                                  departmentfetchData();
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="leveldepartmentname"
                              label="Department"
                              rules={[
                                {
                                  required: true,
                                  message: "Department is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Department"
                                // optionFilterProp="children"
                                mode="multiple"
                                getPopupContainer={() => containerRef.current}
                                disabled={departmentLevelData?.length === 0}
                                options={departmentLevelData}
                                fieldNames={{
                                  label: "value",
                                  value: "value",
                                }}
                                onChange={() => {
                                  onFinish();
                                  // competencyrolefetchData();
                                }}
                              />
                            </Form.Item>
                          </Col>
                          {/* )} */}

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="competencyrole"
                              label="Competency Role"
                              rules={[
                                {
                                  required: false,
                                  message: "Competency Role is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                mode="multiple"
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                getPopupContainer={() => containerRef.current}
                                onChange={onFinish}
                              >
                                {CompetencyRole?.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={12} md={3} ref={containerRef}>
                            <Form.Item name="subCluster" label="Sub Cluster">
                              <Checkbox
                                checked={formValues?.subCluster}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setFormValues({
                                    ...formValues,
                                    subCluster: checked,
                                  });
                                  form.setFieldValue("subCluster", checked);

                                  if (!checked) {
                                    form.setFieldValue("subClusterList", []); // Clear selection only when unchecking
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          {form.getFieldValue("subCluster") && (
                            <Col xs={24} sm={24} md={6} ref={containerRef}>
                              <Form.Item
                                name="subClusterList"
                                label="Sub Cluster Countries"
                                rules={[
                                  {
                                    validator: (_, value) => {
                                      if (!value || value?.length < 1) {
                                        return Promise.reject(
                                          new Error("Please select at least one sub cluster country")
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  },
                                ]}
                              >
                                <Select
                                  mode="multiple"
                                  placeholder="Select Sub Cluster Countries"
                                  optionFilterProp="children"
                                  style={{ width: "100%" }}
                                  maxTagCount="responsive"
                                  // ✅ Make selected country non-removable
                                  tagRender={(props) => {
                                    const { label, value, closable, onClose } = props;
                                    const selectedCountry = form.getFieldValue("managingoffice");
                                    const primaryCountry = Array.isArray(selectedCountry) ? selectedCountry[0] : selectedCountry;
                                    const isMainCountry = value === primaryCountry;

                                    return (
                                      <span
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          padding: "0 7px",
                                          marginRight: 3,
                                          backgroundColor: isMainCountry ? "#e6f7ff" : "#fafafa",
                                          border: "1px solid #d9d9d9",
                                          borderRadius: 2,
                                          fontSize: 14,
                                        }}
                                      >
                                        {label}
                                        {!isMainCountry && closable && (
                                          <span
                                            onClick={onClose}
                                            style={{
                                              marginLeft: 5,
                                              cursor: "pointer",
                                              fontSize: 12,
                                            }}
                                          >
                                            ×
                                          </span>
                                        )}
                                      </span>
                                    );
                                  }}
                                >
                                  {managingOfficeData
                                    ?.filter((item) => {
                                      const value = item.value?.trim().toLowerCase();
                                      const primaryCountryValue = primaryCountry?.trim().toLowerCase();
                                      return (
                                        value !== "head office" &&
                                        value !== "ghana" &&
                                        value !== primaryCountryValue
                                      );
                                    })
                                    .map((item) => (
                                      <Select.Option key={item.value} value={item.value}>
                                        {item.value}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          )}
                          {/* <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            name="supervisor"
                            label="Supervisor / Manager"
                            rules={[
                              {
                                required: false,
                                pattern: NON_EMPTY_REGEX,
                                message: "Supervisor / Manager is required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder="Search to Select"
                              optionFilterProp="children"
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                              options={supervisorList}
                              fieldNames={{
                                label: "name",
                                value: "employeeId",
                              }}
                              filterOption={(input, option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            />
                          </Form.Item>
                        </Col> */}
                        </StyleRow>
                        <b className="my-2">Edit Work Information:</b>
                        <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="companyname"
                              label="Contracting Company"
                              rules={[
                                {
                                  required: false,
                                  message: "Contracting Company is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                getPopupContainer={() => containerRef.current}
                                onChange={onFinish}
                              >
                                {(ClientId === MAIN_CLIENT_ID
                                  ? ContractingCompany
                                  : AdditionalContractingCompany
                                )?.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="industry"
                              label="Primary Industry"
                              rules={[
                                {
                                  required: true,
                                  message: "Primary Industry is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                getPopupContainer={() => containerRef.current}
                                onChange={onFinish}
                              >
                                {[
                                  ...(Industry || []),
                                  ...(ClientId !== MAIN_CLIENT_ID ? AdditionalIndustryList : [])
                                ].map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="secondaryindustry"
                              label="Secondry Industry"
                              rules={[
                                {
                                  required: false,
                                  message: "Secondry Industry is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                mode="multiple"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {secondaryIndustry?.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col> */}
                          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="sector"
                              label="Sector"
                              rules={[
                                {
                                  required: false,
                                  message: "Sector is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                mode="multiple"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {Sector?.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col> */}
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="expertise"
                              label="Expertise"
                              rules={[
                                {
                                  required: false,
                                  message: "Expertise is required",
                                },
                              ]}
                            >
                              <Input
                                type="text"
                                placeholder="Expertise"
                                // maxLength={500}
                                onKeyDown={(e) => {
                                  const allowedChars = /^[a-zA-Z\s]+$/;
                                  if (!allowedChars.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="industryrole"
                              label="Industry Role"
                              rules={[
                                {
                                  required: false,
                                  message: "Industry Role is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {IndustryRole?.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="regionalsupervisor"
                              label="Regional Competency Supervisor"
                              rules={[
                                {
                                  required: false,
                                  message:
                                    "Regional Competency Supervisor is required",
                                },
                              ]}
                            >
                              <Select
                                disabled={
                                  EmployeeDetails?.userid ===
                                  CEO[0]
                                }
                                showSearch
                                allowClear
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                getPopupContainer={() => containerRef.current}
                                options={
                                  EmployeeDetails?.RegionalSupervisorId === "none"
                                    ? [
                                      {
                                        name: `${EmployeeDetails?.firstname || ""} ${EmployeeDetails?.lastname || ""}`.trim(),
                                        employeeId: "none",
                                      },
                                    ]
                                    : supervisorList
                                }
                                fieldNames={{
                                  label: "name",
                                  value: "employeeId",
                                }}
                                onChange={onFinish}
                                filterOption={(input, option) =>
                                  option.name
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="regionalcompetencyrole"
                              label="Regional Competency Role"
                              rules={[
                                {
                                  required: false,
                                  message: "Regional Competency Role is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {RegionalCometencyRole.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="officesupervisor"
                              label="Office Competency Supervisor"
                              tooltip={{
                                title: `This list only shows supervisors based in this employee's own country, plus any countries selected in Sub Cluster Countries above${ClientId === MAIN_CLIENT_ID
                                  ? ", and who hold an eligible grade (C3, C4, M1, M2, P1-P5)"
                                  : ""
                                  }.`,
                                icon: <QuestionCircleOutlined style={{ cursor: "pointer" }} />,
                              }}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Office Competency Supervisor is required",
                                },
                              ]}
                            >
                              <Select
                                disabled={
                                  EmployeeDetails?.userid === CEO[0] ||
                                  EmployeeDetails?.OfficeSupervisorId === "none" ||
                                  (ClientId === MAIN_CLIENT_ID &&
                                    !(userInfo?.managingoffice?.[0] === "Head Office" || userInfo?.roleId === "7"))
                                }
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                clearIcon={null}
                                value={form.getFieldValue("officesupervisor")}  // ✅ Add this for controlled behavior
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                options={officeSupervisorOptions}
                                fieldNames={{ label: "name", value: "employeeId" }}
                                onChange={(value) => {
                                  setFormValues((prev) => ({
                                    ...prev,
                                    officesupervisor: value,
                                  }));
                                  fetchTerminationDetailsForTimesheet(value);
                                }}
                                filterOption={(input, option) =>
                                  option.name?.toLowerCase().includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="engagementsupervisor"
                              label="Secondary Supervisor"
                              rules={[
                                {
                                  required: false,
                                  message: "Secondary Supervisor is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                getPopupContainer={() => containerRef.current}
                                options={officeSupervisorOptions}
                                fieldNames={{
                                  label: "name",
                                  value: "employeeId",
                                }}
                                onChange={onFinish}
                                filterOption={(input, option) =>
                                  option.name
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center", // ✅ FIXED (was flex-end)
                                justifyContent: "space-between",
                                gap: "16px",
                                width: "100%",
                              }}
                            >
                              {/* ✅ LEFT: Grade */}
                              <div style={{ flex: 1 }}>
                                <Form.Item
                                  name="grade"
                                  label="Grade"
                                  rules={[{ required: true, message: "Grade is required" }]}
                                  style={{ marginBottom: 0 }} // ✅ IMPORTANT
                                >
                                  <Select
                                    showSearch
                                    placeholder="Search to Select"
                                    options={gradeOptions}
                                    getPopupContainer={() => containerRef.current}
                                    onChange={(gradeValue, option) => {
                                      setOverrideRole(null);

                                      if (originalDesignationRef.current === null) {
                                        originalDesignationRef.current = form.getFieldValue("designation") || "";
                                      }

                                      const newDesignation = option?.designation || "";
                                      const newJobTitle = option?.jobgrade || "";

                                      const hasOriginalGrade =
                                        originalGradeRef.current !== null &&
                                        originalGradeRef.current !== undefined &&
                                        originalGradeRef.current !== "";

                                      const isBackToOriginalGrade =
                                        hasOriginalGrade && gradeValue === originalGradeRef.current;

                                      // A default/new employee with no grade history has nothing to promote
                                      // FROM, so assigning any grade here is not a promotion — it must not
                                      // stamp today's date. Only a genuine change away from a KNOWN prior
                                      // grade counts as a promotion.
                                      if (isBackToOriginalGrade || !hasOriginalGrade) {
                                        gradeChangedRef.current = false;
                                        promotionPayloadRef.current = {
                                          oldpromotionallevel: "",
                                          servedfrom: "",
                                          servedto: "",
                                        };

                                        const restoredDate = hasOriginalGrade
                                          ? originalLastPromotionDateRef.current
                                          : null;
                                        const restoredLevel = hasOriginalGrade
                                          ? originalLastPromotionLevelRef.current
                                          : "";

                                        form.setFieldsValue({
                                          grade: gradeValue,
                                          designation: newDesignation,
                                          targetchargeability: option?.targetchargeability || 0,
                                          chargeoutrate: option?.rate || 0,
                                          jobtitle: newJobTitle,
                                          lastpromotion: restoredLevel,
                                          lastpromotionlevel: restoredDate,
                                        });

                                        setFormValues((prev) => ({
                                          ...prev,
                                          grade: gradeValue,
                                          designation: newDesignation,
                                          targetchargeability: option?.targetchargeability || 0,
                                          chargeoutrate: option?.rate || 0,
                                          jobtitle: newJobTitle,
                                          lastpromotion: restoredLevel,
                                          lastpromotionlevel: restoredDate,
                                        }));
                                      } else {
                                        gradeChangedRef.current = true;

                                        const today = moment().format("YYYY-MM-DD");
                                        const previousServedTo = promotionPayloadRef.current.servedto;
                                        const hiredDate = form.getFieldValue("hireddate")
                                          ? moment(form.getFieldValue("hireddate")).format("YYYY-MM-DD")
                                          : moment().format("YYYY-MM-DD");

                                        const servedfrom = previousServedTo || hiredDate;

                                        promotionPayloadRef.current = {
                                          oldpromotionallevel: originalDesignationRef.current,
                                          servedfrom,
                                          servedto: today,
                                        };

                                        const existingRawDate = form.getFieldValue("lastpromotionlevel");
                                        const existingPromoDate =
                                          existingRawDate && moment(existingRawDate).isValid()
                                            ? moment(existingRawDate)
                                            : moment();

                                        form.setFieldsValue({
                                          grade: gradeValue,
                                          designation: newDesignation,
                                          targetchargeability: option?.targetchargeability || 0,
                                          chargeoutrate: option?.rate || 0,
                                          jobtitle: newJobTitle,
                                          lastpromotion: originalDesignationRef.current,
                                          lastpromotionlevel: existingPromoDate,
                                        });

                                        setFormValues((prev) => ({
                                          ...prev,
                                          grade: gradeValue,
                                          designation: newDesignation,
                                          targetchargeability: option?.targetchargeability || 0,
                                          chargeoutrate: option?.rate || 0,
                                          jobtitle: newJobTitle,
                                          lastpromotion: originalDesignationRef.current,
                                          lastpromotionlevel: existingPromoDate,
                                        }));
                                      }

                                      const matchedRole = roleListForGrade.find(
                                        (role) => Array.isArray(role?.jobgrade) && role.jobgrade.includes(gradeValue)
                                      );

                                      if (matchedRole) {
                                        setGradeBasedRole(matchedRole.roleId);
                                        form.setFieldsValue({ roleId: matchedRole.roleId });
                                      }

                                      setChargeout(gradeValue);
                                      setTargetChargeability(gradeValue);

                                      // Custom Job Description has no link to grade, so skip this reset in that mode.
                                      if (!isCustomJobDescription) {
                                        setData((prevData) =>
                                          prevData.map((row) => ({
                                            ...row,
                                            jobdescriptionFileName: "",
                                            jobdescriptionFileUrl: "",
                                            jobDescriptionId: "",
                                            jobdescriptionFileId: "",
                                          }))
                                        );

                                        setAddedJobDescriptions({});
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </div>

                              {/* ✅ RIGHT: Override */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center", // ✅ align vertically
                                  gap: "4px",
                                  minWidth: "240px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "13px",
                                    color: "#969696",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  Override Role - Permission

                                  <Tooltip
                                    title="Use this option only if the employee is HR or Country Admin, as these roles do not follow Job grades and mapped Role-Permission"
                                    color="#273a2e"
                                    overlayInnerStyle={{
                                      color: "#fff",
                                      fontSize: "12px",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "50%",
                                        background: "#22c55e",
                                        color: "#fff",
                                        fontSize: "11px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      i
                                    </span>
                                  </Tooltip>
                                </span>

                                <Radio.Group value={overrideRole}>
                                  <Radio
                                    value="HR"
                                    onClick={() => {
                                      if (overrideRole === "HR") {
                                        resetToGradeRole();
                                      } else {
                                        const hrRole = roleList.find(r => r.roleName === "HR");
                                        form.setFieldsValue({ roleId: hrRole?.roleId });
                                        setOverrideRole("HR");
                                      }
                                    }}
                                  >
                                    HR
                                  </Radio>

                                  <Radio
                                    value="Country Admin"
                                    onClick={() => {
                                      if (overrideRole === "Country Admin") {
                                        resetToGradeRole();
                                      } else {
                                        const caRole = roleList.find(r => r.roleName === "Country Admin");
                                        form.setFieldsValue({ roleId: caRole?.roleId });
                                        setOverrideRole("Country Admin");
                                      }
                                    }}
                                  >
                                    Country Admin
                                  </Radio>
                                </Radio.Group>
                              </div>
                            </div>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="designation"
                              label="Designation"
                              rules={[
                                {
                                  required: false,
                                  message: "Designation is required",
                                },
                              ]}
                            >
                              <Input
                                disabled
                                type="text"
                                placeholder="Designation"
                                maxLength={50}
                              // onKeyDown={(e) => {
                              //   const allowedChars = /^[a-zA-Z\s]+$/;
                              //   if (!allowedChars.test(e.key)) {
                              //     e.preventDefault();
                              //   }
                              // }}
                              // onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="chargeoutrate"
                              label="Charge Out Rates"
                              rules={[
                                {
                                  required: false,
                                  message: "Charge Out Rate is required",
                                },
                              ]}
                            >
                              <Input
                                type="text"
                                placeholder="Charge Out Rate"
                                maxLength={50}
                                onChange={onFinish}
                                onKeyDown={allowOnlyNumbers}
                                disabled={true}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="targetchargeability"
                              label="Target Chargeability %"
                              rules={[
                                {
                                  required: false,
                                  message: "Target Chargeability % is required",
                                },
                              ]}
                            >
                              <Input
                                type="text"
                                placeholder="Target Chargeability %"
                                maxLength={50}
                                onChange={onFinish}
                                disabled={true}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item

                              label="Last Promotion Date"
                              name="lastpromotionlevel"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Last Promotion Date is required",
                                },
                              ]}
                            >
                              <DatePicker
                                disabled
                                className="w-100"
                                format="DD-MM-YYYY"
                                placeholder="Select Last Promotion Date"
                                getPopupContainer={() => containerRef.current}
                                onChange={(date) => {
                                  const currentDesignation = form.getFieldValue("designation") || "";
                                  form.setFieldsValue({
                                    lastpromotion: currentDesignation,
                                  });
                                  // ✅ Update formValues state too
                                  setFormValues((prev) => ({
                                    ...prev,
                                    lastpromotionlevel: date,
                                    lastpromotion: currentDesignation,
                                  }));
                                  onFinish();
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="lastpromotion"    // ← Fixed: matches payload key and formValues key
                              label="Last Promotional Level"
                              rules={[{ required: false, message: "Last Promotion is required" }]}
                            >
                              <Input
                                disabled
                                type="text"
                                placeholder="Last Promotion"
                                maxLength={100}
                                onChange={(e) => {
                                  setFormValues((prev) => ({
                                    ...prev,
                                    lastpromotion: e.target.value,
                                  }));
                                  onFinish();
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="jobtitle"
                              label="Job Title"
                              rules={[
                                {
                                  required: false,
                                  message: "Job title is required",
                                },
                              ]}
                            >
                              <Input
                                disabled
                                type="text"
                                placeholder="Job Title"
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              label="Professional Since"
                              name="professionalsince"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Professional Since is required",
                                },
                              ]}
                            >
                              <DatePicker
                                className="w-100"
                                format="DD-MM-YYYY"
                                onChange={onFinish}
                                placeholder="Professional Since"
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              label="Hired Date"
                              name="hireddate"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Hired Date is required",
                                },
                              ]}
                            >
                              <DatePicker
                                className="w-100"
                                format="DD-MM-YYYY"
                                onChange={onFinish}
                                placeholder="Select Hired Date"
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="employeesponser"
                              label="Employee Sponsor"
                              rules={[
                                {
                                  required: ClientId === MAIN_CLIENT_ID,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                <Option value="yes">Yes</Option>
                                <Option value="no">No</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="employee_status"
                              label="Status"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Select
                                disabled
                                placeholder="Select"
                                getPopupContainer={() => containerRef.current}
                                onChange={(value) =>
                                  setEmployeeStatusId(
                                    value === "active" ? "1" : "0"
                                  )
                                }
                              >
                                <Option value="active">Active</Option>
                                <Option value="in active">In active</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              label="Role Name"
                              name="roleId"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Please Select",
                                },
                              ]}
                            >
                              <Select
                                disabled
                                placeholder="Select Role"
                                name="roleId"
                                options={roleOptions}
                                fieldNames={{
                                  label: "roleName",
                                  value: "roleId",
                                }}
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>
                        </StyleRow>

                        <b className="my-2">Edit Personal Information:</b>
                        <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="firstname"
                              label="First Name"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "First name is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="First name"
                                maxLength={50}
                                onKeyDown={(e) => {
                                  const allowedChars =
                                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                                  if (!allowedChars.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="lastname"
                              label="Last Name"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Last name is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Last name"
                                maxLength={50}
                                onKeyDown={(e) => {
                                  const allowedChars =
                                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                                  if (!allowedChars.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="salutation"
                              label="Salutation"
                              placeholder="Select Salutation"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Salutation is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Salutation"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                <Option value="Mr.">Mr.</Option>
                                <Option value="Dr.">Dr.</Option>
                                <Option value="Prof.">Prof.</Option>
                                <Option value="Ms.">Ms.</Option>
                                <Option value="Mrs.">Mrs.</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="othernames"
                              label="Other Names"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Other names is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Other name"
                                maxLength={50}
                                onKeyDown={(e) => {
                                  const allowedChars =
                                    /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
                                  if (!allowedChars.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              label="Date of Birth"
                              name="dateofbirth"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Date of Birth is required",
                                },
                              ]}
                            >
                              <DatePicker
                                className="w-100"
                                format="DD-MM-YYYY"
                                onChange={() => {
                                  onFinish();
                                }}
                                placeholder="Select Date of Birth"
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="gender"
                              label="Gender"
                              rules={[
                                {
                                  required: true,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Gender is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select gender"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                <Option value="male">Male</Option>
                                <Option value="female">Female</Option>
                                <Option value="They/ Them">They/ Them</Option>
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item name="dependent" label="No. of Dependants">
                              <Input
                                placeholder="No. of Dependants"
                                maxLength={10}
                                onKeyDown={(e) => {
                                  const value = /^[0-9+]$/?.test(e.key);
                                  if (
                                    !value &&
                                    e.key !== "Backspace" &&
                                    /^[0-9+]$/
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>

                            {showClientExtras && (
                              <DependantFields
                                form={form}
                                clientId={ClientId}
                                userId={EmployeeDetails?.userid}
                                onChange={onFinish}
                              />
                            )}
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="maritalstatus"
                              label="Marital Status"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                <Option value="single">Single</Option>
                                <Option value="married">Married</Option>
                                <Option value="widowed">Widowed</Option>
                                <Option value="divorced">Divorced</Option>
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item name="phoneno" label="Mobile Number">
                              <PhoneInput
                                placeholder="Mobile Number"
                                maxLength={20}
                                onKeyDown={(e) => {
                                  const value = /^[0-9+]$/?.test(e.key);
                                  if (
                                    !value &&
                                    e.key !== "Backspace" &&
                                    /^[0-9+]$/
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="personalemailid"
                              label="Personal Email ID"
                              rules={[
                                {
                                  required: true,
                                  message: "Personal Email ID is required",
                                },
                                {
                                  pattern:
                                    /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                  message: "Please enter a valid email address",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Personal Email ID"
                                maxLength={60}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="postaladdress"
                              label="Postal address"
                              rules={[
                                {
                                  required: false,
                                  message: "Postal address is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Postal address"
                                maxLength={60}
                                onKeyDown={(e) => {
                                  const value =
                                    /^[0-9,/]$/.test(e.key) ||
                                    /^[a-zA-Z\s,/]+$/.test(e.key);
                                  if (!value && e.key !== "Backspace") {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="physicaladdress"
                              label="Physical address"
                              rules={[
                                {
                                  required: false,
                                  message:
                                    "Physical Physical Address is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Physical address"
                                maxLength={60}
                                onKeyDown={(e) => {
                                  const value =
                                    /^[0-9,/]$/.test(e.key) ||
                                    /^[a-zA-Z\s,/]+$/.test(e.key);
                                  if (!value && e.key !== "Backspace") {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="country"
                              label="Country"
                              rules={[
                                {
                                  required: false,
                                  message: "Country is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {countryList?.map((country, index) => (
                                  <Select.Option
                                    key={index}
                                    value={country}
                                    label={country}
                                  >
                                    {country}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="greetings"
                              label="Greetings"
                              rules={[
                                {
                                  required: false,
                                  message: "Greetings is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {Greetings?.map((value, index) => (
                                  <Select.Option
                                    key={index}
                                    value={value}
                                    label={value}
                                  >
                                    {value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="national_id"
                              label="National ID/Passport Number"
                            >
                              <Input
                                placeholder="National ID/Passport Number"
                                maxLength={20}
                                onKeyDown={(e) => {
                                  const value =
                                    /^[0-9]$/?.test(e.key) ||
                                    /^[a-zA-Z\s]+$/?.test(e.key);
                                  if (
                                    !value &&
                                    e.key !== "Backspace" &&
                                    /^[0-9]$/
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          {ClientId !== MAIN_CLIENT_ID && (
                            <>
                              <Col xs={24} sm={24} md={12}>
                                <Form.Item name="krapin" label={getStatutoryFieldLabel(ClientId, "krapin")}>
                                  <Input
                                    placeholder={getStatutoryFieldLabel(ClientId, "krapin")}
                                    maxLength={20}
                                    onKeyDown={(e) => {
                                      const value =
                                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={onFinish}
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} sm={24} md={12}>
                                <Form.Item
                                  name="housingfundno"
                                  label={getStatutoryFieldLabel(ClientId, "housingfundno")}
                                >
                                  <Input
                                    placeholder={getStatutoryFieldLabel(ClientId, "housingfundno")}
                                    maxLength={20}
                                    onKeyDown={(e) => {
                                      const value =
                                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={onFinish}
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} sm={24} md={12}>
                                <Form.Item name="nssf" label={getStatutoryFieldLabel(ClientId, "nssf")}>
                                  <Input
                                    placeholder={getStatutoryFieldLabel(ClientId, "nssf")}
                                    maxLength={20}
                                    onChange={onFinish}
                                    onKeyDown={(e) => {
                                      const value =
                                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} sm={24} md={12}>
                                <Form.Item name="nhif" label={getStatutoryFieldLabel(ClientId, "nhif")}>
                                  <Input
                                    placeholder={getStatutoryFieldLabel(ClientId, "nhif")}
                                    maxLength={20}
                                    onChange={onFinish}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Col xs={24} sm={24} md={12}>
                                <Form.Item
                                  name="helpmonthlybilling"
                                  label={getStatutoryFieldLabel(ClientId, "helpmonthlybilling")}
                                >
                                  <Input
                                    placeholder={getStatutoryFieldLabel(ClientId, "helpmonthlybilling")}
                                    maxLength={20}
                                    onChange={onFinish}
                                    onKeyDown={(e) => {
                                      const value =
                                        /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                                      if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            </>
                          )}

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              name="nationality"
                              label="Nationality"
                              rules={[
                                {
                                  required: false,
                                  message: "Nationality is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              >
                                {countryList?.map((country, index) => (
                                  <Select.Option
                                    key={index}
                                    value={country}
                                    label={country}
                                  >
                                    {country}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="workpermitno"
                              label="Work Permit No:"
                            >
                              <Input
                                placeholder="Work Permit No:"
                                type="text"
                                maxLength={10}
                                onKeyDown={(e) => {
                                  const value = /^[0-9]$/?.test(e.key);
                                  if (
                                    !value &&
                                    e.key !== "Backspace" &&
                                    /^[0-9]$/
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              label="Work permit expiry date"
                              name="workpermitexpirydate"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Work permit expiry date is required",
                                },
                              ]}
                            >
                              <DatePicker
                                className="w-100"
                                format="DD-MM-YYYY"
                                placeholder="Select Work permit expiry date"
                                onChange={onFinish}
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>
                        </StyleRow>
                        <b className="my-2 mx-1">Next Of Kin Details:</b>
                        <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="emergencycontactname"
                              label="Emergency Contact Name"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Emergency Contact Name is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Emergency Contact Name"
                                maxLength={30}
                                onKeyDown={(e) => {
                                  const allowedChars = /^[a-zA-Z\s]+$/;
                                  if (!allowedChars.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="emergencycontactnumber"
                              label="Emergency Contact Number"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Emergency Contact Name is required",
                                },
                              ]}
                            >
                              <PhoneInput
                                placeholder="Emergency Contact Number"
                                maxLength={20}
                                onKeyDown={(e) => {
                                  const value = /^[0-9+]$/?.test(e.key);
                                  if (
                                    !value &&
                                    e.key !== "Backspace" &&
                                    /^[0-9+]$/
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="nextofkinrelationship"
                              label="Relationship"
                              rules={[
                                {
                                  required: false,
                                  pattern: NON_EMPTY_REGEX,
                                  message: "Relationship is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Relationship"
                                maxLength={15}
                                onKeyDown={(e) => {
                                  const allowedChars = /^[a-zA-Z\s]+$/;
                                  if (!allowedChars.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              name="nextofkinpostaladdress"
                              label="Postal address"
                              rules={[
                                {
                                  required: false,
                                  message: "Postal address is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Postal address"
                                maxLength={60}
                                onKeyDown={(e) => {
                                  const value =
                                    /^[0-9,/]$/.test(e.key) ||
                                    /^[a-zA-Z\s,/]+$/.test(e.key);
                                  if (!value && e.key !== "Backspace") {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                        </StyleRow>
                        <div
                          className="mt-2 mx-1"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <b>Edit Appraisal Information:</b>
                          <span
                            className="text-primary"
                            style={{
                              borderRadius: "14px",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontWeight: 400,
                              fontSize: 15,
                              marginLeft: 12,
                            }}
                            onClick={handleHistoryClick}
                          >
                            History of Updates
                          </span>
                        </div>
                        <Table
                          className="mb-3"
                          dataSource={data}
                          columns={columns}
                          pagination={false}
                          footer={() => (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {totalWeightage > 100 && (
                                <div
                                  className="text-danger"
                                  style={{
                                    marginBottom: 8,
                                    marginTop: 0,
                                    color: "red",
                                    fontWeight: 400,
                                    background: "#fff0f0",
                                  }}
                                >
                                  The total weightage should not exceed 100%
                                </div>
                              )}
                              {totalWeightage < 100 && (
                                <div
                                  className="text-danger"
                                  style={{
                                    marginBottom: 8,
                                    marginTop: 0,
                                    color: "red",
                                    fontWeight: 500,
                                    border: "1px solid red",
                                    borderRadius: 4,
                                    padding: "4px 12px",
                                    background: "#fff0f0",
                                  }}
                                >
                                  The total weightage should not be less than 100%
                                </div>
                              )}
                              {zeroWeightageRoles?.length > 0 && (
                                <div
                                  className="text-danger"
                                  style={{
                                    marginBottom: 8,
                                    marginTop: 0,
                                    color: "red",
                                    fontWeight: 500,
                                    border: "1px solid red",
                                    borderRadius: 4,
                                    padding: "4px 12px",
                                    background: "#fff0f0",
                                  }}
                                >
                                  Weightage must be greater than 0 for:{" "}
                                  {zeroWeightageRoles
                                    .map((record) => record.roletype)
                                    .join(", ")}
                                </div>
                              )}
                            </div>
                          )}
                          rowKey="key"
                        />
                        {/* + Add Another button */}
                        {data.length < 4 && (
                          <span
                            className="bg-transparent border-0 text-start"
                            type="dashed"
                            block
                            onClick={requestAddRow}
                            style={{
                              cursor: appraisalInfoLoading ? "not-allowed" : "pointer",
                              display: "inline-block",
                              marginBottom: 16,
                              opacity: appraisalInfoLoading ? 0.4 : 1,
                            }}
                          >
                            +{" "}
                            <span style={{ textDecoration: "underline" }}>
                              Add Another
                            </span>
                          </span>
                        )}

                        <div className="text-end mt-3 mb-4">
                          <StyledButton
                            loading={showLoader}
                            type="primary"
                            htmlType="submit"
                          >
                            {showLoader ? "Update" : "Update"}
                          </StyledButton>
                        </div>
                      </Form>
                    </>
                  )}
                  {/* {activeTab === "1" && (
                    <>
                      <div className="styled-card mb-5">
                        {roleList.length === 0 && (
                          <StyledButton
                            className="mt-2"
                          >
                            Add Role
                          </StyledButton>
                        )}
                        {roleList?.length > 0 && (
                          <Checkbox
                            className="mt-3"
                            checked={selectAllRoleChecked}
                            onChange={handleSelectAllRole}
                          >
                            Select All
                          </Checkbox>
                        )}
                        <SelectTable

                          columns={rolecolumns}
                          tabledata={roleList}
                          handleClickRole={handlesubmit}
                          handleReset={handleResetAllRole}
                          selectedRoleId={selectedRoleId}
                          showLoader={showLoader}
                        />

                      </div>
                    </>
                  )}

                  {activeTab === "2" && (
                    <>
                      <div className="styled-card mb-5">
                        <SelectTable

                          columns={baseLocationColumn}
                          tabledata={locationBasedOnRole}
                          editRole="edit"
                          handleClickRole={handlesubmit}
                          selectedBaseLocation={baseLocation}
                          showLoader={showLoader}
                        />
                      </div>
                    </>
                  )} */}
                </TabPane>
              ))}
            </Tabs>
          </>
        )}
        {updateState === "educationdetails" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {pageName} /{" "}
            </button>
            <b>Edit Education Details:</b>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              onFinish={(values) => {
                handlesubmit();
              }}
              autoComplete="off"
              initialValues={{
                educationdetails: [],
              }}
              labelCol={{ xs: 24, sm: 24, md: 24 }}
              style={{ textAlign: "left" }}
            >
              <Form.List name="educationdetails">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => {
                      const fromDate = formValues.educationdetails[key]?.fromdate;
                      const toDate = formValues.educationdetails[key]?.todate;

                      return (
                        <StyleRow gutter={16} className="mt-2">
                          <Col xs={24} sm={24} md={24}>
                            <Form.Item
                              {...restField}
                              label="Institute Name"
                              name={[name, "institutename"]}
                              rules={[
                                {
                                  required: false,
                                  message: "Institute Name required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Institute Name"
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              // {...restField}
                              label="From:"
                            // name={[name, "fromdate"]}
                            // rules={[
                            //   { required: false, message: "Date required" },
                            // ]}
                            >
                              <DatePicker
                                className="w-100"
                                format="DD-MM-YYYY"
                                placeholder="From"
                                getPopupContainer={() => containerRef.current}
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    date,
                                    dateString,
                                    key,
                                    "fromdate"
                                  )
                                }
                                value={
                                  fromDate
                                    ? moment(fromDate, "YYYY-MM-DD").isValid()
                                      ? moment(fromDate, "YYYY-MM-DD")
                                      : null
                                    : null
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12} ref={containerRef}>
                            <Form.Item
                              // {...restField}
                              label="To:"
                            // name={[name, "todate"]}
                            // rules={[
                            //   { required: false, message: "Date required" },
                            // ]}
                            >
                              <DatePicker
                                className="w-100"
                                format="DD-MM-YYYY"
                                placeholder="To"
                                getPopupContainer={() => containerRef.current}
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    date,
                                    dateString,
                                    key,
                                    "todate"
                                  )
                                }
                                value={
                                  toDate
                                    ? moment(toDate, "YYYY-MM-DD").isValid()
                                      ? moment(toDate, "YYYY-MM-DD")
                                      : null
                                    : null
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              {...restField}
                              label="Exam Body:"
                              name={[name, "exambody"]}
                              rules={[
                                {
                                  required: false,
                                  message: "Exam Body required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Exam Body"
                                onChange={onFinish}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={12}>
                            <Form.Item
                              {...restField}
                              label="Awarded:"
                              name={[name, "awarded"]}
                              rules={[
                                { required: false, message: "Awarded required" },
                              ]}
                            >
                              {/* <Input placeholder="Awarded" onChange={onFinish}/> */}
                              <Select
                                placeholder="Select"
                                getPopupContainer={() => containerRef.current}
                                onChange={onFinish}
                              >
                                <Option value="Doctorate">Doctorate</Option>
                                <Option value="Master">Master</Option>
                                <Option value="Bachelor">Bachelor</Option>
                                <Option value="Diploma">Diploma</Option>
                                <Option value="Certificate">Certificate</Option>
                                {ClientId !== MAIN_CLIENT_ID && (
                                  <Option value="High School">High School</Option>
                                )}
                              </Select>
                            </Form.Item>
                            {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                          </Col>
                          <Col xs={24} sm={24} md={24}>
                            <Form.Item
                              {...restField}
                              label="Attachment"
                              name={[name, "attachment"]}
                              valuePropName="fileList"
                              rules={[
                                {
                                  required: false,
                                  message: "file is required",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                if (Array.isArray(e)) {
                                  return e;
                                }
                                return e && e.fileList;
                              }}
                            >
                              <Upload
                                accept=".doc,.docx,.pdf,.ppt,.pptx"
                                beforeUpload={(file) => {
                                  const allowedTypes = [
                                    "application/pdf",
                                    "application/msword",
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                    "application/vnd.ms-powerpoint",
                                    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                                  ];

                                  if (!allowedTypes.includes(file.type)) {
                                    message.error("Only DOC, PDF, and PPT files are allowed");
                                    return Upload.LIST_IGNORE;
                                  }

                                  return true;
                                }}
                                customRequest={({ file, onSuccess }) => {
                                  const reader = new FileReader();
                                  reader.readAsDataURL(file);

                                  reader.onload = () => {
                                    const base64Data = reader.result.split(",")[1];
                                    const uniqueId = generateUniqueId();
                                    onSuccess({ file, base64Data, uniqueId });
                                  };

                                  reader.onerror = (error) => {
                                    console.error("File read error:", error);
                                  };
                                }}
                                name="logo"
                                onChange={(value) => {
                                  onFinish();
                                  uploadFile(value);
                                }}
                                listType="picture"
                                style={{ width: "100%" }}
                              >
                                <div style={{ width: "100%" }}>
                                  <Button className="w-100 text-start" size="large">
                                    Upload File
                                  </Button>
                                </div>
                              </Upload>

                            </Form.Item>
                          </Col>
                        </StyleRow>
                      );
                    })}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                        style={cursorstyle}
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}
        {updateState === "practicaltrainings" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {pageName} /{" "}
            </button>
            <b>Edit Practical Training:</b>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              onFinish={(values) => {
                handlesubmit();
              }}
              autoComplete="off"
              initialValues={{
                practicaltrainings: [],
              }}
              labelCol={{ xs: 24, sm: 24, md: 24 }}
              style={{ textAlign: "left" }}
            >
              <Form.List name="practicaltrainings">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2">
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Organisation Name"
                            name={[name, "organisationname"]}
                            rules={[
                              {
                                required: false,
                                message: "Organisation Name required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Organisation Name"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Position Held"
                            name={[name, "positionheld"]}
                            rules={[
                              {
                                required: false,
                                message: "Position Held required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Position Held"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Nature of work & Tasks performed or completed"
                            name={[name, "tasksperformed"]}
                            rules={[
                              {
                                required: false,
                                message:
                                  "Nature of work & Tasks performed or completed required",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="Nature of work & Tasks performed or completed"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                        style={cursorstyle}
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}
        {updateState === "workexperience" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {pageName} /{" "}
            </button>
            <b>Edit Work Experience:</b>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              onFinish={(values) => {
                handlesubmit();
              }}
              autoComplete="off"
              initialValues={{
                workexperience: [],
              }}
              labelCol={{ xs: 24, sm: 24, md: 24 }}
              style={{ textAlign: "left" }}
            >
              <Form.List name="workexperience">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2">
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Company name"
                            name={[name, "companyname"]}
                            rules={[
                              {
                                required: false,
                                message: "Company name required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Company name"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12}>
                          <Form.Item
                            {...restField}
                            label="Job Title"
                            name={[name, "jobtitle"]}
                            rules={[
                              { required: false, message: "Job Title required" },
                            ]}
                          >
                            <Input
                              placeholder="Job Title"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[
                              { required: false, message: "Date required" },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Relevant"
                            name={[name, "relevant"]}
                            rules={[
                              { required: false, message: "Relevnt required" },
                            ]}
                          >
                            <Select
                              placeholder="Select"
                              getPopupContainer={() => containerRef.current}
                              onChange={onFinish}
                            >
                              <Option value="yes">Yes</Option>
                              <Option value="no">No</Option>
                            </Select>
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Job Description"
                            name={[name, "jobdescription"]}
                            rules={[
                              {
                                required: false,
                                message: "Job Description required",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="Job Description"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                          {/* <MinusCircleOutlined onClick={() => remove(name)} /> */}
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                        style={cursorstyle}
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}
        {updateState === "professionalcertifications" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {pageName} /{" "}
            </button>
            <b>Edit Professional Certification:</b>
            <Form
              form={form}
              name="dynamic_form_nest_item"
              onFinish={(values) => {
                handlesubmit();
              }}
              autoComplete="off"
              initialValues={{
                professionalcertifications: [],
              }}
              labelCol={{ xs: 24, sm: 24, md: 24 }}
              style={{ textAlign: "left" }}
            >
              <Form.List name="professionalcertifications">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <StyleRow gutter={16} className="mt-2">
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Certification Type"
                            name={[name, "certificationtype"]}
                            rules={[
                              {
                                required: true,
                                message: "Certification Type required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              placeholder="Select"
                              optionFilterProp="children"
                              getPopupContainer={() => containerRef.current}
                              defaultValue={AwardList[0]}
                              onChange={onCertificationTypeChange}
                            >
                              {[
                                ...(AwardList || []).filter((item) =>
                                  ClientId === MAIN_CLIENT_ID ||
                                  !AwardListCountryNames.some((country) => item.includes(country))
                                ),
                                ...(ClientId !== MAIN_CLIENT_ID ? AdditionalCertificationTypeList : [])
                              ].map((value, index) => (
                                <Select.Option
                                  key={index}
                                  value={value}
                                  label={value}
                                >
                                  {value}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        {showOtherCertification && (
                          <Col xs={24} sm={24} md={24}>
                            <Form.Item
                              {...restField}
                              label="Other Certification Name"
                              name={[name, "certificationname"]}
                              rules={[
                                {
                                  required: false,
                                  message:
                                    "Please enter Other Certification Name",
                                },
                              ]}
                            >
                              <Input placeholder="Enter Other Certification Name" />
                            </Form.Item>
                          </Col>
                        )}
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="From:"
                            name={[name, "fromdate"]}
                            rules={[{ required: true, message: "Date required" }]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder="From"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} ref={containerRef}>
                          <Form.Item
                            {...restField}
                            label="To:"
                            name={[name, "todate"]}
                            rules={[{ required: true, message: "Date required" }]}
                          >
                            <DatePicker
                              className="w-100"
                              format="DD-MM-YYYY"
                              onChange={() => {
                                onFinish();
                              }}
                              placeholder="To"
                              getPopupContainer={() => containerRef.current}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Remarks"
                            name={[name, "remarks"]}
                            rules={[
                              { required: true, message: "Remarks required" },
                            ]}
                          >
                            <Input
                              placeholder="Remarks"
                              onChange={() => {
                                onFinish();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            {...restField}
                            label="Attachment"
                            name={[name, "attachment"]}
                            valuePropName="fileList"
                            rules={[
                              {
                                required: true,
                                message: "file is required",
                              },
                            ]}
                            getValueFromEvent={(e) => {
                              if (Array.isArray(e)) {
                                return e;
                              }
                              return e && e.fileList;
                            }}
                          >
                            <Upload
                              customRequest={({ file, onSuccess }) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);

                                reader.onload = () => {
                                  const base64Data = reader.result.split(",")[1];
                                  const uniqueId = generateUniqueId();
                                  onSuccess({ file, base64Data, uniqueId });
                                };

                                reader.onerror = (error) => {
                                  console.error("File read error:", error);
                                };
                              }}
                              name="logo"
                              // action="/upload.do"
                              onChange={(value) => {
                                onFinish();
                                uploadFile(value);
                              }}
                              listType="picture"
                              style={{ width: "100%" }}
                            >
                              <div style={{ width: "100%" }}>
                                <Button className="w-100 text-start" size="large">
                                  Upload File
                                </Button>
                              </div>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </StyleRow>
                    ))}
                    <Form.Item>
                      <u
                        className="bg-transparent border-0 text-start"
                        type="dashed"
                        onClick={() => add()}
                        block
                        style={cursorstyle}
                      >
                        +Add Another
                      </u>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <div className="text-end">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}

        {updateState === "bankInfo" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {" "}
              {pageName} /
            </button>{" "}
            <b>Edit Bank Information:</b>
            <Form
              className=""
              form={form}
              name="addemployeeform"
              layout="vertical"
              initialValues={{
                accountname: "",
                accountno: "",
                bankname: "",
                bankbranch: "",
                bankcountry: "",
                bankcode: "",
                bankbranchcode: "",
                bankswiftcode: "",
                nssf: "",
                krapin: "",
                housingfundno: "",
                nhif: "",
                helpmonthlybilling: "",
              }}
              onFinish={(values) => {
                handlesubmit();
              }}
            >
              <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="accountname"
                    label="Account Name"
                    rules={[
                      {
                        required: false,
                        message: "Account Name is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Account Name"
                      // maxLength={500}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="accountno"
                    label="Account Number"
                    rules={[
                      {
                        required: false,
                        message: "Account Number is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Account Number"
                      maxLength={25}
                      onChange={onFinish}
                    // onKeyDown={(e) => {
                    //   const allowedChars = /^[a-zA-Z\s]+$/;
                    //   if (!allowedChars.test(e.key)) {
                    //     e.preventDefault();
                    //   }
                    // }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="bankname"
                    label="Bank Name"
                    rules={[
                      {
                        required: false,
                        message: "Bank Name is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Bank Name"
                      onChange={onFinish}
                      // maxLength={500}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="bankbranch"
                    label="Branch"
                    rules={[
                      {
                        required: false,
                        message: "Branch is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Branch"
                      onChange={onFinish}
                      // maxLength={500}
                      onKeyDown={(e) => {
                        const allowedChars = /^[a-zA-Z\s]+$/;
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} ref={containerRef}>
                  <Form.Item
                    name="bankcountry"
                    label="Country"
                    rules={[{ required: false, message: "Country is required" }]}
                  >
                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      getPopupContainer={() => containerRef.current}
                      onChange={onFinish}
                    >
                      {countryList?.map((country, index) => (
                        <Select.Option
                          key={index}
                          value={country}
                          label={country}
                        >
                          {country}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="bankcode"
                    label="Bank code"
                    rules={[
                      {
                        required: false,
                        message: "Bank code is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Bank code"
                      maxLength={25}
                      onChange={onFinish}
                    // onKeyDown={(e) => {
                    //   const allowedChars = /^[a-zA-Z\s]+$/;
                    //   if (!allowedChars.test(e.key)) {
                    //     e.preventDefault();
                    //   }
                    // }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="bankbranchcode"
                    label="Branch Code"
                    rules={[
                      {
                        required: false,
                        message: "Branch Code is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Branch Code"
                      maxLength={25}
                      onChange={onFinish}
                    // onKeyDown={(e) => {
                    //   const allowedChars = /^[a-zA-Z\s]+$/;
                    //   if (!allowedChars.test(e.key)) {
                    //     e.preventDefault();
                    //   }
                    // }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="bankswiftcode"
                    label="Swiftcode"
                    rules={[
                      {
                        required: false,
                        message: "Swiftcode is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Swiftcode"
                      maxLength={25}
                      onChange={onFinish}
                    // onKeyDown={(e) => {
                    //   const allowedChars = /^[a-zA-Z\s]+$/;
                    //   if (!allowedChars.test(e.key)) {
                    //     e.preventDefault();
                    //   }
                    // }}
                    />
                  </Form.Item>
                </Col>
              </StyleRow>

              {ClientId !== MAIN_CLIENT_ID && (
                <>
                  <b className="my-2 mx-1">Banking Information</b>
                  <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="krapin" label={getStatutoryFieldLabel(ClientId, "krapin")}>
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "krapin")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                          onChange={onFinish}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="housingfundno"
                        label={getStatutoryFieldLabel(ClientId, "housingfundno")}
                      >
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "housingfundno")}
                          maxLength={20}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                          onChange={onFinish}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="nssf" label={getStatutoryFieldLabel(ClientId, "nssf")}>
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "nssf")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item name="nhif" label={getStatutoryFieldLabel(ClientId, "nhif")}>
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "nhif")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="helpmonthlybilling"
                        label={getStatutoryFieldLabel(ClientId, "helpmonthlybilling")}
                      >
                        <Input
                          placeholder={getStatutoryFieldLabel(ClientId, "helpmonthlybilling")}
                          maxLength={20}
                          onChange={onFinish}
                          onKeyDown={(e) => {
                            const value =
                              /^[0-9]$/?.test(e.key) || /^[a-zA-Z\s]+$/?.test(e.key);
                            if (!value && e.key !== "Backspace" && /^[0-9]$/) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </StyleRow>
                </>
              )}
              <div className="text-end">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}

        {updateState === "salaryInfo" && (
          <>
            <button
              className="bg-transparent border-0"
              onClick={() => setUpdateState("")}
            >
              {" "}
              {pageName} /
            </button>{" "}
            <b>Edit Salary Information:</b>
            <Form
              className=""
              form={form}
              name="addemployeeform"
              layout="vertical"
              initialValues={{
                grossSalary: "",
                housingAllowance: "",
                medicalInsurance: "",
                pension: "",
                groupLifeInsurance: "",
                socialSecurityContribution: "",
                bonus: "",
                otherCosts: "",
                TotalEmploymentCost: "",
              }}
              onFinish={(values) => {
                handlesubmit();
              }}
            >
              <StyleRow className="m-1 mt-2 mb-3" gutter={20}>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="grossSalary"
                    label="Gross Salary"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Gross Salary is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Gross Salary"
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                      onChange={onFinish}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="housingAllowance"
                    label="Housing Allowance"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Housing Allowance is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Housing Allowance"
                      maxLength={10}
                      onChange={onFinish}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="medicalInsurance"
                    label="Medical Insurance"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Medical Insurance is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Medical Insurance"
                      onChange={onFinish}
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="pension"
                    label="Pension"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Pension is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Pension"
                      onChange={onFinish}
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="groupLifeInsurance"
                    label="Group Life Insurance"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Group Life Insurance is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Group Life Insurance"
                      maxLength={10}
                      onChange={onFinish}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="socialSecurityContribution"
                    label="Social Security contribution (employer)"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Social Security contribution is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Social Security contribution"
                      maxLength={10}
                      onChange={onFinish}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="bonus"
                    label="Bonus"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Bonus is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Bonus"
                      maxLength={10}
                      onChange={onFinish}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="otherCosts"
                    label="Other Costs"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Other Costs is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Other Costs"
                      maxLength={10}
                      onChange={onFinish}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="totalEmploymentCost"
                    label="Total Employment cost"
                    normalize={(value) => formatNumber(parseNumber(value))}
                    rules={[
                      {
                        required: false,
                        message: "Total Employment cost is required",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Total Employment cost"
                      maxLength={15}
                      onChange={onFinish}
                      disabled
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                </Col>
              </StyleRow>
              <div className="text-end">
                <StyledButton
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {showLoader ? "Update" : "Update"}
                </StyledButton>
              </div>
            </Form>
          </>
        )}

        {isModalVisible && !isHistory && (
          <Modal
            title="Adding Job Description"
            width={650}
            open={isModalVisible}
            onCancel={() => {
              form.setFieldValue("file", []);
              setOtherFileList([]);
              setIsModalVisible(false);
            }}
            modalRender={(modal) => (
              <div style={{ borderRadius: 8 }}>{modal}</div>
            )}
            afterClose={() => {
              form.resetFields();
              setOtherFileList([]); // Clears Upload component
              setSelectedOption(null); // Clears radio
              form.setFieldValue("file", []); // Clears internal Form field
            }}
            footer={[
              <Button
                key="cancel"
                style={{
                  width: 130,
                  height: 34,
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                onClick={() => {
                  form.setFieldValue("file", []);
                  setOtherFileList([]);
                  setIsModalVisible(false);
                }}
              >
                Cancel
              </Button>,
              <Button
                key="add"
                type="primary"
                onClick={handleFinish}
                style={{
                  width: 130,
                  height: 34,
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                disabled={
                  (selectedOption === null && otherFileList.length === 0) ||
                  viewLoading
                }
              >
                Add
              </Button>,
            ]}
          >
            {modalLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 120,
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <Form form={form} layout="vertical">
                <Row gutter={20}>
                  <Col span={24}>
                    {filteredJobDescriptions.length === 0 ? (
                      <p>No job descriptions found for this grade.</p>
                    ) : (
                      <Form.Item name="jobDescription">
                        <div
                          style={{
                            padding: "16px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            maxHeight: "200px",
                            overflowY: "auto",
                          }}
                        >
                          <Radio.Group
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                            }}
                            value={selectedOption}
                            onChange={(e) => {
                              const selected = e.target.value;
                              setSelectedOption(selected);
                              form.setFieldsValue({ jobDescription: selected });

                              if (form.getFieldValue("file")?.length > 0) {
                                form.setFieldsValue({ file: undefined });
                                setOtherFileList([]);
                                message.info(
                                  "You can only select one file. Upload cleared."
                                );
                              }
                            }}
                            disabled={!!form.getFieldValue("file")?.length}
                          >
                            {filteredJobDescriptions.map((desc) => (
                              <Radio
                                key={desc.jobDescriptionId}
                                value={desc.jobDescriptionId}
                                onClick={() => {
                                  if (selectedOption === desc.jobDescriptionId) {
                                    setSelectedOption(null);
                                    form.setFieldsValue({
                                      jobDescription: undefined,
                                    });
                                  }
                                }}
                              >
                                {desc.fileName}
                              </Radio>
                            ))}
                          </Radio.Group>
                        </div>
                      </Form.Item>
                    )}
                  </Col>

                  {currentRoleRecord?.roletype !== "Primary" && (
                    <>
                      <Col span={24}>
                        <Divider plain>or</Divider>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="file"
                          valuePropName="fileList"
                          getValueFromEvent={normFile}
                          help={
                            selectedOption &&
                              form.getFieldValue("file")?.length > 0
                              ? "You can only select one file. Please remove the uploaded file or deselect the radio option."
                              : ""
                          }
                          validateStatus={
                            selectedOption &&
                              form.getFieldValue("file")?.length > 0
                              ? "error"
                              : ""
                          }
                        >
                          <Upload
                            name="file"
                            listType="text"
                            maxCount={1}
                            accept=".pdf,.doc,.docx"
                            action=""
                            fileList={otherFileList}
                            beforeUpload={(file) => {
                              if (selectedOption) {
                                message.error(
                                  "Please clear your radio selection before uploading a file."
                                );
                                return Upload.LIST_IGNORE;
                              }
                              return true;
                            }}
                            customRequest={handleUpload}
                            onChange={async ({ fileList, file }) => {
                              setViewLoading(true);
                              if (!selectedOption) {
                                const newFileList = fileList.map((f) => ({
                                  ...f,
                                  status: "done", // Set status manually to avoid red color
                                }));
                                setOtherFileList(newFileList);

                                if (newFileList.length > 0) {
                                  const uploadFile = newFileList[0].originFileObj;
                                  const reader = new FileReader();
                                  reader.onload = async (e) => {
                                    const base64 = e.target.result;
                                    await handlePostCategoryDoc(
                                      currentRoleRecord,
                                      uploadFile,
                                      base64,
                                      uploadFile.type
                                    );
                                  };
                                  reader.readAsDataURL(uploadFile);

                                  setSelectedOption(null);
                                  form.setFieldsValue({
                                    jobDescription:
                                      form.getFieldValue("jobDescription") || "",
                                  });
                                }
                              }
                            }}
                            onRemove={() => {
                              setOtherFileList([]);
                            }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              style={{
                                backgroundColor: "#E2E2E8",
                                border: "none",
                                height: "35px",
                                fontWeight: "500",
                                width: "100%",
                              }}
                              disabled={!!selectedOption}
                              loading={viewLoading}
                            >
                              Upload Other File
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </Form>
            )}
          </Modal>
        )}

        {isCustomJdModalVisible && (
          <Modal
            title="Add Job Description"
            open={isCustomJdModalVisible}
            onCancel={() => {
              setIsCustomJdModalVisible(false);
              customJdForm.resetFields();
              setCustomJdFileList([]);
            }}
            footer={[
              <Button
                key="cancel"
                onClick={() => {
                  setIsCustomJdModalVisible(false);
                  customJdForm.resetFields();
                  setCustomJdFileList([]);
                }}
              >
                Cancel
              </Button>,
              <Button
                key="save"
                type="primary"
                loading={customJdSaving}
                onClick={handleSaveCustomJobDescription}
              >
                Save
              </Button>,
            ]}
          >
            <Form form={customJdForm} layout="vertical">
              <Row gutter={20}>
                <Col span={12}>
                  <Form.Item
                    label="File ID"
                    name="fileid"
                    rules={[{ required: true, message: "Please enter File ID" }]}
                  >
                    <Input placeholder="Enter File ID" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="File Name" required>
                    <FullWidthUpload>
                      <Upload
                        fileList={customJdFileList}
                        maxCount={1}
                        accept=".pdf,.doc,.docx"
                        beforeUpload={(file) => {
                          const isLt10M = file.size / 1024 / 1024 < 10;
                          if (!isLt10M) {
                            message.error("Upload only files up to 10MB");
                            return Upload.LIST_IGNORE;
                          }
                          return false;
                        }}
                        onChange={({ fileList }) =>
                          setCustomJdFileList(fileList.slice(-1))
                        }
                        onRemove={() => setCustomJdFileList([])}
                      >
                        <Button
                          type="primary"
                          icon={<UploadOutlined />}
                          style={{ width: "100%" }}
                        >
                          Upload File
                        </Button>
                      </Upload>
                    </FullWidthUpload>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        )}

        {showConfirmModal && (
          <Modal
            open={showConfirmModal}
            footer={null}
            closable={false}
            centered
            width={198}
            className="small-close-modal"
            bodyStyle={{
              textAlign: "center",
              padding: 10,
              borderRadius: 8,
              height: 100,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            modalRender={(modal) => (
              <div style={{ borderRadius: 8, overflow: "auto" }}>{modal}</div>
            )}
            onCancel={() => setShowConfirmModal(false)}
          >
            <img
              src={Confirm}
              alt="Confirmed"
              style={{ width: 36, height: 36, marginBottom: 8 }}
            />
            <div
              style={{
                fontWeight: 600,
                fontSize: 18,
                marginBottom: 4,
                marginTop: 4,
              }}
            >
              Added
            </div>
          </Modal>
        )}

        {contractDeleteModal.visible && (
          <Modal
            open={contractDeleteModal.visible}
            footer={null}
            closable={false}
            centered
            width={420}
            onCancel={() => setContractDeleteModal({ visible: false, key: null })}
          >
            <div style={{ textAlign: "center", padding: "8px 4px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: 40,
                  color: "#fff",
                  background: "#e63946",
                  borderRadius: "50%",
                  padding: 8,
                }}
              />
              <p style={{ marginTop: 20, fontSize: 15, color: "#333" }}>
                An active performance contract exists for this role. Deleting
                this role will also permanently delete the associated
                contract. Are you sure you want to proceed?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}
              >
                <Button
                  onClick={() =>
                    setContractDeleteModal({ visible: false, key: null })
                  }
                  style={{ minWidth: 110 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleDeleteRow(contractDeleteModal.key, true);
                    setContractDeleteModal({ visible: false, key: null });
                  }}
                  style={{
                    minWidth: 130,
                    background: "#8FE3C5",
                    borderColor: "#8FE3C5",
                    color: "#0B3B2E",
                  }}
                >
                  Delete Anyway
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {lastActiveRoleDeleteModal.visible && (
          <Modal
            open={lastActiveRoleDeleteModal.visible}
            footer={null}
            closable={false}
            centered
            width={420}
            onCancel={() => setLastActiveRoleDeleteModal({ visible: false, key: null })}
          >
            <div style={{ textAlign: "center", padding: "8px 4px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: 40,
                  color: "#fff",
                  background: "#e63946",
                  borderRadius: "50%",
                  padding: 8,
                }}
              />
              <p style={{ marginTop: 20, fontSize: 15, color: "#333" }}>
                An active performance contract exists for this role. Deleting
                the role will permanently delete the associated contract.
                Since all other appraisal roles for this employee have been
                closed, deleting this final active role will also close the
                current appraisal cycle. Are you sure you want to proceed?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}
              >
                <Button
                  onClick={() =>
                    setLastActiveRoleDeleteModal({ visible: false, key: null })
                  }
                  style={{ minWidth: 110 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleDeleteRow(lastActiveRoleDeleteModal.key, true);
                    setLastActiveRoleDeleteModal({ visible: false, key: null });
                  }}
                  style={{
                    minWidth: 130,
                    background: "#8FE3C5",
                    borderColor: "#8FE3C5",
                    color: "#0B3B2E",
                  }}
                >
                  Delete Anyway
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {lastPendingRoleDeleteModal.visible && (
          <Modal
            open={lastPendingRoleDeleteModal.visible}
            footer={null}
            closable={false}
            centered
            width={420}
            onCancel={() => setLastPendingRoleDeleteModal({ visible: false, key: null })}
          >
            <div style={{ textAlign: "center", padding: "8px 4px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: 40,
                  color: "#fff",
                  background: "#e63946",
                  borderRadius: "50%",
                  padding: 8,
                }}
              />
              <p style={{ marginTop: 20, fontSize: 15, color: "#333" }}>
                No performance contract has been created for this role.
                However, all other appraisal roles for this employee have
                been closed. Deleting this final pending role will also
                close the current appraisal cycle. Are you sure you want to
                proceed?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}
              >
                <Button
                  onClick={() =>
                    setLastPendingRoleDeleteModal({ visible: false, key: null })
                  }
                  style={{ minWidth: 110 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    handleDeleteRow(lastPendingRoleDeleteModal.key, false);
                    setLastPendingRoleDeleteModal({ visible: false, key: null });
                  }}
                  style={{
                    minWidth: 130,
                    background: "#8FE3C5",
                    borderColor: "#8FE3C5",
                    color: "#0B3B2E",
                  }}
                >
                  Delete Anyway
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {appraisalNoModal.visible && (
          <Modal
            open={appraisalNoModal.visible}
            footer={null}
            closable={false}
            centered
            width={420}
            onCancel={() =>
              setAppraisalNoModal({ visible: false, record: null, value: null, option: null })
            }
          >
            <div style={{ textAlign: "center", padding: "8px 4px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: 40,
                  color: "#fff",
                  background: "#e63946",
                  borderRadius: "50%",
                  padding: 8,
                }}
              />
              <p style={{ marginTop: 20, fontSize: 15, color: "#333" }}>
                This role has an active performance contract. If you change
                the Appraisal status to "No", the associated contract will be
                permanently deleted. Are you sure you want to continue?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}
              >
                <Button
                  onClick={() =>
                    setAppraisalNoModal({ visible: false, record: null, value: null, option: null })
                  }
                  style={{ minWidth: 110 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={confirmAppraisalNo}
                  style={{
                    minWidth: 130,
                    background: "#8FE3C5",
                    borderColor: "#8FE3C5",
                    color: "#0B3B2E",
                  }}
                >
                  Proceed & Save
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {changeAppraiserModal.visible && (
          <Modal
            open={changeAppraiserModal.visible}
            footer={null}
            closable={false}
            centered
            width={420}
            onCancel={() =>
              setChangeAppraiserModal({ visible: false, record: null, value: null, option: null })
            }
          >
            <div style={{ textAlign: "center", padding: "8px 4px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: 40,
                  color: "#fff",
                  background: "#e63946",
                  borderRadius: "50%",
                  padding: 8,
                }}
              />
              <p style={{ marginTop: 20, fontSize: 15, color: "#333" }}>
                An active contract exists for this role. Changing the
                appraiser will transfer the open contract to the new
                appraiser. Are you sure you want to change?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}
              >
                <Button
                  onClick={() =>
                    setChangeAppraiserModal({ visible: false, record: null, value: null, option: null })
                  }
                  style={{ minWidth: 110 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={confirmChangeAppraiser}
                  style={{
                    minWidth: 130,
                    background: "#8FE3C5",
                    borderColor: "#8FE3C5",
                    color: "#0B3B2E",
                  }}
                >
                  Proceed & Save
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {addRoleModal.visible && (
          <Modal
            open={addRoleModal.visible}
            footer={null}
            closable={false}
            centered
            width={420}
            onCancel={() => setAddRoleModal({ visible: false })}
          >
            <div style={{ textAlign: "center", padding: "8px 4px" }}>
              <ExclamationCircleFilled
                style={{
                  fontSize: 40,
                  color: "#fff",
                  background: "#e63946",
                  borderRadius: "50%",
                  padding: 8,
                }}
              />
              <p style={{ marginTop: 20, fontSize: 15, color: "#333" }}>
                There are active performance contracts for this period. If
                you add another role, it will be included in the current
                appraisal period. Are you sure you want to add another role?
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}
              >
                <Button
                  onClick={() => setAddRoleModal({ visible: false })}
                  style={{ minWidth: 110 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    addNewRow();
                    setAddRoleModal({ visible: false });
                  }}
                  style={{
                    minWidth: 130,
                    background: "#8FE3C5",
                    borderColor: "#8FE3C5",
                    color: "#0B3B2E",
                  }}
                >
                  Add Anyway
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {isModalVisible && isHistory && (
          <Modal
            title="History of Updates"
            width={950}
            style={{ borderRadius: 14 }}
            open={isModalVisible}
            onCancel={onCancel}
            footer=""
            modalRender={(modal) => (
              <div style={{ borderRadius: 14, overflow: "auto" }}>{modal}</div>
            )}
          >
            {historyLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 120,
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <>
                <div style={{ marginBottom: 16 }}>
                  <RangePicker
                    allowClear
                    onChange={(dates) => setHistoryDateRange(dates)}
                    style={{ width: 320 }}
                  />
                </div>
                <div style={{ maxHeight: 400, overflowY: "auto" }}>
                  <Table
                    columns={historyColumns}
                    dataSource={filteredHistoryData}
                    pagination={false}
                  />
                </div>
              </>
            )}
          </Modal>
        )}
        <Modal
          open={isPdfModalVisible}
          title={
            <div className="d-flex justify-content-between">
              <div>
                <h6 style={{ marginBottom: 0 }}>Job Description Preview</h6>
                {currentRoleRecord?.jobdescriptionFileId && (
                  <div style={{ fontSize: 13, fontWeight: 400 }}>
                    File ID: {currentRoleRecord.jobdescriptionFileId}
                  </div>
                )}
              </div>
              <div
                className="mx-4"
                style={{ cursor: "pointer" }}
                onClick={handleDeleteClick}
              >
                <TrashDelete className="table_action_icon" /> Delete
              </div>
            </div>
          }
          footer={null}
          onCancel={() => setIsPdfModalVisible(false)}
          width={800}
          bodyStyle={{ height: "80vh", padding: 0 }}
        >
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              width="100%"
              height="100%"
              style={{ border: "none" }}
              title="PDF Preview"
            />
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spin size="large" />
            </div>
          )}
        </Modal>
        {/* <button onClick={() => setUpdateState("")}>back</button> */}
      </Spin>
    </EditProfileBox>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  roleList: getRoleList(state),
  ClientId: getClientid(state),
  bandList: getBandList(state),
  locationList: getLocations(state),
  supervisorList: getSupervisorList(state),
});

export default connect(mapStateToProps, mapDispatchToProps, null)(EditProfile);
